import {
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instanceat14thlj150z as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toString14fd7g605f91p as toString_0,
  Char__hashCode_impl_otmys1ewos5t0dm35g as Char__hashCode_impl_otmys,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  joinToString1cxrrlmo0chqs as joinToString,
  booleanArray2jdug9b51huk7 as booleanArray,
  StringBuildermazzzhj6kkai as StringBuilder,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_0,
  toLongw1zpgk99d84b as toLong,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong1a4cndvg6c52s as numberToLong,
  println2shhhgwwt4c61 as println,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  mapOf1xd03cq9cnmy8 as mapOf,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instance3jf2rsvdhmxzn as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp2zkq9ykxbil7d as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  getKClass1s3j9wy1cofik as getKClass,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  KProperty02ce7r476m8633 as KProperty0,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstance8lqb2pbph5yn as Console_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_1,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstance2cg04z8rod8ga as Level_WARN_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance2r8kc48nhvjcq as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstance39o54489czp6d as Companion_getInstance_2,
  Os_UNKNOWN_getInstancecnx3cm3i6e2g as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_3,
  DenoPointerpb0vypijx63v as DenoPointer,
  get_pointerlkbwhoqlhapz as get_pointer,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_4,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_6,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_7,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_2,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance293l0r179rei7 as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration__hashCode_impl_y13la6nym0c1xbwjaa as FastDuration__hashCode_impl_y13la6,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  FastDuration__minus_impl_evs237bt7zqxxnwet as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  minus2npwq73u0d9yx as minus,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab30y5opwsu5po5 as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  clonelcrqoxe4ne5i as clone,
  Companion_instancejzamqjlqqs4y as Companion_instance_4,
  _Int8Buffer___init__impl__e20lvcp4p2uvfo996c as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulbq12sgwh1jcvh as _Int8Buffer___get_buffer__impl__q0gulb,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  Companion_getInstance35xii7iw9kdg2 as Companion_getInstance_9,
  ByteUnits__toString_impl_ox2ku22zb4xrvk9phl9 as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  arrayequal25g4om83vd8w1 as arrayequal,
  copyOfnqvdm0sc8lk as copyOf,
  setArrayLEwil75hzlfusu as setArrayLE,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliu1ltqm2yo4vfb6 as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu2fcy7ilfo0o6g as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34sznedf8x821xo8e0 as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  insert42sy0xc4ax89g9 as insert4,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  insert8f3zk23r8x9da as insert8,
  insert32d422lnha9g5r as insert3,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  min1z074tc6jeruz as min,
  max1izmzj76cv5b4 as max_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate2g7wzskc23f1q as interpolate,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3 as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8 as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v as _RGBAPremultiplied___get_rf__impl__pt0c4y,
  _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq as _RGBAPremultiplied___get_gf__impl__ivron7,
  _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni as _RGBAPremultiplied___get_bf__impl__qa3on2,
  _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx as _RGBAPremultiplied___get_af__impl__euwcjn,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_instance1sgltfeqg9bxt as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1yhww5yoq3a9l as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instance1zw3l6m7tnvps as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance2vt0vokm4ixbh as Companion_getInstance_11,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay2vwv568c245r8 as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  delay1blitpytzu6gr as delay_0,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  cancelChildrennwartoz0yn6c as cancelChildren,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin2j6ktsickm6hy as cancelAndJoin,
  MainScope1gi1r4abhrtmm as MainScope,
} from './kotlinx-coroutines-core.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance2i0t7ux7bzoqc as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_12,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-inject-root-korlibs-inject.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  FFILiby83bova0zjfy as FFILib,
  Companion_getInstance2ww1whxsubyyu as Companion_getInstance_13,
  FuncInfocud0a7bce10z as FuncInfo,
  CreateFFIPointernsr7ilwulbub as CreateFFIPointer,
  get_pointer2afz2rc14joly as get_pointer_0,
  CreateFFIMemoryv82e6jbfcdze as CreateFFIMemory,
  set3216gyp8r69gas8 as set32,
  CreateFFIMemory2iekizxdvtyvt as CreateFFIMemory_0,
  setFFIPointerjzarmbova4sm as setFFIPointer,
  getS32284qh8a5ldxzn as getS32,
} from './korlibs-ffi-root-korlibs-ffi-legacy.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.h6c_1 = eventLoop;
    this.i6c_1 = now;
    this.j6c_1 = time;
    this.k6c_1 = interval;
    this.l6c_1 = callback;
  }
  m6c(value) {
    this.i6c_1 = Duration__minus_impl_q5cfm7(value, this.j6c_1);
  }
  n6c() {
    return Duration__plus_impl_yu9v8f(this.i6c_1, this.j6c_1);
  }
  o6c(other) {
    return Duration__compareTo_impl_pchp0f(this.n6c(), other.n6c());
  }
  d(other) {
    return this.o6c(other instanceof TimedTask ? other : THROW_CCE());
  }
  g6() {
    this.k6c_1 = false;
    this.h6c_1.y6c_1.x2p(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.h6d_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.q6c_1 = immediateRun;
    this.r6c_1 = new SyncPauseable();
    this.s6c_1 = paused$factory(this.r6c_1);
    this.t6c_1 = new Lock();
    this.u6c_1 = true;
    this.v6c_1 = Monotonic_instance.hj();
    var tmp = this;
    tmp.w6c_1 = SyncEventLoop$nowProvider$lambda(this);
    this.x6c_1 = ArrayDeque.mk();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_0;
    tmp_0.y6c_1 = tmp_1.z2t(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_2 = this;
    tmp_2.z6c_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.a6d_1 = null;
  }
  b6d(task) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.t6c_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.f1x();
      try {
        this.x6c_1.qk(task);
        this.t6c_1.j1x();
        break $l$block;
      }finally {
        this_0.h1x();
      }
    }
  }
  c6d(time, task) {
    return _queueAfter(this, time, false, task);
  }
  g6() {
    var oldImmediateRun = this.q6c_1;
    try {
      this.q6c_1 = true;
      this.d6d();
      this.u6c_1 = false;
    }finally {
      this.q6c_1 = oldImmediateRun;
    }
  }
  e6d(task) {
    if (this.q6c_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.y6c_1.f2u().n6c()) >= 0;
  }
  f6d(runTimers) {
    var count = 0;
    while (this.g6d(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  d6d(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.f6d(runTimers) : $super.f6d.call(this, runTimers);
  }
  g6d(runTimers) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.t6c_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.f1x();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.y6c_1.g1()) {
            tmp_1 = this.e6d(this.y6c_1.f2u());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.y6c_1.g2u();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.h1x();
      }
    }
    var timedTask = tmp$ret$2;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        timedTask.l6c_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.z6c_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.k6c_1 && !this.q6c_1) {
        timedTask.m6c(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.n6c(), timedTask.j6c_1)), new Duration(_get_now__e6dlkr(this))).nj_1);
        this.y6c_1.w2p(timedTask);
      }
    }
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_1 = this.t6c_1;
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_1.f1x();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.x6c_1.g1()) {
          tmp_2 = this.x6c_1.rk();
        } else {
          tmp_2 = null;
        }
        tmp$ret$7 = tmp_2;
        break $l$block_0;
      }finally {
        this_1.h1x();
      }
    }
    var task = tmp$ret$7;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (task == null)
        null;
      else
        task();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.z6c_1(e_0);
      } else {
        throw $p;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.i6d_1 = func;
    this.j6d_1 = node;
    this.k6d_1 = base;
  }
  g6() {
    if (this.j6d_1.m6d_1.g3(this)) {
      __updateChildListenerCount(this.k6d_1, this.j6d_1.l6d_1, -1);
    }
  }
  o6d() {
    this.j6d_1.m6d_1.h(this);
    __updateChildListenerCount(this.k6d_1, this.j6d_1.l6d_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.l6d_1 = type;
    this.m6d_1 = FastArrayList.uz();
    this.n6d_1 = FastArrayList.uz();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.a5(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.ht(this.v6d(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.x6d(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.e6e(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.x6d(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.x6d(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.f6e(event.v2c(), event);
}
class BaseEventListener {
  static t6d() {
    var $this = createThis(this);
    $this.p6d_1 = null;
    $this.q6d_1 = null;
    $this.r6d_1 = null;
    $this.s6d_1 = null;
    return $this;
  }
  cz(_set____db54di) {
    this.p6d_1 = _set____db54di;
  }
  dz() {
    return this.p6d_1;
  }
  u6d(other) {
    var tmp0_safe_receiver = this.q6d_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.q6d_1 = other;
    var tmp1_safe_receiver = this.q6d_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  }
  v6d(type, handler) {
    if (this.r6d_1 == null)
      this.r6d_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.r6d_1);
      var res = get_0(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.o6d();
    return this_1;
  }
  w6d(type) {
    var tmp0_safe_receiver = this.r6d_1;
    var tmp = tmp0_safe_receiver == null ? null : get_0(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  x6d(type, event, result, up, down) {
    var eventListenerCount = this.y6d(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.z6d(type, event, result);
    }
    var listeners = this.w6d(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.m6d_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.n6d_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.sz_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].i6d_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.b6e_1 = result.b6e_1 + 1 | 0;
          }
        }
      }finally {
        temp.e3();
      }
    }
    if (up) {
      this.c6e(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.a6e_1 = result.a6e_1 + 1 | 0;
    }
    return event.d6e();
  }
  e6e(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  g6e(event) {
    return dispatch_0.call(this, event);
  }
  c6e(type, event, result) {
  }
  z6d(type, event, result) {
  }
  y6d(type) {
    var tmp0_safe_receiver = this.s6d_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.a6e_1 = iterationCount;
    this.b6e_1 = resultCount;
  }
  v2t() {
    this.a6e_1 = 0;
    this.b6e_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.a6e_1 + ', resultCount=' + this.b6e_1 + ')';
  }
  hashCode() {
    var result = this.a6e_1;
    result = imul(result, 31) + this.b6e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.a6e_1 === tmp0_other_with_cast.a6e_1))
      return false;
    if (!(this.b6e_1 === tmp0_other_with_cast.b6e_1))
      return false;
    return true;
  }
}
class Companion {}
class Event {
  constructor() {
    this.n6e_1 = null;
    this.o6e_1 = false;
  }
  p6e(_set____db54di) {
    this.n6e_1 = _set____db54di;
  }
  w6g(reason) {
    throw StopPropagatingException.m6h(reason);
  }
  q6e(_set____db54di) {
    this.o6e_1 = _set____db54di;
  }
  d6e() {
    return this.o6e_1;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.m6e_1 = type;
  }
  v2c() {
    return this.m6e_1;
  }
}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_8);
  }
}
class Companion_0 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_9);
  }
}
class Companion_1 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_10);
  }
}
class Companion_2 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_11);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_18();
    super(Companion_getInstance_18());
    this.u6e_1 = true;
    this.v6e_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.u6e_1 + ', render=' + this.v6e_1 + ')';
  }
}
class Companion_3 extends RenderEvent {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_19();
    super(Companion_getInstance_19());
  }
}
class Companion_4 extends InitEvent {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class Companion_5 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_14);
  }
}
class Companion_6 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_15);
    this.z6e_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.z6e_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.z6e_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.z6e_1 === tmp0_other_with_cast.z6e_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height, setPos) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    setPos = setPos === VOID ? true : setPos;
    super(Companion_instance_16);
    this.d6f_1 = x;
    this.e6f_1 = y;
    this.f6f_1 = width;
    this.g6f_1 = height;
    this.h6f_1 = setPos;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.d6f_1 + ', y=' + this.e6f_1 + ', width=' + this.f6f_1 + ', height=' + this.g6f_1 + ', setPos=' + this.h6f_1 + ')';
  }
  hashCode() {
    var result = this.d6f_1;
    result = imul(result, 31) + this.e6f_1 | 0;
    result = imul(result, 31) + this.f6f_1 | 0;
    result = imul(result, 31) + this.g6f_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.d6f_1 === tmp0_other_with_cast.d6f_1))
      return false;
    if (!(this.e6f_1 === tmp0_other_with_cast.e6f_1))
      return false;
    if (!(this.f6f_1 === tmp0_other_with_cast.f6f_1))
      return false;
    if (!(this.g6f_1 === tmp0_other_with_cast.g6f_1))
      return false;
    if (!(this.h6f_1 === tmp0_other_with_cast.h6f_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_17 = this;
    this.i6f_1 = values();
  }
}
class Type extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.l6f_1 = type;
    this.m6f_1 = id;
    this.n6f_1 = key;
    this.o6f_1 = keyCode;
    this.p6f_1 = character;
    this.q6f_1 = shift;
    this.r6f_1 = ctrl;
    this.s6f_1 = alt;
    this.t6f_1 = meta;
    this.u6f_1 = str;
    this.v6f_1 = Companion_getInstance().oj_1;
  }
  v2c() {
    return this.l6f_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.l6f_1) + ', id=' + this.m6f_1 + ', key=' + this.n6f_1.toString() + ', keyCode=' + this.o6f_1 + ', character=' + toString_0(this.p6f_1) + ', shift=' + this.q6f_1 + ', ctrl=' + this.r6f_1 + ', alt=' + this.s6f_1 + ', meta=' + this.t6f_1 + ', str=' + this.u6f_1 + ')';
  }
  hashCode() {
    var result = this.l6f_1.hashCode();
    result = imul(result, 31) + this.m6f_1 | 0;
    result = imul(result, 31) + this.n6f_1.hashCode() | 0;
    result = imul(result, 31) + this.o6f_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.p6f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r6f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s6f_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t6f_1) | 0;
    result = imul(result, 31) + (this.u6f_1 == null ? 0 : getStringHashCode(this.u6f_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.l6f_1.equals(tmp0_other_with_cast.l6f_1))
      return false;
    if (!(this.m6f_1 === tmp0_other_with_cast.m6f_1))
      return false;
    if (!this.n6f_1.equals(tmp0_other_with_cast.n6f_1))
      return false;
    if (!(this.o6f_1 === tmp0_other_with_cast.o6f_1))
      return false;
    if (!(this.p6f_1 === tmp0_other_with_cast.p6f_1))
      return false;
    if (!(this.q6f_1 === tmp0_other_with_cast.q6f_1))
      return false;
    if (!(this.r6f_1 === tmp0_other_with_cast.r6f_1))
      return false;
    if (!(this.s6f_1 === tmp0_other_with_cast.s6f_1))
      return false;
    if (!(this.t6f_1 === tmp0_other_with_cast.t6f_1))
      return false;
    if (!(this.u6f_1 == tmp0_other_with_cast.u6f_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_18 = this;
    this.w6f_1 = values_0();
  }
}
class Type_0 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.z6f_1 = scale;
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.c6g_1 = type;
    this.d6g_1 = id;
    this.e6g_1 = x;
    this.f6g_1 = y;
    this.g6g_1 = button;
    this.h6g_1 = buttons;
    this.i6g_1 = scrollDeltaX;
    this.j6g_1 = scrollDeltaY;
    this.k6g_1 = scrollDeltaZ;
    this.l6g_1 = isShiftDown;
    this.m6g_1 = isCtrlDown;
    this.n6g_1 = isAltDown;
    this.o6g_1 = isMetaDown;
    this.p6g_1 = scaleCoords;
    this.q6g_1 = emulated;
    this.r6g_1 = scrollDeltaMode;
    this.s6g_1 = null;
    var tmp = this;
    tmp.t6g_1 = MouseEvent$requestLock$lambda;
  }
  v2c() {
    return this.c6g_1;
  }
  u6g(other) {
    this.c6g_1 = other.c6g_1;
    this.d6g_1 = other.d6g_1;
    this.e6g_1 = other.e6g_1;
    this.f6g_1 = other.f6g_1;
    this.g6g_1 = other.g6g_1;
    this.h6g_1 = other.h6g_1;
    this.i6g_1 = other.i6g_1;
    this.j6g_1 = other.j6g_1;
    this.k6g_1 = other.k6g_1;
    this.l6g_1 = other.l6g_1;
    this.m6g_1 = other.m6g_1;
    this.n6g_1 = other.n6g_1;
    this.o6g_1 = other.o6g_1;
    this.p6g_1 = other.p6g_1;
    this.q6g_1 = other.q6g_1;
    this.r6g_1 = other.r6g_1;
  }
  v6g(mode, x, y, z) {
    this.r6g_1 = mode;
    this.i6g_1 = x;
    this.j6g_1 = y;
    this.k6g_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.c6g_1) + ', id=' + this.d6g_1 + ', x=' + this.e6g_1 + ', y=' + this.f6g_1 + ', button=' + this.g6g_1.toString() + ', buttons=' + this.h6g_1 + ', scrollDeltaX=' + this.i6g_1 + ', scrollDeltaY=' + this.j6g_1 + ', scrollDeltaZ=' + this.k6g_1 + ', isShiftDown=' + this.l6g_1 + ', isCtrlDown=' + this.m6g_1 + ', isAltDown=' + this.n6g_1 + ', isMetaDown=' + this.o6g_1 + ', scaleCoords=' + this.p6g_1 + ', emulated=' + this.q6g_1 + ', scrollDeltaMode=' + this.r6g_1.toString() + ')';
  }
  hashCode() {
    var result = this.c6g_1.hashCode();
    result = imul(result, 31) + this.d6g_1 | 0;
    result = imul(result, 31) + this.e6g_1 | 0;
    result = imul(result, 31) + this.f6g_1 | 0;
    result = imul(result, 31) + this.g6g_1.hashCode() | 0;
    result = imul(result, 31) + this.h6g_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.i6g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j6g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p6g_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6g_1) | 0;
    result = imul(result, 31) + this.r6g_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.c6g_1.equals(tmp0_other_with_cast.c6g_1))
      return false;
    if (!(this.d6g_1 === tmp0_other_with_cast.d6g_1))
      return false;
    if (!(this.e6g_1 === tmp0_other_with_cast.e6g_1))
      return false;
    if (!(this.f6g_1 === tmp0_other_with_cast.f6g_1))
      return false;
    if (!this.g6g_1.equals(tmp0_other_with_cast.g6g_1))
      return false;
    if (!(this.h6g_1 === tmp0_other_with_cast.h6g_1))
      return false;
    if (!equals(this.i6g_1, tmp0_other_with_cast.i6g_1))
      return false;
    if (!equals(this.j6g_1, tmp0_other_with_cast.j6g_1))
      return false;
    if (!equals(this.k6g_1, tmp0_other_with_cast.k6g_1))
      return false;
    if (!(this.l6g_1 === tmp0_other_with_cast.l6g_1))
      return false;
    if (!(this.m6g_1 === tmp0_other_with_cast.m6g_1))
      return false;
    if (!(this.n6g_1 === tmp0_other_with_cast.n6g_1))
      return false;
    if (!(this.o6g_1 === tmp0_other_with_cast.o6g_1))
      return false;
    if (!(this.p6g_1 === tmp0_other_with_cast.p6g_1))
      return false;
    if (!(this.q6g_1 === tmp0_other_with_cast.q6g_1))
      return false;
    if (!this.r6g_1.equals(tmp0_other_with_cast.r6g_1))
      return false;
    return true;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_19 = this;
    this.x6g_1 = values_1();
  }
}
class Type_1 extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.a6h_1 = type;
    this.b6h_1 = id;
    this.c6h_1 = amountX;
    this.d6h_1 = amountY;
  }
  v2c() {
    return this.a6h_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.a6h_1) + ', id=' + this.b6h_1 + ', amountX=' + this.c6h_1 + ', amountY=' + this.d6h_1 + ')';
  }
  hashCode() {
    var result = this.a6h_1.hashCode();
    result = imul(result, 31) + this.b6h_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.c6h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d6h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.a6h_1.equals(tmp0_other_with_cast.a6h_1))
      return false;
    if (!(this.b6h_1 === tmp0_other_with_cast.b6h_1))
      return false;
    if (!equals(this.c6h_1, tmp0_other_with_cast.c6h_1))
      return false;
    if (!equals(this.d6h_1, tmp0_other_with_cast.d6h_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    this.e6h_1 = values_2();
  }
}
class Type_2 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance() : type;
    files = files === VOID ? null : files;
    super();
    this.h6h_1 = type;
    this.i6h_1 = files;
  }
  v2c() {
    return this.h6h_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.h6h_1) + ', files=' + toString_1(this.i6h_1) + ')';
  }
  hashCode() {
    var result = this.h6h_1.hashCode();
    result = imul(result, 31) + (this.i6h_1 == null ? 0 : hashCode(this.i6h_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.h6h_1.equals(tmp0_other_with_cast.h6h_1))
      return false;
    if (!equals(this.i6h_1, tmp0_other_with_cast.i6h_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  static m6h(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.yd();
    captureStack($this, $this.l6h_1);
    $this.k6h_1 = reason;
    return $this;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    this.n6h_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_27();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_4().z28_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.o6h_1 = new Mixin();
    this.p6h_1 = index;
    this.q6h_1 = id;
    this.r6h_1 = p;
    this.s6h_1 = force;
    this.t6h_1 = status;
    this.u6h_1 = kind;
    this.v6h_1 = button;
  }
  w6h() {
    return this.r6h_1.x28_1;
  }
  x6h() {
    return this.r6h_1.y28_1;
  }
  c16() {
    return !this.t6h_1.equals(Status_REMOVE_getInstance());
  }
  y6h(other) {
    this.q6h_1 = other.q6h_1;
    this.r6h_1 = other.r6h_1;
    this.s6h_1 = other.s6h_1;
    this.t6h_1 = other.t6h_1;
    this.u6h_1 = other.u6h_1;
    this.v6h_1 = other.v6h_1;
  }
  hashCode() {
    return this.p6h_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.p6h_1 === other.p6h_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.p6h_1 + ', id=' + this.q6h_1 + ', p=' + this.r6h_1.toString() + ', force=' + this.s6h_1 + ', status=' + this.t6h_1.toString() + ', kind=' + this.u6h_1.toString() + ', button=' + this.v6h_1.toString() + ')';
  }
  cz(value) {
    this.o6h_1.cz(value);
  }
  dz() {
    return this.o6h_1.dz();
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    this.z6h_1 = values_3();
  }
}
class Type_3 extends Enum {}
class Companion_14 {
  constructor() {
    this.a6i_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_8().l1w_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.d6i_1 = type;
    this.e6i_1 = screen;
    this.f6i_1 = currentTime;
    this.g6i_1 = scaleCoords;
    this.h6i_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_23.a6i_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.i6i_1 = tmp_2;
    this.j6i_1 = FastArrayList.uz();
    this.k6i_1 = FastArrayList.uz();
    this.l6i_1 = FastIntMap();
  }
  v2c() {
    return this.d6i_1;
  }
  m6i() {
    return this.j6i_1;
  }
  n6i() {
    return this.m6i().e1();
  }
  o6i(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.l6i_1.get(id);
  }
  toString() {
    var tmp = toString(this.d6i_1);
    var tmp_0 = this.n6i();
    var tmp_1 = this.m6i();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  p6i(type) {
    this.d6i_1 = type;
    this.f6i_1 = Companion_getInstance_8().p1w();
    this.j6i_1.e3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.l6i_1.clear();
  }
  q6i() {
    this.k6i_1.e3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.m6i();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      if (it.c16()) {
        this.k6i_1.h(it);
      }
    }
  }
  r6i(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.l6i_1.get(id);
    return tmp0_elvis_lhs == null ? this.s6i(id) : tmp0_elvis_lhs;
  }
  s6i(id) {
    var touch = this.i6i_1[this.j6i_1.e1()];
    touch.q6h_1 = id;
    this.j6i_1.h(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.l6i_1;
    var key = touch.q6h_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  }
  t6i(id, p, status, force, kind, button) {
    var touch = this.r6i(id);
    touch.r6h_1 = p;
    touch.t6h_1 = status;
    touch.s6h_1 = force;
    touch.u6h_1 = kind;
    touch.v6h_1 = button;
  }
  u6i(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.t6i(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.t6i.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  v6i(touch) {
    this.t6i(touch.q6h_1, touch.r6h_1, touch.t6h_1, touch.s6h_1, touch.u6h_1, touch.v6h_1);
  }
  w6i(other) {
    this.d6i_1 = other.d6i_1;
    this.e6i_1 = other.e6i_1;
    this.f6i_1 = other.f6i_1;
    this.g6i_1 = other.g6i_1;
    this.h6i_1 = other.h6i_1;
    var inductionVariable = 0;
    var last = Companion_instance_23.a6i_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.i6i_1[n].y6h(other.i6i_1[n]);
      }
       while (inductionVariable < last);
    this.j6i_1.e3();
    this.k6i_1.e3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.l6i_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.m6i();
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.d1(_unary__edvuaz);
      var touch = this.i6i_1[otherTouch.p6h_1];
      this.j6i_1.h(touch);
      if (touch.c16()) {
        this.k6i_1.h(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.l6i_1;
      var key = touch.q6h_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  }
  x6i() {
    return this.d6i_1.equals(Type_START_getInstance_0());
  }
  y6i() {
    return this.d6i_1.equals(Type_END_getInstance_0());
  }
  hashCode() {
    var result = this.d6i_1.hashCode();
    result = imul(result, 31) + this.e6i_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.f6i_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g6i_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.d6i_1.equals(tmp0_other_with_cast.d6i_1))
      return false;
    if (!(this.e6i_1 === tmp0_other_with_cast.e6i_1))
      return false;
    if (!equals(this.f6i_1, tmp0_other_with_cast.f6i_1))
      return false;
    if (!(this.g6i_1 === tmp0_other_with_cast.g6i_1))
      return false;
    if (!(this.h6i_1 === tmp0_other_with_cast.h6i_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.z6i_1 = new TouchEvent();
    this.a6j_1 = new TouchEvent();
    this.b6j_1 = Mode_JS_getInstance();
  }
  c6j(type, scaleCoords) {
    this.a6j_1.g6i_1 = scaleCoords;
    this.a6j_1.p6i(type);
    if (this.b6j_1.k3_1 === 2) {
      this.a6j_1.w6i(this.z6i_1);
      this.a6j_1.d6i_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.a6j_1.j6i_1;
      var n = 0;
      var m = 0;
      while (n < this_0.e1()) {
        if (m >= 0 && !(m === n)) {
          this_0.h3(m, this_0.d1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.d1(n);
        var tmp;
        if (it.c16()) {
          it.t6h_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.a6j_1.l6i_1;
          var key = it.q6h_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.e1() > m) {
        this_0.i3(this_0.e1() - 1 | 0);
      }
    }
  }
  d6j() {
    switch (this.b6j_1.k3_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.z6i_1.m6i();
        var n = 0;
        while (n < this_0.e1()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.d1(_unary__edvuaz);
          if (this.a6j_1.o6i(oldTouch.q6h_1) == null) {
            if (oldTouch.c16()) {
              oldTouch.t6h_1 = Status_REMOVE_getInstance();
              this.a6j_1.v6i(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.a6j_1.q6i();
    this.z6i_1.w6i(this.a6j_1);
    return this.a6j_1;
  }
  e6j(id, p, force, kind, button) {
    var touch = this.a6j_1.r6i(id);
    touch.r6h_1 = p;
    touch.s6h_1 = force;
    touch.u6h_1 = kind;
    touch.v6h_1 = button;
    if (this.b6j_1.k3_1 === 2) {
      var tmp = touch;
      switch (this.a6j_1.d6i_1.k3_1) {
        case 0:
          tmp.t6h_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.t6h_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.t6h_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.z6i_1.o6i(id);
      touch.t6h_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  f6j(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.e6j(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.e6j.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.g6j_1 = dispatcher;
    this.h6j_1 = booleanArray(4);
    this.i6j_1 = new GamePadUpdateEvent();
    this.j6j_1 = new GamePadConnectionEvent();
    this.k6j_1 = IntArrayList.t2n();
  }
  l6j() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.i6j_1.p6j_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].r6j_1 = false;
    }
    this.i6j_1.o6j_1 = 0;
  }
  x6j(info) {
    var _receiver__tnumb7 = this.i6j_1;
    var _unary__edvuaz = _receiver__tnumb7.o6j_1;
    _receiver__tnumb7.o6j_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.i6j_1.p6j_1[index];
    pad.y6j(info);
    pad.r6j_1 = true;
    pad.q6j_1 = index;
  }
  z6j(out) {
    out.e3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.i6j_1.p6j_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.h6j_1[it.q6j_1] === it.r6j_1)) {
        this.h6j_1[it.q6j_1] = it.r6j_1;
        out.z2n(it.q6j_1);
        if (!it.r6j_1) {
          it.s6j_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.j6j_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.c6k_1 = Companion_getInstance_32().f6k(it.r6j_1);
        this_1.d6k_1 = it.q6j_1;
        this.g6j_1.g6e(this_1);
      }
    }
    this.g6j_1.g6e(this.i6j_1);
    return out;
  }
}
class BatteryStatus extends Enum {}
class Companion_15 {
  constructor() {
    this.g6k_1 = 'Wireless Controller';
    this.h6k_1 = 4;
    this.i6k_1 = 0.075;
  }
  j6k(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  k6k(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.j6k(value, margin, apply) : $super.j6k.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_24.g6k_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.q6j_1 = index;
    this.r6j_1 = connected;
    this.s6j_1 = name;
    this.t6j_1 = rawButtons;
    this.u6j_1 = batteryLevel;
    this.v6j_1 = name2;
    this.w6j_1 = batteryStatus;
  }
  l6k() {
    var tmp0_elvis_lhs = this.s6j_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.v6j_1;
  }
  y6j(that) {
    this.q6j_1 = that.q6j_1;
    this.s6j_1 = that.s6j_1;
    this.v6j_1 = that.v6j_1;
    this.r6j_1 = that.r6j_1;
    this.u6j_1 = that.u6j_1;
    this.w6j_1 = that.w6j_1;
    var tmp = that.t6j_1;
    var tmp_0 = this.t6j_1;
    // Inline function 'kotlin.math.min' call
    var a = this.t6j_1.length;
    var b = that.t6j_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  m6k(button) {
    return this.t6j_1[button.p6k()];
  }
  q6k(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.ub('Gamepad[' + this.q6j_1 + '][' + this.l6k() + ']');
    if (includeButtons) {
      this_0.ub('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.m6k(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.ub(',');
          }
          this_0.ub(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.ub(']');
    }
    return this_0.toString();
  }
  r6k(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.q6k(includeButtons) : $super.q6k.call(this, includeButtons);
  }
  toString() {
    return this.q6k(false);
  }
}
class Companion_16 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.o6j_1 = gamepadsLength;
    this.p6j_1 = gamepads;
  }
  v2c() {
    return Companion_instance_25;
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.p6j_1;
    var destination = ArrayList.i1();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.r6j_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.r6k();
      destination_0.h(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.o6j_1;
    result = imul(result, 31) + hashCode(this.p6j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.o6j_1 === tmp0_other_with_cast.o6j_1))
      return false;
    if (!equals(this.p6j_1, tmp0_other_with_cast.p6j_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.e6k_1 = values_4();
  }
  f6k(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.c6k_1 = type;
    this.d6k_1 = gamepad;
  }
  v2c() {
    return this.c6k_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.c6k_1) + ', gamepad=' + this.d6k_1 + ')';
  }
  hashCode() {
    var result = this.c6k_1.hashCode();
    result = imul(result, 31) + this.d6k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.c6k_1.equals(tmp0_other_with_cast.c6k_1))
      return false;
    if (!(this.d6k_1 === tmp0_other_with_cast.d6k_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.s6k_1 = values_5();
    this.t6k_1 = 32;
  }
}
class GameButton extends Enum {
  p6k() {
    return this.k3_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.u6k_1 = Key_UNKNOWN_getInstance().k3_1 + 1 | 0;
    this.v6k_1 = Key_ENTER_getInstance();
    this.w6k_1 = Key_N0_getInstance();
    this.x6k_1 = Key_N1_getInstance();
    this.y6k_1 = Key_N2_getInstance();
    this.z6k_1 = Key_N3_getInstance();
    this.a6l_1 = Key_N4_getInstance();
    this.b6l_1 = Key_N5_getInstance();
    this.c6l_1 = Key_N6_getInstance();
    this.d6l_1 = Key_N7_getInstance();
    this.e6l_1 = Key_N8_getInstance();
    this.f6l_1 = Key_N9_getInstance();
  }
  g6l() {
    return Key_CONTROL_getInstance();
  }
  h6l() {
    return Key_CONTROL_getInstance();
  }
  i6l() {
    return Key_SHIFT_getInstance();
  }
  j6l() {
    return Key_SHIFT_getInstance();
  }
  k6l() {
    return Key_ALT_getInstance();
  }
  l6l() {
    return Key_ALT_getInstance();
  }
  m6l() {
    return Key_SUPER_getInstance();
  }
  n6l() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  q6l() {
    switch (this.k3_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.r6l_1 = MouseButton_NONE_getInstance().k3_1 + 1 | 0;
    this.s6l_1 = values_6();
  }
  d1(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.s6l_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.v6l_1 = id;
    this.w6l_1 = bits;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.x6l_1 = Companion_getInstance_1().tx('AG');
    this.y6l_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_isUniformBuffersSupported() {
  var tmp0_safe_receiver = this.z6m();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a6n();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp0_safe_receiver = this.z6m();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b6n();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
class AG {
  static d6m() {
    Companion_getInstance_36();
    var $this = createThis(this);
    $this.z6l_1 = new Mixin();
    $this.a6m_1 = AGFrameBuffer.r6m(true);
    $this.b6m_1 = 0;
    $this.c6m_1 = new AGStats();
    return $this;
  }
  s6m() {
    return this.a6m_1;
  }
  t6m() {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().x6l_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.e2x(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().x6l_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.d2x(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.e2x(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.b6m_1 = this.b6m_1 + 1 | 0;
  }
  u6m() {
    return this.v6m(AGFinish_instance);
  }
  w6m() {
    return Unit_instance;
  }
  q6i() {
    return Unit_instance;
  }
  v6m(command) {
    return Unit_instance;
  }
  x6m(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.v6m(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  y6m(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.v6m(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
  cz(value) {
    this.z6l_1.cz(value);
  }
  dz() {
    return this.z6l_1.dz();
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.l6o_1 = parentFeatures;
    this.m6o_1 = graphicExtensions;
    this.n6o_1 = isInstancedSupported;
    this.o6o_1 = isUniformBuffersSupported;
    this.p6o_1 = isVertexArraysSupported;
    this.q6o_1 = isStorageMultisampleSupported;
    this.r6o_1 = isFloatTextureSupported;
  }
  z6m() {
    return this.l6o_1;
  }
  a6n() {
    return this.o6o_1;
  }
  b6n() {
    return this.p6o_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.l6o_1) + ', graphicExtensions=' + toString(this.m6o_1) + ', isInstancedSupported=' + this.n6o_1 + ', isUniformBuffersSupported=' + this.o6o_1 + ', isVertexArraysSupported=' + this.p6o_1 + ', isStorageMultisampleSupported=' + this.q6o_1 + ', isFloatTextureSupported=' + this.r6o_1 + ')';
  }
  hashCode() {
    var result = this.l6o_1 == null ? 0 : hashCode(this.l6o_1);
    result = imul(result, 31) + hashCode(this.m6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r6o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.l6o_1, tmp0_other_with_cast.l6o_1))
      return false;
    if (!equals(this.m6o_1, tmp0_other_with_cast.m6o_1))
      return false;
    if (!(this.n6o_1 === tmp0_other_with_cast.n6o_1))
      return false;
    if (!(this.o6o_1 === tmp0_other_with_cast.o6o_1))
      return false;
    if (!(this.p6o_1 === tmp0_other_with_cast.p6o_1))
      return false;
    if (!(this.q6o_1 === tmp0_other_with_cast.q6o_1))
      return false;
    if (!(this.r6o_1 === tmp0_other_with_cast.r6o_1))
      return false;
    return true;
  }
}
class AGObject {
  constructor() {
    this.s6p_1 = null;
    this.t6p_1 = -1;
    this.u6p_1 = -2;
    this.v6p_1 = -1;
  }
  a6q() {
    this.w6p();
    this.u6p_1 = this.v6p_1 - 1 | 0;
  }
  w6p() {
    this.v6p_1 = this.v6p_1 + 1 | 0;
  }
  g6() {
    var tmp0_safe_receiver = this.s6p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b6t();
    }
    this.s6p_1 = null;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.r6p_1 = null;
  }
  x6p(data, offset, length) {
    return upload(this, _Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)), false);
  }
  y6p(data, offset, length) {
    return upload(this, sliceWithSize(data, offset, length), true);
  }
  z6p(data) {
    return upload(this, data, true);
  }
  toString() {
    var tmp0_safe_receiver = this.r6p_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r13();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  }
}
class Companion_22 {
  constructor() {
    this.n6n_1 = 8;
  }
  o6n() {
    return AGTextureUnits.d6q();
  }
}
class AGTextureUnits {
  static e6q(textures, infos) {
    var $this = createThis(this);
    $this.b6q_1 = textures;
    $this.c6q_1 = infos;
    return $this;
  }
  static d6q(size) {
    size = size === VOID ? Companion_instance_31.n6n_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.e6q(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  e1() {
    return this.b6q_1.length;
  }
  f6q(index, texture, info) {
    this.b6q_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.c6q_1, index, info);
  }
  g6q(sampler, texture, info) {
    this.f6q(sampler.s6q_1, texture, info);
  }
  u6q(sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_39().w6q_1 : info;
    var tmp;
    if ($super === VOID) {
      this.g6q(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.g6q.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  e3() {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.f6q(n, null, Companion_getInstance_39().w6q_1);
      }
       while (inductionVariable < last);
  }
  zy() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.b6q_1.slice();
    return AGTextureUnits.e6q(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.c6q_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.b6q_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.c6q_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.b6q_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.c6q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.b6q_1, tmp0_other_with_cast.b6q_1))
      return false;
    if (!equals(this.c6q_1, tmp0_other_with_cast.c6q_1))
      return false;
    return true;
  }
}
class Companion_23 {
  constructor() {
    this.x6q_1 = 128;
    this.y6q_1 = 128;
  }
}
class AGFrameBuffer {
  static z6q(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.e6m_1 = base;
    $this.f6m_1 = id;
    $this.g6m_1 = 1;
    $this.h6m_1 = true;
    $this.i6m_1 = true;
    $this.j6m_1 = 0;
    $this.k6m_1 = 0;
    $this.l6m_1 = 128;
    $this.m6m_1 = 128;
    $this.n6m_1 = 128;
    $this.o6m_1 = 128;
    $this.p6m_1 = RectangleInt.n2i();
    $this.q6m_1 = null;
    return $this;
  }
  static r6m(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.z6q(new AGFrameBufferBase(isMain), id);
  }
  a6r() {
    return this.e6m_1.a6r();
  }
  i6r() {
    return this.e6m_1.f6r_1;
  }
  j6r() {
    return this.e6m_1.g6r_1;
  }
  k6o() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.j6m_1, this.k6m_1, this.l6m_1, this.m6m_1), this.g6m_1), this.i6m_1), this.h6m_1);
  }
  k6r(width, height) {
    return this.l6r(0, 0, width, height);
  }
  m6r(x, y, width, height, fullWidth, fullHeight) {
    if (this.j6m_1 === x && this.k6m_1 === y && this.l6m_1 === width && this.m6m_1 === height && this.n6m_1 === fullWidth && this.o6m_1 === fullHeight)
      return true;
    this.j6r().b6s(NullBitmap.d4d(width, height));
    this.e6m_1.h6r_1 = Companion_getInstance_9().q15(imul(imul(fullWidth, fullHeight), 8));
    this.j6m_1 = x;
    this.k6m_1 = y;
    this.l6m_1 = width;
    this.m6m_1 = height;
    this.n6m_1 = fullWidth;
    this.o6m_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  l6r(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.m6r(x, y, width, height, fullWidth, fullHeight) : $super.m6r.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  g6() {
    this.e6m_1.g6();
  }
  c6s(samples) {
    if (this.g6m_1 === samples)
      return Unit_instance;
    this.g6m_1 = samples;
    markAsDirty(this);
  }
  d6s(hasDepth, hasStencil) {
    if (this.i6m_1 === hasDepth && this.h6m_1 === hasStencil)
      return Unit_instance;
    this.i6m_1 = hasDepth;
    this.h6m_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.i6r() ? 'main' : '' + this.f6m_1) + ', ' + this.l6m_1 + ', ' + this.m6m_1 + ')';
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_50().e6s_1 : targetKind;
    super();
    this.r6r_1 = targetKind;
    this.s6r_1 = Companion_getInstance_1().tx('AGTexture');
    this.t6r_1 = false;
    this.u6r_1 = false;
    this.v6r_1 = null;
    this.w6r_1 = null;
    this.x6r_1 = null;
    this.y6r_1 = false;
    this.z6r_1 = null;
    this.a6s_1 = Companion_getInstance_9().r15(new Long(0, 0));
  }
  i6s() {
    var tmp0_safe_receiver = this.z6r_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b4c();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_50(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.r6r_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  k2l() {
    var tmp0_safe_receiver = this.x6r_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a3y_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  l2l() {
    var tmp0_safe_receiver = this.x6r_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b3y_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  k6s() {
    var tmp = this.x6r_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y6s_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  }
  z6s(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.z6r_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.x6r_1 = bmp;
    this.a6s_1 = Companion_getInstance_9().q15(imul(imul(imul(this.k2l(), this.l2l()), this.k6s()), 4));
    this.w6p();
    this.u6r_1 = mipmaps;
    this.v6r_1 = baseMipmapLevel;
    this.w6r_1 = maxMipmapLevel;
    return this;
  }
  b6s(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.z6s(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.z6s.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  a6t(bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.a3y_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.b3y_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.k2l() + ',' + this.l2l() + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.f6r_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.t6r_1 = true;
    tmp.g6r_1 = this_0;
    this.h6r_1 = Companion_getInstance_9().q15(0);
  }
  a6r() {
    return !this.f6r_1;
  }
  g6() {
    this.g6r_1.g6();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.f6r_1 + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    this.v6q_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.w6q_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_51().d6t_1), Companion_getInstance_50().e6s_1);
  }
  c6t(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  g6t(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  h6t(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_51().d6t_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.g6t(wrap, linear, trilinear) : $super.g6t.call(this, new AGWrapMode(wrap), linear, trilinear).i6t_1;
  }
}
class AGTextureUnitInfo {
  constructor(data) {
    Companion_getInstance_39();
    this.i6t_1 = data;
  }
  toString() {
    return AGTextureUnitInfo__toString_impl_7im6je(this.i6t_1);
  }
  hashCode() {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.i6t_1);
  }
  equals(other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.i6t_1, other);
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.j6t_1 = FastIdentityMap();
  }
  v2t() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.j6t_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).v2t();
    }
  }
  s6t() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.j6t_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).t6t();
    }
  }
  u6t(block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.j6t_1;
      var res = get_0(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.v6t_1 = program;
    this.w6t_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.v6t_1.i6u_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.c6v_1;
      destination.h(tmp$ret$0);
    }
    tmp.x6t_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.x6t_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.c1().e6v_1 + 1 | 0;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.c1().e6v_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.y6t_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.y6t_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var _iterator__ex2g4s = this.x6t_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var layout = _iterator__ex2g4s.c1();
      tmp_4[layout.e6v_1] = layout;
    }
    tmp_1.z6t_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.z6t_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.z6t_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.w6t_1.u6t(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.a6u_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.z6t_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.a6u_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.k6t_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.b6u_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.z6t_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.a6u_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.l6t_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.c6u_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.z6t_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.d6u_1 = tmp_25;
  }
  i6v() {
    var inductionVariable = 0;
    var last = this.d6u_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.a6u_1[n];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j6v();
        this.d6u_1[n] = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.d6u_1.slice();
    return new UniformBlocksBuffersRef(this.b6u_1, this.c6u_1, tmp$ret$1);
  }
}
class AGVertexArrayObject {
  static n6v(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.k6v_1 = new Mixin();
    $this.l6v_1 = list;
    $this.m6v_1 = isDynamic;
    return $this;
  }
  static o6v(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.n6v(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.l6v_1.toString() + ', isDynamic=' + this.m6v_1 + ')';
  }
  hashCode() {
    var result = this.l6v_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.m6v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.l6v_1.equals(tmp0_other_with_cast.l6v_1))
      return false;
    if (!(this.m6v_1 === tmp0_other_with_cast.m6v_1))
      return false;
    return true;
  }
  cz(value) {
    this.k6v_1.cz(value);
  }
  dz() {
    return this.k6v_1.dz();
  }
}
class AGVertexData {
  constructor(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.x6v([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.y6v_1 = layout;
    this.z6v_1 = buffer;
    this.a6w_1 = baseOffset;
  }
  toString() {
    return 'AGVertexData(layout=' + this.y6v_1.toString() + ', buffer=' + this.z6v_1.toString() + ', baseOffset=' + this.a6w_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.y6v_1);
    result = imul(result, 31) + hashCode(this.z6v_1) | 0;
    result = imul(result, 31) + this.a6w_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.y6v_1, tmp0_other_with_cast.y6v_1))
      return false;
    if (!equals(this.z6v_1, tmp0_other_with_cast.z6v_1))
      return false;
    if (!(this.a6w_1 === tmp0_other_with_cast.a6w_1))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.b6w_1 = _AGDrawType___init__impl__emm6mb(0);
    this.c6w_1 = _AGDrawType___init__impl__emm6mb(1);
    this.d6w_1 = _AGDrawType___init__impl__emm6mb(2);
    this.e6w_1 = _AGDrawType___init__impl__emm6mb(3);
    this.f6w_1 = _AGDrawType___init__impl__emm6mb(4);
    this.g6w_1 = _AGDrawType___init__impl__emm6mb(5);
    this.h6w_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class AGDrawType {
  constructor(ordinal) {
    Companion_getInstance_40();
    this.i6w_1 = ordinal;
  }
  toString() {
    return AGDrawType__toString_impl_eonaeb(this.i6w_1);
  }
  hashCode() {
    return AGDrawType__hashCode_impl_ylaury(this.i6w_1);
  }
  equals(other) {
    return AGDrawType__equals_impl_rtafo6(this.i6w_1, other);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.c6n_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.d6n_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.e6n_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.f6n_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.g6n_1 = _AGBlending___init__impl__upt3bq(-1);
    this.h6n_1 = Companion_getInstance_42().x6w(Companion_getInstance_52().p6w_1, Companion_getInstance_52().w6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().w6w_1);
    this.i6n_1 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().s6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().s6w_1);
    this.j6n_1 = Companion_getInstance_42().y6w(Companion_getInstance_52().p6w_1, Companion_getInstance_52().s6w_1);
    this.k6n_1 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().n6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
    this.l6n_1 = Companion_getInstance_42().x6w(Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
  }
  z6w(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  x6w(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_53().a6x_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.z6w(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.z6w.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).j6w_1;
  }
  d6x(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  y6w(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_53().a6x_1 : eq;
    return $super === VOID ? this.d6x(src, dst, eq) : $super.d6x.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).j6w_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_42();
    this.j6w_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.j6w_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.j6w_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.j6w_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.b6o_1 = AGScissor.i6x(0, 0, 0, 0);
    this.c6o_1 = Companion_getInstance_43().f2h(-2147483648, -2147483648, 2147483647, 2147483647);
    this.d6o_1 = Companion_getInstance_43().f2h(-32766, -32766, 2147483647, 2147483647);
    this.e6o_1 = Companion_getInstance_43().f2h(-32767, -32767, 2147483647, 2147483647);
  }
  f2h(left, top, right, bottom) {
    return AGScissor.i6x(left, top, right - left | 0, bottom - top | 0);
  }
  j6x(left, top, right, bottom) {
    return AGScissor.k6x(left, top, right - left, bottom - top);
  }
  l6x(rect) {
    if (rect == null)
      return this.e6o_1;
    if (rect.m29())
      return this.e6o_1;
    return AGScissor.m6x(rect.h29_1, rect.i29_1, rect.j29_1, rect.k29_1);
  }
  n6x(prev, next) {
    if (prev.equals(this.e6o_1))
      return next;
    if (next.equals(this.e6o_1))
      return prev;
    var intersectsX = prev.o29() <= next.p29() && prev.p29() >= next.o29();
    var intersectsY = prev.q29() <= next.r29() && prev.r29() >= next.q29();
    if (!intersectsX || !intersectsY)
      return this.b6o_1;
    // Inline function 'kotlin.math.max' call
    var a = prev.o29();
    var b = next.o29();
    var left = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = prev.q29();
    var b_0 = next.q29();
    var top = Math.max(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = prev.p29();
    var b_1 = next.p29();
    var right = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.min' call
    var a_2 = prev.r29();
    var b_2 = next.r29();
    var bottom = Math.min(a_2, b_2);
    return this.f2h(left, top, right, bottom);
  }
}
class AGScissor {
  static o6x(_left, _top, _right, _bottom) {
    Companion_getInstance_43();
    var $this = createThis(this);
    $this.e6x_1 = _left;
    $this.f6x_1 = _top;
    $this.g6x_1 = _right;
    $this.h6x_1 = _bottom;
    return $this;
  }
  m29() {
    return this.equals(Companion_getInstance_43().e6o_1);
  }
  static i6x(x, y, width, height) {
    Companion_getInstance_43();
    return this.o6x(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static k6x(x, y, width, height) {
    Companion_getInstance_43();
    return this.i6x(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static m6x(x, y, width, height) {
    Companion_getInstance_43();
    return this.i6x(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  o29() {
    return this.e6x_1;
  }
  q29() {
    return this.f6x_1;
  }
  p29() {
    return this.g6x_1;
  }
  r29() {
    return this.h6x_1;
  }
  w6h() {
    return this.o29();
  }
  x6h() {
    return this.q29();
  }
  k2l() {
    return this.p29() - this.o29() | 0;
  }
  l2l() {
    return this.r29() - this.q29() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_43().e6o_1))
      return 'null';
    return 'Scissor(x=' + this.w6h() + ', y=' + this.x6h() + ', width=' + this.k2l() + ', height=' + this.l2l() + ')';
  }
  p6x() {
    return this.m29() ? Companion_getInstance_5().w29() : Companion_getInstance_5().b2h(this.w6h(), this.x6h(), this.k2l(), this.l2l());
  }
  q6x() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.p6x();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.n29()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.e6x_1;
    result = imul(result, 31) + this.f6x_1 | 0;
    result = imul(result, 31) + this.g6x_1 | 0;
    result = imul(result, 31) + this.h6x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.e6x_1 === tmp0_other_with_cast.e6x_1))
      return false;
    if (!(this.f6x_1 === tmp0_other_with_cast.f6x_1))
      return false;
    if (!(this.g6x_1 === tmp0_other_with_cast.g6x_1))
      return false;
    if (!(this.h6x_1 === tmp0_other_with_cast.h6x_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.s6x_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.t6x_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.u6x_1 = frameBuffer;
    this.v6x_1 = frameBufferInfo;
    this.w6x_1 = color;
    this.x6x_1 = depth;
    this.y6x_1 = stencil;
    this.z6x_1 = clearColor;
    this.a6y_1 = clearDepth;
    this.b6y_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.u6x_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.v6x_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.w6x_1) + ', depth=' + this.x6x_1 + ', stencil=' + this.y6x_1 + ', clearColor=' + this.z6x_1 + ', clearDepth=' + this.a6y_1 + ', clearStencil=' + this.b6y_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.u6x_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.v6x_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.w6x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x6x_1) | 0;
    result = imul(result, 31) + this.y6x_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z6x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a6y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b6y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.u6x_1, tmp0_other_with_cast.u6x_1))
      return false;
    if (!equals(this.v6x_1, tmp0_other_with_cast.v6x_1))
      return false;
    if (!(this.w6x_1 === tmp0_other_with_cast.w6x_1))
      return false;
    if (!equals(this.x6x_1, tmp0_other_with_cast.x6x_1))
      return false;
    if (!(this.y6x_1 === tmp0_other_with_cast.y6x_1))
      return false;
    if (!(this.z6x_1 === tmp0_other_with_cast.z6x_1))
      return false;
    if (!(this.a6y_1 === tmp0_other_with_cast.a6y_1))
      return false;
    if (!(this.b6y_1 === tmp0_other_with_cast.b6y_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.p6n_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.q6n_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_45();
    this.c6y_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.c6y_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.c6y_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.c6y_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.r6n_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.s6n_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_56().g6y_1), Companion_getInstance_55().t6y_1, Companion_getInstance_55().t6y_1, Companion_getInstance_55().t6y_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_46();
    this.w6y_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.w6y_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.w6y_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.w6y_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.t6n_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.u6n_1 = _AGColorMask___init__impl__j38ai8_1();
    this.v6n_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.w6n_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.x6n_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.y6n_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class AGColorMask {
  constructor(data) {
    Companion_getInstance_47();
    this.a6z_1 = data;
  }
  toString() {
    return AGColorMask__toString_impl_5i5oqg(this.a6z_1);
  }
  hashCode() {
    return AGColorMask__hashCode_impl_g9082f(this.a6z_1);
  }
  equals(other) {
    return AGColorMask__equals_impl_mrih8l(this.a6z_1, other);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.z6n_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.a6o_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_56().g6y_1), Companion_getInstance_57().b6z_1);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.f6o_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.g6o_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.h6o_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.i6o_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.j6o_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGCullFace {
  constructor(ordinal) {
    Companion_getInstance_49();
    this.e6z_1 = ordinal;
  }
  toString() {
    return AGCullFace__toString_impl_7d891w(this.e6z_1);
  }
  hashCode() {
    return AGCullFace__hashCode_impl_t4e5ur(this.e6z_1);
  }
  equals(other) {
    return AGCullFace__equals_impl_wgngjr(this.e6z_1, other);
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.o6v([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_41().e6n_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().y6z_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_58().m6n_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_31.o6n() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_42().i6n_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().s6n_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_45().q6n_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_47().v6n_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().a6o_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_43().e6o_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_49().g6o_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_40().f6w_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.u6o_1 = frameBuffer;
    this.v6o_1 = frameBufferInfo;
    this.w6o_1 = vertexData;
    this.x6o_1 = indices;
    this.y6o_1 = indexType;
    this.z6o_1 = program;
    this.a6p_1 = uniformBlocks;
    this.b6p_1 = textureUnits;
    this.c6p_1 = blending;
    this.d6p_1 = stencilOpFunc;
    this.e6p_1 = stencilRef;
    this.f6p_1 = colorMask;
    this.g6p_1 = depthAndFrontFace;
    this.h6p_1 = scissor;
    this.i6p_1 = cullFace;
    this.j6p_1 = drawType;
    this.k6p_1 = drawOffset;
    this.l6p_1 = vertexCount;
    this.m6p_1 = instances;
  }
  t6o(ag) {
    ag.y6m(this.u6o_1, this.v6o_1, this.w6o_1, this.z6o_1, this.j6p_1, this.l6p_1, this.x6o_1, this.y6o_1, this.k6p_1, this.c6p_1, this.a6p_1, this.b6p_1, this.e6p_1, this.d6p_1, this.f6p_1, this.g6p_1, this.h6p_1, this.i6p_1, this.m6p_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.u6o_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.v6o_1) + ', vertexData=' + this.w6o_1.toString() + ', indices=' + toString_1(this.x6o_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.y6o_1) + ', program=' + this.z6o_1.toString() + ', uniformBlocks=' + toString(this.a6p_1) + ', textureUnits=' + this.b6p_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.c6p_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.d6p_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.e6p_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.f6p_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.g6p_1) + ', scissor=' + this.h6p_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.i6p_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.j6p_1) + ', drawOffset=' + this.k6p_1 + ', vertexCount=' + this.l6p_1 + ', instances=' + this.m6p_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.u6o_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.v6o_1) | 0;
    result = imul(result, 31) + this.w6o_1.hashCode() | 0;
    result = imul(result, 31) + (this.x6o_1 == null ? 0 : hashCode(this.x6o_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.y6o_1) | 0;
    result = imul(result, 31) + this.z6o_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.a6p_1) | 0;
    result = imul(result, 31) + this.b6p_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.c6p_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.d6p_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.e6p_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.f6p_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.g6p_1) | 0;
    result = imul(result, 31) + this.h6p_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.i6p_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.j6p_1) | 0;
    result = imul(result, 31) + this.k6p_1 | 0;
    result = imul(result, 31) + this.l6p_1 | 0;
    result = imul(result, 31) + this.m6p_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.u6o_1, tmp0_other_with_cast.u6o_1))
      return false;
    if (!equals(this.v6o_1, tmp0_other_with_cast.v6o_1))
      return false;
    if (!this.w6o_1.equals(tmp0_other_with_cast.w6o_1))
      return false;
    if (!equals(this.x6o_1, tmp0_other_with_cast.x6o_1))
      return false;
    if (!(this.y6o_1 === tmp0_other_with_cast.y6o_1))
      return false;
    if (!this.z6o_1.equals(tmp0_other_with_cast.z6o_1))
      return false;
    if (!equals(this.a6p_1, tmp0_other_with_cast.a6p_1))
      return false;
    if (!this.b6p_1.equals(tmp0_other_with_cast.b6p_1))
      return false;
    if (!(this.c6p_1 === tmp0_other_with_cast.c6p_1))
      return false;
    if (!(this.d6p_1 === tmp0_other_with_cast.d6p_1))
      return false;
    if (!equals(this.e6p_1, tmp0_other_with_cast.e6p_1))
      return false;
    if (!(this.f6p_1 === tmp0_other_with_cast.f6p_1))
      return false;
    if (!(this.g6p_1 === tmp0_other_with_cast.g6p_1))
      return false;
    if (!this.h6p_1.equals(tmp0_other_with_cast.h6p_1))
      return false;
    if (!(this.i6p_1 === tmp0_other_with_cast.i6p_1))
      return false;
    if (!(this.j6p_1 === tmp0_other_with_cast.j6p_1))
      return false;
    if (!(this.k6p_1 === tmp0_other_with_cast.k6p_1))
      return false;
    if (!(this.l6p_1 === tmp0_other_with_cast.l6p_1))
      return false;
    if (!(this.m6p_1 === tmp0_other_with_cast.m6p_1))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.e6s_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.f6s_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.g6s_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.h6s_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_50();
    this.j6s_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.j6s_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.j6s_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.j6s_1, other);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.d6t_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.e6t_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.f6t_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_51();
    this.a70_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.a70_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.a70_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.a70_1, other);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.n6w_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.o6w_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.p6w_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.q6w_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.r6w_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.s6w_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.t6w_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.u6w_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.v6w_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.w6w_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_52();
    this.b70_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.b70_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.b70_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.b70_1, other);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.a6x_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.b6x_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.c6x_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_53();
    this.c70_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.c70_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.c70_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.c70_1, other);
  }
}
class Companion_39 {
  d70() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  r6x(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_49 = this;
    this.o6y_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.p6y_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.q6y_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.r6y_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.s6y_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.t6y_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.u6y_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.v6y_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_55();
    this.e70_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.e70_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.e70_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.e70_1, other);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.g6y_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.h6y_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.i6y_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.j6y_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.k6y_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.l6y_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.m6y_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.n6y_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_56();
    this.f70_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.f70_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.f70_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.f70_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.b6z_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.c6z_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.d6z_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.s6o_1 = list;
  }
  t6o(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.s6o_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).t6o(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.s6o_1) + ')';
  }
  hashCode() {
    return hashCode(this.s6o_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.s6o_1, tmp0_other_with_cast.s6o_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.g70_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.g70_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.g70_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.g70_1 === tmp0_other_with_cast.g70_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_9().q15(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_9().q15(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_9().q15(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.h70_1 = texturesCount;
    this.i70_1 = texturesMemory;
    this.j70_1 = buffersCount;
    this.k70_1 = buffersMemory;
    this.l70_1 = frameBuffersCount;
    this.m70_1 = frameBuffersMemory;
    this.n70_1 = texturesCreated;
    this.o70_1 = texturesDeleted;
    this.p70_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.h70_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.i70_1) + ', buffers[' + this.j70_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.k70_1) + ', frameBuffers[' + this.l70_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.m70_1) + ', programs[' + this.p70_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.e6v_1 = fixedLocation;
    this.f6v_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.g6v_1 = ArrayList.i1();
    this.h6v_1 = 0;
  }
  l3() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  j71() {
    return this.g6v_1;
  }
  k71() {
    return this.f6v_1.e1();
  }
  l71() {
    return nextMultipleOf(this.k71(), 256);
  }
  m71() {
    return this.j71().e1();
  }
  n71(name) {
    return this.s71(name, VarType_Float1_getInstance(), 4, 4);
  }
  o71(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.n71(name) : $super.n71.call(this, name);
  }
  p71(name) {
    return this.s71(name, VarType_Float4_getInstance(), 16, 16);
  }
  q71(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.p71(name) : $super.p71.call(this, name);
  }
  r71(name) {
    return this.s71(name, VarType_Mat4_getInstance(), 64, 16);
  }
  w70(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.r71(name) : $super.r71.call(this, name);
  }
  s71(name, type, size, align) {
    var tmp = this.f6v_1.x7g(size, align);
    var _unary__edvuaz = this.h6v_1;
    this.h6v_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.j71(), ', ') + ', fixedLocation=' + this.e6v_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    this.u70_1 = this.w70().g71(this, u_ProjMat$factory());
    this.v70_1 = this.w70().g71(this, u_ViewMat$factory());
  }
  h71() {
    return this.u70_1.ho(this, u_ProjMat$factory_0());
  }
  i71() {
    return this.v70_1.ho(this, u_ViewMat$factory_0());
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    this.f6z_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).v71(this, u_Tex$factory());
    this.g6z_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).v71(this, u_TexEx$factory());
    this.h6z_1 = Attribute.m72('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.i6z_1 = Attribute.m72('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.j6z_1 = Attribute.m72('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.k6z_1 = Varying.y72('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.l6z_1 = Varying.y72('v_Col', VarType_Float4_getInstance());
    this.m6z_1 = Temp.k73(0, VarType_Float4_getInstance());
    this.n6z_1 = Temp.k73(1, VarType_Float4_getInstance());
    this.o6z_1 = Temp.k73(2, VarType_Mat2_getInstance());
    this.p6z_1 = ProgramLayout.x6v([this.h6z_1, this.i6z_1, this.j6z_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.s73(builder.o73(), builder.p73());
    builder.s73(builder.t73(), builder.u73());
    builder.s73(builder.v73(), builder.w73(builder.w73(builder.h71(), builder.i71()), builder.z73([builder.x73(), builder.y73(0.0), builder.y73(1.0)])));
    tmp.q6z_1 = VertexShader(builder.a74());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.n73();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.b74(this_0.o73(), 'xy');
    this_0.s73(this_0.v73(), this_0.w73(this_0.d74(this_0.c74(), coords), this_0.f74(this_0.d74(DefaultShaders_getInstance().e74(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.a74());
    tmp_0.r6z_1 = new Program(this.q6z_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.s73(builder_0.v73(), builder_0.z73([builder_0.y73(1.0), builder_0.y73(1.0), builder_0.y73(0.0), builder_0.y73(1.0)]));
    tmp_1.s6z_1 = FragmentShader(builder_0.a74());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.s73(builder_1.v73(), builder_1.t73());
    tmp_2.t6z_1 = FragmentShader(builder_1.a74());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.s73(builder_2.v73(), builder_2.w73(builder_2.b74(builder_2.d74(builder_2.c74(), builder_2.b74(builder_2.o73(), 'xy')), 'rgba'), builder_2.t73()));
    var tmp$ret$5 = FragmentShader(builder_2.a74());
    tmp_3.u6z_1 = new Program(this.q6z_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.s73(builder_3.g74(), builder_3.d74(builder_3.c74(), builder_3.b74(builder_3.o73(), 'xy')));
    builder_3.s73(builder_3.b74(builder_3.g74(), 'rgb'), builder_3.h74(builder_3.b74(builder_3.g74(), 'rgb'), builder_3.b74(builder_3.g74(), 'a')));
    builder_3.s73(builder_3.v73(), builder_3.w73(builder_3.b74(builder_3.g74(), 'rgba'), builder_3.t73()));
    var tmp$ret$6 = FragmentShader(builder_3.a74());
    tmp_4.v6z_1 = new Program(this.q6z_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.w6z_1 = new Program(this.q6z_1, this.t6z_1, 'PROGRAM_SOLID_COLOR');
    this.x6z_1 = ProgramLayout.x6v([this.h6z_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.s73(builder_4.v73(), builder_4.z73([builder_4.x73(), builder_4.y73(0.0), builder_4.y73(1.0)]));
    var tmp_6 = VertexShader(builder_4.a74());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.s73(builder_5.v73(), builder_5.z73([builder_5.y73(1.0), builder_5.y73(0.0), builder_5.y73(0.0), builder_5.y73(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.a74());
    tmp_5.y6z_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.s73(builder_6.v73(), builder_6.w73(builder_6.w73(builder_6.h71(), builder_6.i71()), builder_6.z73([builder_6.x73(), builder_6.y73(0.0), builder_6.y73(1.0)])));
    var tmp_8 = VertexShader(builder_6.a74());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.s73(builder_7.v73(), builder_7.z73([builder_7.y73(1.0), builder_7.y73(0.0), builder_7.y73(0.0), builder_7.y73(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.a74());
    tmp_7.z6z_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  c74() {
    return this.f6z_1.ho(this, u_Tex$factory_0());
  }
  e74() {
    return this.g6z_1.ho(this, u_TexEx$factory_0());
  }
  h71() {
    return ProjViewUB_getInstance().h71().d6v_1;
  }
  i71() {
    return ProjViewUB_getInstance().i71().d6v_1;
  }
}
class VarTypeAccessor {}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function atan(y, x) {
  return Func.p7q('atan', [y, x], y.v2c());
}
function texture2D(sampler, coord) {
  return Func.p7q('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.b7q(cond, otrue, ofalse);
}
function pow(b, e) {
  return Func.p7q('pow', [b, e], b.v2c());
}
function sqrt(v) {
  return Func.p7q('sqrt', [v], v.v2c());
}
function abs(v) {
  return Func.p7q('abs', [v], v.v2c());
}
function fract(v) {
  return Func.p7q('fract', [v], v.v2c());
}
function clamp(v, min, max) {
  return Func.p7q('clamp', [v, min, max], v.v2c());
}
function min_0(a, b) {
  return Func.p7q('min', [a, b], a.v2c());
}
function max_1(a, b) {
  return Func.p7q('max', [a, b], a.v2c());
}
function fwidth(a) {
  return Func.p7q('fwidth', [a], a.v2c());
}
function mix(a, b, step) {
  return Func.p7q('mix', [a, b, step], a.v2c());
}
function smoothstep(a, b, c) {
  return Func.p7q('smoothstep', [a, b, c], a.v2c());
}
function length(a) {
  return Func.p7q('length', [a], VarType_Float1_getInstance());
}
function get_lit(_this__u8e3s4) {
  return FloatLiteral.f7q(_this__u8e3s4);
}
function vec2(ops) {
  return Vector.g7q(VarType_Float2_getInstance(), ops);
}
function vec4(ops) {
  return Vector.g7q(VarType_Float4_getInstance(), ops);
}
function get_1(_this__u8e3s4, swizzle) {
  return Swizzle.h7q(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.b74(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.b74(_this__u8e3s4, 'y');
}
function get_z(_this__u8e3s4) {
  return this.b74(_this__u8e3s4, 'z');
}
function get_w(_this__u8e3s4) {
  return this.b74(_this__u8e3s4, 'w');
}
function get_a(_this__u8e3s4) {
  return this.b74(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.d7q('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '==', that);
}
function lt(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '<', that);
}
function le(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.e7q(_this__u8e3s4, '>', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.r75(this.y73(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.s75(this.y73(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.w73(this.y73(_this__u8e3s4), that);
}
function plus_4(_this__u8e3s4, that) {
  return this.s75(_this__u8e3s4, this.y73(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.w75(_this__u8e3s4, this.y73(that));
}
class Builder {
  static i74(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.q73_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r73_1 = ArrayList.i1();
    return $this;
  }
  static x7o(parent) {
    return this.i74(parent.q73_1);
  }
  j74() {
    return Builder.x7o(this);
  }
  k74() {
    return FuncBuilder.w7o(this);
  }
  l74() {
    return new Stms(toList(this.r73_1));
  }
  m74() {
    var funcs = LinkedHashMap.hc();
    (new Program$Builder$_funcs$1(funcs)).a7q(this.r73_1);
    var _iterator__ex2g4s = this.q73_1.s7q_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.set' call
      var key = func.b7m_1;
      funcs.b3(key, func);
    }
    return toList(funcs.f3());
  }
  a74() {
    return to(this.l74(), this.m74());
  }
  n74(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.k74();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.u7o_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.y78_1, item.v2c());
      destination.h(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.l74());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.q73_1.s7q_1.h(this_2);
    return this_2;
  }
  o74(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  p74(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.o74(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.o74;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  q74(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  r74(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.q74(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.q74;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  s74(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  t74(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.s74(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.s74;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  u74(type) {
    var _receiver__tnumb7 = this.q73_1;
    var _unary__edvuaz = _receiver__tnumb7.t7q_1;
    _receiver__tnumb7.t7q_1 = _unary__edvuaz + 1 | 0;
    return Temp.k73(_unary__edvuaz, type);
  }
  k7p(initialValue) {
    var temp = this.u74(initialValue.v2c());
    this.s73(temp, initialValue);
    return temp;
  }
  v74(_this__u8e3s4, p0) {
    return CustomFunc.q7q(_this__u8e3s4, listOf(p0));
  }
  w74(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.q7q(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  x74(_this__u8e3s4, callback) {
    var body = this.j74();
    callback(body);
    _this__u8e3s4.o7n_1 = body.l74();
  }
  y74(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.t75(ref, this.y73(min));
      var body = this.j74();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.l74());
      // Inline function 'kotlin.collections.plusAssign' call
      this.r73_1.h(stmIf);
      var tmp = stmIf;
      this.x74(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.v75(ref, this.y73(middle));
      var body_0 = this.j74();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.y74(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.l74());
      // Inline function 'kotlin.collections.plusAssign' call
      this.r73_1.h(stmIf_0);
      var tmp_0 = stmIf_0;
      this.x74(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  z74(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.t75(ref, this.y73(min));
      var body = this.j74();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_LIST.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.l74());
      // Inline function 'kotlin.collections.plusAssign' call
      this.r73_1.h(stmIf);
      var tmp = stmIf;
      this.x74(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  }
  s73(target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.r73_1;
    var element = new Set(target, expr);
    this_0.h(element);
  }
  a75() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.r73_1;
    var element = Discard_getInstance();
    this_0.h(element);
  }
  b75(operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.r73_1;
    var element = new Return(operand);
    this_0.h(element);
  }
  c75(operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.b75(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.b75.call(this, operand);
    }
    return tmp;
  }
  d75(type) {
    var _receiver__tnumb7 = this.q73_1;
    var _unary__edvuaz = _receiver__tnumb7.t7q_1;
    _receiver__tnumb7.t7q_1 = _unary__edvuaz + 1 | 0;
    return Temp.u7q(_unary__edvuaz, type, 1);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().c74();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().h71();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().i71();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().h6z_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().i6z_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().j6z_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().k6z_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().l6z_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().m6z_1;
}
function get_t_Temp1() {
  return DefaultShaders_getInstance().n6z_1;
}
class ProgramBuilderDefault extends Builder {
  static n73() {
    return this.i74();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.y75_1 = vao;
    this.z75_1 = glId;
    this.a76_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  static l76(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.pa('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.k76_1);
    $this.d76_1 = str;
    $this.e76_1 = error;
    $this.f76_1 = errorInt;
    $this.g76_1 = gl;
    $this.h76_1 = debugName;
    $this.i76_1 = type;
    $this.j76_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.m79_1 = index;
    this.n79_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.o79_1 = -1;
    this.p79_1 = -1;
    this.q79_1 = -1;
    this.r79_1 = -1;
  }
  v2t() {
    this.n79_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.o79_1 = -1;
    this.p79_1 = -1;
    this.q79_1 = -1;
    this.r79_1 = -1;
  }
}
class AGOpengl extends AG {
  static a7c(gl, context) {
    context = context === VOID ? null : context;
    var $this = this.d6m();
    $this.q76_1 = gl;
    $this.r76_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.s76_1 = LinkedHashSet.h1();
    $this.t76_1 = new GLGlobalState($this.q76_1, $this);
    $this.u76_1 = HashMap.m8();
    $this.v76_1 = null;
    var tmp_0 = $this;
    tmp_0.w76_1 = lazy(AGOpengl$glslConfig$delegate$lambda($this));
    $this.x76_1 = null;
    $this.y76_1 = Companion_getInstance_42().g6n_1;
    $this.z76_1 = Companion_getInstance_49().f6o_1;
    $this.a77_1 = Companion_getInstance_46().r6n_1;
    $this.b77_1 = Companion_getInstance_45().p6n_1;
    $this.c77_1 = Companion_getInstance_47().t6n_1;
    $this.d77_1 = Companion_getInstance_48().z6n_1;
    $this.e77_1 = null;
    $this.f77_1 = AGTextureUnits.d6q();
    $this.g77_1 = new Int32Array($this.f77_1.e1());
    $this.h77_1 = 0;
    $this.i77_1 = Companion_getInstance_43().d6o_1;
    $this.j77_1 = -1;
    $this.k77_1 = -1;
    $this.l77_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    $this.m77_1 = Ref();
    $this.n77_1 = Buffer.m13(36);
    var tmp_1 = $this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.o77_1 = tmp_3;
    $this.p77_1 = allocDirect(Companion_instance_4, 0);
    $this.q77_1 = 7;
    $this.r77_1 = 0;
    $this.s77_1 = Companion_instance_48.d70();
    $this.t77_1 = -1;
    $this.u77_1 = new Long(-1, -1);
    $this.v77_1 = null;
    return $this;
  }
  static b7c(context) {
    return this.a7c(context.d7c_1, context);
  }
  z6m() {
    return this.q76_1;
  }
  t6m() {
    var gl = this.q76_1;
    super.t6m();
    gl.f7c();
    gl.g7c();
    this.u76_1.e3();
    resetObjects(this);
    this.j77_1 = -1;
    this.k77_1 = -1;
    this.l77_1 = true;
  }
  x6m(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.q76_1;
    this.h7c(frameBuffer, frameBufferInfo);
    this.i7c(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.j7c(Companion_getInstance_47().w6n_1);
      gl.k7c(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.l7c(true);
      gl.m7c(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.a77_1 = Companion_getInstance_46().r6n_1;
      gl.n7c(-1);
      gl.o7c(stencil);
      mask = mask | 1024;
    }
    gl.p7c(mask);
  }
  y6m(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.q76_1;
    this.h7c(frameBuffer, frameBufferInfo);
    this.i7c(scissor, frameBuffer, frameBufferInfo);
    var tmp1_safe_receiver = this.x76_1;
    if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l6v_1, vertexData.l6v_1)) {
      var tmp0_safe_receiver = this.x76_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.q7c(tmp0_safe_receiver);
      }
      this.x76_1 = vertexData;
      this.r7c(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.l6v_1.sz_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.z6v_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.s7c(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.y76_1 === blending)) {
      this.y76_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.v7c(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.t7c(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.u7c(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.w7c(depthAndFrontFace);
    this.j7c(colorMask);
    if (!(this.z76_1 === cullFace)) {
      this.z76_1 = cullFace;
      this.x7c(cullFace);
    }
    if (!(this.a77_1 === stencilOpFunc) || !equals(this.b77_1, stencilRef)) {
      this.a77_1 = stencilOpFunc;
      this.b77_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.z7c(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.b7d(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.a7d(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.a7d(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.d7d(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.c7d(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.c7d(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.n7c(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.e7d(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.e7d(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.y7c(2960);
        gl.n7c(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_41().c6n_1;
    if (!(indexType_0 === Companion_getInstance_41().c6n_1))
      if (!(instances === 1)) {
        gl.i7d(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.h7d(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.g7d(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.f7d(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  b78() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w76_1;
    glslConfig$factory();
    return this_0.n1();
  }
  w6m() {
    var gl = this.q76_1;
    var tmp0_safe_receiver = this.r76_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j7d();
    }
    gl.k7d(this.b6m_1);
    resetObjects(this);
    this.h77_1 = getIntegerv(gl, 36006);
    gl.l7b(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.m7b())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.k7b(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.k7b(3553, 33085, 0);
    }
  }
  q6i() {
    var tmp0_safe_receiver = this.x76_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.q7c(tmp0_safe_receiver);
    }
    this.x76_1 = null;
    this.h7c(this.s6m().e6m_1, this.s6m().k6o());
    var tmp1_safe_receiver = this.r76_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.l7d();
    }
  }
  u6m() {
    var tmp0_safe_receiver = this.x76_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.q7c(tmp0_safe_receiver);
    }
    this.x76_1 = null;
    this.q76_1.rc();
    deletePendingObjects(this);
  }
  x7c(face) {
    if (this.q76_1.v7c(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_49().g6o_1))) {
      this.q76_1.m7d(toGl_5(face));
    }
  }
  l7a(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.u6p_1 === _this__u8e3s4.v6p_1)) {
      _this__u8e3s4.u6p_1 = _this__u8e3s4.v6p_1;
      block(_this__u8e3s4);
    }
  }
  q7c(vao) {
    if (this.l77_1 && this.q76_1.b6n()) {
      this.q76_1.p7d(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.l6v_1.sz_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[_unary__edvuaz].y6v_1.p6v_1;
        var n_0 = 0;
        while (n_0 < this_0.e1()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.d1(_unary__edvuaz_0);
          if (att.j72_1) {
            var loc = att.l72_1;
            if (loc >= 0) {
              if (!(att.k72_1 === 0)) {
                this.q76_1.n7d(loc, 0);
              }
              this.q76_1.o7d(loc);
            }
          }
        }
      }
    }
  }
  r7c(vao) {
    var gl = this.q76_1;
    if (this.l77_1 && gl.b6n()) {
      var vaoGl = get_gl(vao);
      if (vao.m6v_1) {
        if (!(this.k77_1 === this.b6m_1)) {
          this.j77_1 = genVertexArray(gl);
          this.k77_1 = this.b6m_1;
          if (this.j77_1 <= 0)
            this.l77_1 = false;
        }
        gl.p7d(this.j77_1);
        this.q7d(vao);
      } else {
        if (!(vaoGl.a76_1 === this.b6m_1)) {
          vaoGl.a76_1 = this.b6m_1;
          vaoGl.z75_1 = genVertexArray(gl);
          if (vaoGl.z75_1 <= 0)
            this.l77_1 = false;
          gl.p7d(vaoGl.z75_1);
          this.q7d(vao);
        }
        gl.p7d(vaoGl.z75_1);
        this.r7d(vao, this.l77_1);
      }
    } else {
      this.q7d(vao);
    }
  }
  r7d(vao, updateBuffersOnly) {
    var gl = this.q76_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.l6v_1.sz_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.z6v_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.m77_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.l6v_1.sz_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.z6v_1;
      var vertexLayout = entry_0.y6v_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.p6v_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.u6v_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.m77_1);
      var totalSize = vertexLayout.w6v_1;
      var inductionVariable = 0;
      var last = vattrspos.e1() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.d1(n_1);
          if (!att.j72_1)
            continue $l$loop;
          var off = vattrspos.d1(n_1);
          var loc = att.l72_1;
          var glElementType = toGl_7(att.v2c());
          var elementCount = att.v2c().w7a_1;
          if (loc >= 0) {
            gl.s7d(loc);
            gl.t7d(loc, elementCount, glElementType, att.i72_1, totalSize, numberToLong(entry_0.a6w_1).r3(toLong(off)));
            if (!(att.k72_1 === 0)) {
              gl.n7d(loc, att.k72_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  q7d(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.r7d(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.r7d.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  s7c(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.e77_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.b6q_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.c6q_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.g6r_1, tex_0)) {
          tex_0 = null;
        }
        var tmp0_safe_receiver = tex_0;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v6p_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if (!(this.f77_1.b6q_1[n] === tex_0) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.f77_1.c6q_1, n) === info) || !(this.g77_1[n] === texVersion)) {
          this.f77_1.f6q(n, tex_0, info);
          this.g77_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.u7d(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.i6s(), wrap, this.v7d(tex_0, linear, trilinear), this.w7d(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.i6s()));
          } else {
            this.u7d(null, Companion_getInstance_50().e6s_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.g78_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.e1();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_0 = uniformBlocks.x7d_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.y7d_1[n_0];
          var valueIndex = uniformBlocks.z7d_1[n_0];
          if (glProgram.g78_1.m78_1.l79()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_0 = buffer_0 == null ? null : buffer_0.i7a_1;
            this.q76_1.a7e(35345, block.k6t_1.e6v_1, tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0, imul(valueIndex, block.n6t_1), block.n6t_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.p78_1[block.k6t_1.e6v_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.k6t_1.e6v_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.a5(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).r6p_1);
          var currentMem = ref.c7e_1;
          var ublock = ref.b7e_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.l71())) {
              arraycopy_0(bufferMem, imul(ublock.l71(), valueIndex), currentMem, 0, ublock.l71());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.j71();
              var n_1 = 0;
              while (n_1 < this_0.e1()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.d1(_unary__edvuaz);
                writeUniform(this, uniform.d6v_1, glProgramInfo, sliceBuffer(currentMem, uniform.a6v_1, uniform.a6v_1 + uniform.s7a_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.k6t_1.toString() + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  v7d(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.y6r_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  w7d(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  f7e(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_43().e6o_1) || scissor.equals(Companion_getInstance_43().c6o_1) ? scissor : frameBuffer.f6r_1 ? Companion_getInstance_43().f2h(scissor.o29(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.r29() | 0, scissor.p29(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.q29() | 0) : scissor;
  }
  u7d(tex, target) {
    var gl = this.q76_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.w7b_1;
    gl.g7e(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.x6r_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.x7b_1 === texBitmap.j3y_1) || !(glTex.y7b_1 === this.b6m_1)) {
        glTex.x7b_1 = texBitmap.j3y_1;
        glTex.y7b_1 = this.b6m_1;
        tex.a6q();
      }
      this.l7a(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  h7c(frameBuffer, info) {
    var gl = this.q76_1;
    if (!(this.s77_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.h7e(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.f6r_1) {
      if (!(this.t77_1 === this.h77_1)) {
        this.t77_1 = this.h77_1;
        gl.i7e(36160, this.h77_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.l7e_1.g6r_1;
    var doMsaa = false;
    if (!equals(fb.o7e_1, info)) {
      fb.o7e_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.x6r_1 = NullBitmap.d4d(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.q77_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.u7d(tex, Companion_getInstance_50().e6s_1);
        textureUnitParameters(this, Companion_getInstance_50().e6s_1, Companion_getInstance_51().d6t_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.u7d(null, Companion_getInstance_50().e6s_1);
        }
        selectTextureUnit(this, old);
      }
      gl.p7e(36161, fb.m7e_1);
      if (!(internalFormat === 0)) {
        gl.q7e(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.p7e(36161, 0);
      gl.i7e(36160, fb.n7e_1);
      gl.r7e(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.l7e_1.g6r_1, this).w7b_1, 0);
      if (!(internalFormat === 0)) {
        gl.s7e(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.m7e_1);
      } else {
        gl.s7e(36160, 36128, 36161, 0);
        gl.s7e(36160, 36096, 36161, 0);
      }
    }
    if (!(this.t77_1 === fb.n7e_1)) {
      this.t77_1 = fb.n7e_1;
      gl.i7e(36160, fb.n7e_1);
    }
  }
  w7c(renderState) {
    var gl = this.q76_1;
    if (!(this.d77_1 === renderState)) {
      this.d77_1 = renderState;
      gl.t7e(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.l7c(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.u7e(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_56().g6y_1);
      if (gl.v7c(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.v7e(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  j7c(colorMask) {
    var gl = this.q76_1;
    if (!(this.c77_1 === colorMask)) {
      this.c77_1 = colorMask;
      gl.w7e(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  i7c(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.q76_1;
    var scissor_0 = this.f7e(scissor, frameBuffer, frameBufferInfo);
    if (!this.i77_1.equals(scissor_0)) {
      this.i77_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_43().e6o_1);
      if (gl.v7c(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.x7e(scissor_0.w6h(), scissor_0.x6h(), scissor_0.k2l(), scissor_0.l2l());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.s79_1 = gl;
    this.t79_1 = ag;
    this.u79_1 = atomic$int$1(0);
    this.v79_1 = atomic$int$1(0);
    this.w79_1 = atomic$ref$1(0.0);
    this.x79_1 = atomic$int$1(0);
    this.y79_1 = atomic$int$1(0);
    this.z79_1 = atomic$ref$1(0.0);
    this.a7a_1 = new Lock();
    this.b7a_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.c7a_1 = globalState;
    this.d7a_1 = this.c7a_1.s79_1;
  }
  e7a() {
  }
  b6t() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.c7a_1.a7a_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.f1x();
      try {
        this.c7a_1.b7a_1.h(this);
        break $l$block;
      }finally {
        this_0.h1x();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.g78_1 = programInfo;
  }
  e7a() {
    this.g78_1.y7e(this.d7a_1);
  }
  h78() {
    this.g78_1.z7e(this.d7a_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.i7a_1 = genBuffer(this.d7a_1);
    this.j7a_1 = -1;
    this.k7a_1 = 0.0;
    this.c7a_1.x79_1.atomicfu$incrementAndGet();
  }
  n7b(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.c7a_1.z79_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLBuffer.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.k7a_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.k7a_1 = value;
  }
  e7a() {
    this.c7a_1.y79_1.atomicfu$incrementAndGet();
    deleteBuffer(this.d7a_1, this.i7a_1);
    this.i7a_1 = -1;
    this.j7a_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.i7a_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.w7b_1 = genTexture(this.d7a_1);
    this.x7b_1 = -2;
    this.y7b_1 = -2;
    this.z7b_1 = 0.0;
    this.c7a_1.u79_1.atomicfu$incrementAndGet();
  }
  n7b(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.c7a_1.w79_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLTexture.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.z7b_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.z7b_1 = value;
  }
  e7a() {
    this.c7a_1.v79_1.atomicfu$incrementAndGet();
    deleteTexture(this.d7a_1, this.w7b_1);
    this.w7b_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.l7e_1 = ag;
    this.m7e_1 = genRenderbuffer(this.d7a_1);
    this.n7e_1 = genFramebuffer(this.d7a_1);
    this.o7e_1 = Companion_getInstance_44().t6x_1;
  }
  e7a() {
    deleteRenderbuffer(this.d7a_1, this.m7e_1);
    deleteFramebuffer(this.d7a_1, this.n7e_1);
    this.m7e_1 = -1;
    this.n7e_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.i78_1 = programId;
    this.j78_1 = vertexId;
    this.k78_1 = fragmentId;
    this.l78_1 = blocks;
    this.m78_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.l78_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.ic(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.e6v_1;
      destination.b3(tmp$ret$0, element);
    }
    tmp.n78_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.l78_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.c1().e6v_1;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.c1().e6v_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.o78_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.o78_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.n78_1.z2(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef.a7f(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.p78_1 = tmp_4;
    this.q78_1 = FastStringMap();
    this.r78_1 = FastStringMap();
  }
  d79(gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.r78_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.b7f(this.i78_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  z7e(gl) {
    gl.c7f(this.i78_1);
  }
  y7e(gl) {
    if (!(this.j78_1 === 0)) {
      gl.d7f(this.j78_1);
    }
    if (!(this.k78_1 === 0)) {
      gl.d7f(this.k78_1);
    }
    if (!(this.i78_1 === 0)) {
      gl.e7f(this.i78_1);
    }
    this.j78_1 = 0;
    this.k78_1 = 0;
    this.i78_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.i78_1 + ', vertexId=' + this.j78_1 + ', fragmentId=' + this.k78_1 + ', blocks=' + toString(this.l78_1) + ', config=' + this.m78_1.toString() + ')';
  }
  hashCode() {
    var result = this.i78_1;
    result = imul(result, 31) + this.j78_1 | 0;
    result = imul(result, 31) + this.k78_1 | 0;
    result = imul(result, 31) + hashCode(this.l78_1) | 0;
    result = imul(result, 31) + this.m78_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.i78_1 === tmp0_other_with_cast.i78_1))
      return false;
    if (!(this.j78_1 === tmp0_other_with_cast.j78_1))
      return false;
    if (!(this.k78_1 === tmp0_other_with_cast.k78_1))
      return false;
    if (!equals(this.l78_1, tmp0_other_with_cast.l78_1))
      return false;
    if (!this.m78_1.equals(tmp0_other_with_cast.m78_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.c78_1 = Companion_getInstance_1().tx('GLShaderCompiler');
  }
  d78(gl, config, program, debugName) {
    var id = gl.j7f();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_61().l7f();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_61().m7f()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.c78_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.d2x(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_61().l7f() + '. used=' + usedGlSlVersion;
        this_0.e2x(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.n7f(VOID, VOID, usedGlSlVersion, item);
      destination.h(tmp$ret$2);
    }
    var _destruct__k2r9zo = this.o7f(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.il();
    var vertexShaderId = _destruct__k2r9zo.jl();
    var finalConfig = _destruct__k2r9zo.qr();
    var _iterator__ex2g4s = program.m6u_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var attr = _iterator__ex2g4s.c1();
      var location = attr.l72_1;
      gl.p7f(id, location, attr.y78_1);
    }
    gl.q7f(id, fragmentShaderId);
    gl.q7f(id, vertexShaderId);
    gl.r7f(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.j6u_1, finalConfig);
  }
  o7f(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.i1();
    var _iterator__ex2g4s = configs.a1();
    $l$loop: while (_iterator__ex2g4s.b1()) {
      var config = _iterator__ex2g4s.c1();
      try {
        var fragmentString = toNewGlslString(program.f6u_1, config);
        var vertexString = toNewGlslString(program.e6u_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.c78_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.d2x(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          this_0.e2x(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.c78_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.d2x(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.e2x(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.h(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator = errors.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.h(tmp$ret$5);
    }
    throw Exception.zd('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  static w7f(size) {
    size = size === VOID ? Size2D.e2a(640, 480) : size;
    var $this = this.d6m();
    $this.s6m().k6r(numberToInt(size.c2a_1), numberToInt(size.d2a_1));
    return $this;
  }
}
class AGBaseLog extends AGDummy {
  static q7g(size) {
    size = size === VOID ? Size2D.e2a(640, 480) : size;
    var $this = this.w7f(size);
    $this.l7g_1 = 0;
    $this.m7g_1 = 0;
    $this.n7g_1 = 0;
    $this.o7g_1 = 0;
    $this.p7g_1 = linkedHashMapOf([]);
    return $this;
  }
  r7g(str, kind) {
  }
  v6m(command) {
    this.r7g(toString(command), Kind_COMMAND_getInstance());
  }
  u6m() {
    return this.r7g('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  static g7g(size) {
    size = size === VOID ? Size2D.e2a(640, 480) : size;
    return this.q7g(size);
  }
  r7g(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.m6n_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_58();
    this.x7d_1 = blocks;
    this.y7d_1 = buffers;
    this.z7d_1 = valueIndices;
  }
  e1() {
    return this.x7d_1.length;
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.x70_1 = block;
    this.y70_1 = name;
    this.z70_1 = voffset;
    this.a71_1 = vindex;
    this.b71_1 = type;
    this.c71_1 = arrayCount;
    this.d71_1 = size;
    this.e71_1 = align;
    var tmp = this;
    tmp.f71_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  t7g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f71_1;
    uniform$factory();
    return this_0.n1();
  }
  g71(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.y70_1;
    tmp.y70_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.t7g();
  }
  toString() {
    return 'Gen(block=' + this.x70_1.toString() + ', name=' + this.y70_1 + ', voffset=' + this.z70_1 + ', vindex=' + this.a71_1 + ', type=' + this.b71_1.toString() + ', arrayCount=' + this.c71_1 + ', size=' + this.d71_1 + ', align=' + this.e71_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x70_1);
    result = imul(result, 31) + (this.y70_1 == null ? 0 : getStringHashCode(this.y70_1)) | 0;
    result = imul(result, 31) + this.z70_1 | 0;
    result = imul(result, 31) + this.a71_1 | 0;
    result = imul(result, 31) + this.b71_1.hashCode() | 0;
    result = imul(result, 31) + this.c71_1 | 0;
    result = imul(result, 31) + this.d71_1 | 0;
    result = imul(result, 31) + this.e71_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.x70_1, tmp0_other_with_cast.x70_1))
      return false;
    if (!(this.y70_1 == tmp0_other_with_cast.y70_1))
      return false;
    if (!(this.z70_1 === tmp0_other_with_cast.z70_1))
      return false;
    if (!(this.a71_1 === tmp0_other_with_cast.a71_1))
      return false;
    if (!this.b71_1.equals(tmp0_other_with_cast.b71_1))
      return false;
    if (!(this.c71_1 === tmp0_other_with_cast.c71_1))
      return false;
    if (!(this.d71_1 === tmp0_other_with_cast.d71_1))
      return false;
    if (!(this.e71_1 === tmp0_other_with_cast.e71_1))
      return false;
    return true;
  }
}
class Operand {
  static c7q(type) {
    var $this = createThis(this);
    $this.m7a_1 = type;
    return $this;
  }
  v2c() {
    return this.m7a_1;
  }
}
class OperandWithArray extends Operand {
  static z7r(type, arrayCount) {
    var $this = this.c7q(type);
    $this.o7a_1 = arrayCount;
    $this.p7a_1 = type.v7a_1;
    $this.q7a_1 = type.w7a_1;
    $this.r7a_1 = imul($this.q7a_1, $this.o7a_1);
    $this.s7a_1 = imul(type.y7a_1, $this.o7a_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static a7r(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.z7r(type, arrayCount);
    $this.y78_1 = name;
    $this.z78_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.y78_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.a79_1 = tmp_1;
    $this.b79_1 = 0;
    $this.c79_1 = null;
    return $this;
  }
  static r7r(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.a7r(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.b79_1 === other.b79_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v2c().equals(other.v2c());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y78_1 === other.y78_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static k7h(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.a7r(name, type, arrayCount, precision);
    $this.j7h_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  static s7g(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.k7h(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.a6v_1 = voffset;
    $this.b6v_1 = vindex;
    $this.c6v_1 = block;
    $this.d6v_1 = Uniform.y7h(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  ho(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.y78_1 + "', offset=" + this.a6v_1 + ', type=' + this.v2c().toString() + ')';
  }
}
class Companion_44 {}
class UniformBlockBuffer {
  constructor(block) {
    this.k6t_1 = block;
    this.l6t_1 = new AGBuffer();
    this.m6t_1 = this.k6t_1.k71();
    this.n6t_1 = this.k6t_1.l71();
    this.o6t_1 = this.k6t_1.j71().e1();
    this.p6t_1 = Buffer.m13(imul(this.n6t_1, 1));
    this.q6t_1 = UniformsRef.z7h(this.k6t_1, this.p6t_1, -1);
    this.r6t_1 = Buffer.m13(this.k6t_1.l71());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.k6t_1) + ')';
  }
  a7i(value) {
    this.q6t_1.d7e_1 = value;
  }
  j6v() {
    return this.q6t_1.d7e_1;
  }
  b7i(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.p6t_1 = copyOf(this.p6t_1, imul(this.n6t_1, newCapacity));
      this.q6t_1.c7e_1 = this.p6t_1;
    }
  }
  v2t() {
    this.a7i(-1);
  }
  t6t() {
    var tmp = this.p6t_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.j6v() + 1 | 0, this.k6t_1.l71());
    var tmp$ret$0 = Math.max(0, b);
    this.l6t_1.y6p(tmp, 0, tmp$ret$0);
    return this;
  }
  c7i() {
    var _unary__edvuaz = this.j6v();
    this.a7i(_unary__edvuaz - 1 | 0);
  }
}
class UBLayoutBuilder {
  constructor() {
    this.u7g_1 = 0;
    this.v7g_1 = 4;
    var tmp = this;
    tmp.w7g_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  e1() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w7g_1;
    size$factory();
    return this_0.n1();
  }
  x7g(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).u7g_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.u7g_1 = this.u7g_1 + size | 0;
    return this_0;
  }
}
class UniformsRef {
  static z7h(block, buffer, index) {
    var $this = createThis(this);
    $this.b7e_1 = block;
    $this.c7e_1 = buffer;
    $this.d7e_1 = index;
    $this.e7e_1 = $this.b7e_1.l71();
    return $this;
  }
  static a7f(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.z7h(block, Buffer.m13(imul(block.l71(), size)), index);
  }
  d7i(uniform) {
    return imul(this.d7e_1, this.e7e_1) + uniform.a6v_1 | 0;
  }
  e7i(ref) {
    arraycopy_0(ref.p6t_1, 0, this.c7e_1, imul(this.d7e_1, this.e7e_1), this.e7e_1);
  }
  f7i(uniform, value) {
    return this.g7i(uniform, value);
  }
  h7i(uniform, value) {
    return this.i7i(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  }
  j7i(uniform, value) {
    return this.i7i(uniform, value.o2k_1, value.p2k_1, value.q2k_1, value.r2k_1);
  }
  k7i(uniform, value) {
    switch (uniform.v2c().k3_1) {
      case 3:
        this.l7i(uniform, value, Companion_getInstance_6().h2f_1);
        break;
      case 2:
        this.m7i(uniform, value, Companion_getInstance_6().h2f_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ud();
    }
  }
  m7i(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.d7i(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.c7e_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.l2g(it);
        var tmp;
        if (true) {
          this_1.q13(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.p13(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  l7i(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.m7i(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.m7i.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
  g7i(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.d7i(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.c7e_1;
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      this_1.q13(byteOffset, value);
      tmp = Unit_instance;
    } else {
      this_1.p13(byteOffset, value);
      tmp = Unit_instance;
    }
  }
  i7i(uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.d7i(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.n7i(this_0, x, y, z, w);
  }
  n7i(index, x, y, z, w) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.c7e_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.q13(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.p13(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.c7e_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.q13(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.p13(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_2 = this.c7e_1;
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      this_2.q13(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      this_2.p13(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_3 = this.c7e_1;
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      this_3.q13(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      this_3.p13(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  }
}
class Companion_45 {
  o7i(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.k3_1, 16));
  }
  p7i(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.o7i(isES, isWebGL, isCore, version, os) : $super.o7i.call(this, isES, isWebGL, isCore, version, os).q7i_1;
  }
  r7i() {
    return Companion_instance_54.p7i(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  s7i(version) {
    return Companion_instance_54.p7i(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.q7i_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.q7i_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.q7i_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.q7i_1, other);
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.l7k_1 = default_0;
  }
  m7k(func) {
    this.n7k(func.e7m_1);
  }
  a7q(stms) {
    var _iterator__ex2g4s = stms.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.n7k(stm);
    }
  }
  n7k(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.o7k(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.r7k(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.p7k(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.q7k(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.s7k(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.u7k(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.t7k(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.v7k(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.w7k(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  o7k(stms) {
    var _iterator__ex2g4s = stms.s7m_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.n7k(stm);
    }
  }
  p7k(stm) {
    this.x7k(stm.m7n_1);
    this.n7k(stm.n7n_1);
    this.n7k(stm.o7n_1);
  }
  q7k(stm) {
    this.a7l(stm.p7n_1);
    this.x7k(stm.q7n_1);
    this.n7k(stm.s7n_1);
  }
  r7k(stm) {
    this.x7k(stm.u7m_1);
    this.x7k(stm.t7m_1);
  }
  s7k(stm) {
  }
  t7k(stm) {
  }
  u7k(stm) {
  }
  v7k(stm) {
    this.n7k(stm.o7m_1);
  }
  w7k(stm) {
    var tmp0_safe_receiver = stm.v7m_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.x7k(tmp0_safe_receiver);
    }
  }
  x7k(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.a7l(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.e7l(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.f7l(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.g7l(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.m7l(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.k7l(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.l7l(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.j7l(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.h7l(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.i7l(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.y7k(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  y7k(func) {
    var _iterator__ex2g4s = func.h7n().a1();
    while (_iterator__ex2g4s.b1()) {
      var op = _iterator__ex2g4s.c1();
      this.x7k(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.z7k(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.k7k(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  z7k(func) {
    return this.l7k_1;
  }
  k7k(func) {
    return this.l7k_1;
  }
  a7l(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.w7j(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.y7j(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.e7k(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.a7k(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.c7k(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.d7l(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.b7l(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.c7l(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  b7l(temp) {
    return this.l7k_1;
  }
  c7l(arg) {
    return this.l7k_1;
  }
  w7j(attribute) {
    return this.l7k_1;
  }
  y7j(varying) {
    return this.l7k_1;
  }
  a7k(uniform) {
    return this.l7k_1;
  }
  e7k(sampler) {
    return this.l7k_1;
  }
  c7k(typedUniform) {
    return this.a7k(typedUniform.d6v_1);
  }
  d7l(output) {
    return this.l7k_1;
  }
  e7l(operand) {
    this.x7k(operand.b7n_1);
    return this.l7k_1;
  }
  f7l(operand) {
    this.x7k(operand.d7n_1);
    this.x7k(operand.f7n_1);
    return this.l7k_1;
  }
  g7l(operand) {
    this.x7k(operand.j7n_1);
    this.x7k(operand.k7n_1);
    this.x7k(operand.l7n_1);
    return this.l7k_1;
  }
  h7l(operand) {
    this.x7k(operand.a7o_1);
    return this.l7k_1;
  }
  i7l(operand) {
    this.x7k(operand.d7o_1);
    this.x7k(operand.e7o_1);
    return this.l7k_1;
  }
  j7l(operand) {
    var indexedObject = operand.y7m_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.x7k(op);
    }
    return this.l7k_1;
  }
  k7l(operand) {
    return this.l7k_1;
  }
  l7l(operand) {
    return this.l7k_1;
  }
  m7l(operand) {
    return this.l7k_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.o7j_1 = LinkedHashSet.h1();
    this.p7j_1 = LinkedHashSet.h1();
    this.q7j_1 = LinkedHashSet.h1();
    this.r7j_1 = LinkedHashSet.h1();
    this.s7j_1 = LinkedHashSet.h1();
    this.t7j_1 = LinkedHashSet.h1();
    this.u7j_1 = LinkedHashSet.h1();
  }
  v7j(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.o7j_1.h(attribute);
  }
  w7j(attribute) {
    this.v7j(attribute);
    return Unit_instance;
  }
  x7j(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.p7j_1.h(varying);
  }
  y7j(varying) {
    this.x7j(varying);
    return Unit_instance;
  }
  z7j(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.q7j_1.h(uniform);
    var tmp0_safe_receiver = uniform.x7h_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.r7j_1.h(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.s7j_1;
    var element = uniform.x7h_1.c6v_1;
    this_0.h(element);
  }
  a7k(uniform) {
    this.z7j(uniform);
    return Unit_instance;
  }
  b7k(typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.q7j_1;
    var element = typedUniform.d6v_1;
    this_0.h(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.r7j_1.h(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.s7j_1;
    var element_0 = typedUniform.c6v_1;
    this_1.h(element_0);
  }
  c7k(typedUniform) {
    this.b7k(typedUniform);
    return Unit_instance;
  }
  d7k(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.t7j_1.h(sampler);
  }
  e7k(sampler) {
    this.d7k(sampler);
    return Unit_instance;
  }
  f7k(func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.u7j_1;
    var element = func.j7k().l3();
    this_0.h(element);
  }
  k7k(func) {
    this.f7k(func);
    return Unit_instance;
  }
}
class Companion_46 {
  constructor() {
    Companion_instance_55 = this;
    this.k7f_1 = Companion_getInstance_1().tx('GlslGenerator');
  }
  l7f() {
    return Companion_getInstance_62().l7f();
  }
  m7f() {
    return Companion_getInstance_62().m7f();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.t7i_1 = generator;
    this.u7i_1 = result;
    this.v7i_1 = attributes;
    this.w7i_1 = uniforms;
    this.x7i_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.t7i_1) + ', result=' + this.u7i_1 + ', attributes=' + toString(this.v7i_1) + ', uniforms=' + toString(this.w7i_1) + ', varyings=' + toString(this.x7i_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.t7i_1);
    result = imul(result, 31) + getStringHashCode(this.u7i_1) | 0;
    result = imul(result, 31) + hashCode(this.v7i_1) | 0;
    result = imul(result, 31) + hashCode(this.w7i_1) | 0;
    result = imul(result, 31) + hashCode(this.x7i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.t7i_1, tmp0_other_with_cast.t7i_1))
      return false;
    if (!(this.u7i_1 === tmp0_other_with_cast.u7i_1))
      return false;
    if (!equals(this.v7i_1, tmp0_other_with_cast.v7i_1))
      return false;
    if (!equals(this.w7i_1, tmp0_other_with_cast.w7i_1))
      return false;
    if (!equals(this.x7i_1, tmp0_other_with_cast.x7i_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.s7l_1 = function_0;
  }
  xi(a, b) {
    return this.s7l_1(a, b);
  }
  compare(a, b) {
    return this.xi(a, b);
  }
  h4() {
    return this.s7l_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.l7m().h79_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.k3_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.k3_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.v7a_1.k3_1) {
        case 0:
          var tmp_1;
          switch (type.w7a_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.w7a_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.w7a_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.o7a_1 === 1) ? '[' + _this__u8e3s4.o7a_1 + ']' : '';
}
function get_IN() {
  return this.l7m().u7l();
}
function get_OUT() {
  return this.l7m().z7l();
}
function get_UNIFORM() {
  return this.l7m().y7l();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_61();
    this.k7j_1 = kind;
    this.l7j_1 = config;
  }
  l7m() {
    return this.l7j_1;
  }
  m7j(shader) {
    return this.m7m(shader.z7i_1, shader.a7j_1);
  }
  m7m(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.k7j_1.equals(ShaderType_FRAGMENT_getInstance()) && this.l7j_1.t7l()) {
      types.p7j_1.h(Varying.y72(this.l7j_1.a7m(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.m7k(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.i1();
    var tmp0_iterator = funcs.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.u7j_1.s2(element.f7m_1.l3())) {
        destination.h(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet.ia();
    var list = ArrayList.i1();
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var e = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.f7m_1.l3();
      if (set.h(key)) {
        list.h(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s = funcs.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      types.m7k(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_11();
    var this_1 = tmp_0.d37(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_62().m7f()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_61().k7f_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.d2x(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.l7j_1.j79_1;
        this_2.e2x(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_61().k7f_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.d2x(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.e2x(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.p7m(Companion_getInstance_62().o7l_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.o7j_1), toList(types.q7j_1), toList(types.p7j_1));
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.n7l_1 = new GlslConfig(Companion_instance_54.r7i(), new Immutable(VOID, VOID, VOID, true));
    this.o7l_1 = 'GLSL';
    this.p7l_1 = 100;
    this.q7l_1 = 'fragColor';
    this.r7l_1 = 'gl_FragColor';
  }
  l7f() {
    var tmp0_safe_receiver = Companion_instance_1.ei('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  }
  m7f() {
    return Companion_instance_1.ei('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_62();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.h79_1 = variant;
    this.i79_1 = features;
    this.j79_1 = glslVersion;
    this.k79_1 = compatibility;
  }
  q7m(name) {
    if (this.k79_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  t7l() {
    if (_GLVariant___get_isES__impl__yezzg8(this.h79_1))
      return this.j79_1 >= 300;
    return !this.k79_1;
  }
  l79() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.t7l() && this.i79_1.a6n();
  }
  u7l() {
    return this.t7l() ? 'in' : 'attribute';
  }
  z7l() {
    return this.t7l() ? 'out' : 'varying';
  }
  y7l() {
    return 'uniform';
  }
  a7m() {
    return this.t7l() ? Companion_getInstance_62().q7l_1 : Companion_getInstance_62().r7l_1;
  }
  r7m(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  n7f(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.h79_1 : variant;
    features = features === VOID ? this.i79_1 : features;
    glslVersion = glslVersion === VOID ? this.j79_1 : glslVersion;
    compatibility = compatibility === VOID ? this.k79_1 : compatibility;
    return $super === VOID ? this.r7m(variant, features, glslVersion, compatibility) : $super.r7m.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.h79_1) + ', features=' + toString(this.i79_1) + ', glslVersion=' + this.j79_1 + ', compatibility=' + this.k79_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.h79_1);
    result = imul(result, 31) + hashCode(this.i79_1) | 0;
    result = imul(result, 31) + this.j79_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k79_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.h79_1 === tmp0_other_with_cast.h79_1))
      return false;
    if (!equals(this.i79_1, tmp0_other_with_cast.i79_1))
      return false;
    if (!(this.j79_1 === tmp0_other_with_cast.j79_1))
      return false;
    if (!(this.k79_1 === tmp0_other_with_cast.k79_1))
      return false;
    return true;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.h7m_1 = kind;
    this.i7m_1 = config;
    this.j7m_1 = LinkedHashSet.h1();
    this.k7m_1 = new Indenter();
  }
  l7m() {
    return this.i7m_1;
  }
  o7k(stms) {
    var _iterator__ex2g4s = stms.s7m_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.n7k(stm);
    }
  }
  r7k(stm) {
    this.k7m_1.w37(this.x7k(stm.t7m_1) + ' = ' + this.x7k(stm.u7m_1) + ';');
  }
  s7k(stm) {
    this.k7m_1.w37('discard;');
  }
  t7k(stm) {
    this.k7m_1.w37('break;');
  }
  u7k(stm) {
    this.k7m_1.w37('continue;');
  }
  w7k(stm) {
    var result = stm.v7m_1;
    if (!(result == null)) {
      this.k7m_1.w37('return ' + this.x7k(result) + ';');
    } else {
      this.k7m_1.w37('return;');
    }
  }
  j7l(operand) {
    var tmp = this.w7l(operand.x7m_1) + '(';
    return tmp + joinToString_0(operand.y7m_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  e7l(operand) {
    return '(' + operand.a7n_1 + '(' + this.x7k(operand.b7n_1) + ')' + ')';
  }
  f7l(operand) {
    return '(' + this.x7k(operand.d7n_1) + ' ' + operand.e7n_1 + ' ' + this.x7k(operand.f7n_1) + ')';
  }
  y7k(func) {
    var tmp = this.i7m_1.q7m(func.l3()) + '(';
    var tmp_0 = func.h7n();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  g7l(ternary) {
    return '((' + this.x7k(ternary.j7n_1) + ') ? (' + this.x7k(ternary.k7n_1) + ') : (' + this.x7k(ternary.l7n_1) + '))';
  }
  p7k(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.k7m_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.x7k(stm.m7n_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.w37(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.x37();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.n7k(stm.n7n_1);
    }finally {
      this_0.y37();
    }
    this_0.w37('}');
    if (!(stm.o7n_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.w37(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.x37();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.n7k(ensureNotNull(stm.o7n_1));
      }finally {
        this_0.y37();
      }
      this_0.w37('}');
    }
  }
  q7k(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.k7m_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.w7l(stm.p7n_1.v2c());
    var loopVar = this.a7l(stm.p7n_1);
    var min = this.x7k(stm.q7n_1);
    var maxExclusive = this.x7k(stm.r7n_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.w37(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.x37();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.n7k(stm.s7n_1);
    }finally {
      this_0.y37();
    }
    this_0.w37('}');
  }
  v7k(stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.k7m_1.w37(stm.p7m(Companion_getInstance_62().o7l_1));
  }
  a7l(operand) {
    super.a7l(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.h7m_1.k3_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.i7m_1.a7m();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.y78_1;
    }
    return tmp;
  }
  b7l(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.j7m_1.h(temp);
    return super.b7l(temp);
  }
  d7l(output) {
    return super.d7l(output);
  }
  k7l(operand) {
    return '' + operand.u7n_1;
  }
  l7l(operand) {
    var str = '' + operand.w7n_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  m7l(operand) {
    return '' + operand.y7n_1;
  }
  h7l(operand) {
    return this.x7k(operand.a7o_1) + '.' + operand.b7o_1;
  }
  i7l(operand) {
    return this.x7k(operand.d7o_1) + '[' + this.x7k(operand.e7o_1) + ']';
  }
}
class ProgramLayout {
  static f7o(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.p6v_1 = items;
    $this.q6v_1 = layoutSize;
    $this.r6v_1 = fixedLocation;
    $this.s6v_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.p6v_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.t2n();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s = this_0.a1();
    while (_iterator__ex2g4s.b1()) {
      var v = _iterator__ex2g4s.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.v2c().v7a_1.i7o_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.z2n(tmp$ret$0);
    }
    tmp.t6v_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.p6v_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.t2n();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s_0 = this_2.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var v_0 = _iterator__ex2g4s_0.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      $this.s6v_1 = !(v_0.j7h_1 == null) ? v_0.j7h_1 : nextAlignedTo($this.s6v_1, v_0.v2c().v7a_1.i7o_1);
      var out = $this.s6v_1;
      $this.s6v_1 = $this.s6v_1 + v_0.v2c().y7a_1 | 0;
      this_3.z2n(out);
    }
    tmp_0.u6v_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.t6v_1);
    tmp_1.v6v_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.q6v_1;
    tmp_2.w6v_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.s6v_1, $this.v6v_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  static x6v(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.f7o(toFastList_0(variables), layoutSize);
  }
  j7o() {
    return joinToString(this.p6v_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.j7o() + ', fixedLocation=' + this.r6v_1 + ']';
  }
  a1() {
    return this.p6v_1.a1();
  }
}
class Attribute extends VariableWithOffset {
  static k7o(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.k7h(name, type, 1, precision, offset);
    $this.i72_1 = normalized;
    $this.j72_1 = active;
    $this.k72_1 = divisor;
    $this.l72_1 = fixedLocation;
    return $this;
  }
  static m72(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.k7o(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  toString() {
    return 'Attribute(' + this.y78_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.b79_1 === other.b79_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.v2c().equals(other.v2c());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.y78_1 === other.y78_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i72_1 === (other instanceof Attribute ? other : THROW_CCE()).i72_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.j7h_1 == other.j7h_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.j72_1 === other.j72_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.i72_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.j7h_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.j72_1) | 0;
    return out;
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.s7m_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.s7m_1) + ')';
  }
  hashCode() {
    return hashCode(this.s7m_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.s7m_1, tmp0_other_with_cast.s7m_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.t7m_1 = to;
    this.u7m_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.t7m_1) + ', from=' + toString(this.u7m_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.t7m_1);
    result = imul(result, 31) + hashCode(this.u7m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.t7m_1, tmp0_other_with_cast.t7m_1))
      return false;
    if (!equals(this.u7m_1, tmp0_other_with_cast.u7m_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.v7m_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.v7m_1) + ')';
  }
  hashCode() {
    return this.v7m_1 == null ? 0 : hashCode(this.v7m_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.v7m_1, tmp0_other_with_cast.v7m_1))
      return false;
    return true;
  }
}
class Break extends Stm {}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.m7n_1 = cond;
    this.n7n_1 = tbody;
    this.o7n_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.m7n_1) + ', tbody=' + toString(this.n7n_1) + ', fbody=' + toString_1(this.o7n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.m7n_1);
    result = imul(result, 31) + hashCode(this.n7n_1) | 0;
    result = imul(result, 31) + (this.o7n_1 == null ? 0 : hashCode(this.o7n_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.m7n_1, tmp0_other_with_cast.m7n_1))
      return false;
    if (!equals(this.n7n_1, tmp0_other_with_cast.n7n_1))
      return false;
    if (!equals(this.o7n_1, tmp0_other_with_cast.o7n_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {}
class Raw extends Stm {
  l7o(name) {
    return this.n7m_1.z2(name);
  }
  m7o(name, default_0) {
    var tmp0_elvis_lhs = this.l7o(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  p7m(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.m7o(name, default_0) : $super.m7o.call(this, name, default_0);
  }
}
class Program$ExpressionBuilder$Companion$INSTANCE$1 {}
class Companion_48 {
  constructor() {
    Companion_instance_57 = this;
    var tmp = this;
    tmp.n7o_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
}
class FuncBuilder extends Builder {
  static w7o(parent) {
    var $this = this.x7o(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.u7o_1 = ArrayList.i1();
    return $this;
  }
  v7o(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.j7p(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.u7o_1.h(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.x7p_1 = decl;
  }
  ho(thisRef, property) {
    var tmp = this.x7p_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.o7o_1 = rettype;
    this.p7o_1 = varTypes;
    this.q7o_1 = builder;
    this.r7o_1 = block;
  }
  v71(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.q7o_1.n74(tmp, this.o7o_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.z7p_1 = $funcs;
    super(Unit_instance, $box);
  }
  f7k(func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.z7p_1;
    var key = func.l3();
    var tmp = func.j7k();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.b3(key, value);
  }
  k7k(func) {
    this.f7k(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  static b7q(cond, otrue, ofalse) {
    var $this = this.c7q(otrue.v2c());
    $this.j7n_1 = cond;
    $this.k7n_1 = otrue;
    $this.l7n_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.j7n_1) + ', otrue=' + toString(this.k7n_1) + ', ofalse=' + toString(this.l7n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.j7n_1);
    result = imul(result, 31) + hashCode(this.k7n_1) | 0;
    result = imul(result, 31) + hashCode(this.l7n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.j7n_1, tmp0_other_with_cast.j7n_1))
      return false;
    if (!equals(this.k7n_1, tmp0_other_with_cast.k7n_1))
      return false;
    if (!equals(this.l7n_1, tmp0_other_with_cast.l7n_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  static d7q(op, right) {
    var $this = this.c7q(right.v2c());
    $this.a7n_1 = op;
    $this.b7n_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.a7n_1 + ', right=' + toString(this.b7n_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.a7n_1);
    result = imul(result, 31) + hashCode(this.b7n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.a7n_1 === tmp0_other_with_cast.a7n_1))
      return false;
    if (!equals(this.b7n_1, tmp0_other_with_cast.b7n_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  static e7q(left, op, right) {
    var $this = this.c7q(left.v2c());
    $this.d7n_1 = left;
    $this.e7n_1 = op;
    $this.f7n_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.d7n_1) + ', op=' + this.e7n_1 + ', right=' + toString(this.f7n_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.d7n_1);
    result = imul(result, 31) + getStringHashCode(this.e7n_1) | 0;
    result = imul(result, 31) + hashCode(this.f7n_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.d7n_1, tmp0_other_with_cast.d7n_1))
      return false;
    if (!(this.e7n_1 === tmp0_other_with_cast.e7n_1))
      return false;
    if (!equals(this.f7n_1, tmp0_other_with_cast.f7n_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {}
class FloatLiteral extends Operand {
  static f7q(value) {
    var $this = this.c7q(VarType_Float1_getInstance());
    $this.w7n_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.w7n_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.w7n_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.w7n_1, tmp0_other_with_cast.w7n_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  static g7q(type, ops) {
    var $this = this.c7q(type);
    $this.x7m_1 = type;
    $this.y7m_1 = ops;
    return $this;
  }
  v2c() {
    return this.x7m_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.x7m_1.equals(other.x7m_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.y7m_1, other.y7m_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.x7m_1.hashCode(), 7) + contentHashCode(this.y7m_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.x7m_1.toString() + ', ops=' + toString(this.y7m_1) + ')';
  }
}
class Swizzle extends Operand {
  static h7q(left, swizzle) {
    var $this = this.c7q(left.v2c().i7q(swizzle.length));
    $this.a7o_1 = left;
    $this.b7o_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.a7o_1) + ', swizzle=' + this.b7o_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a7o_1);
    result = imul(result, 31) + getStringHashCode(this.b7o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.a7o_1, tmp0_other_with_cast.a7o_1))
      return false;
    if (!(this.b7o_1 === tmp0_other_with_cast.b7o_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {}
class BaseFunc extends Operand {
  static j7q(type) {
    return this.c7q(type);
  }
}
class Func extends BaseFunc {
  static o7q(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.j7q(type);
    $this.l7q_1 = name;
    $this.m7q_1 = ops;
    $this.n7q_1 = type;
    return $this;
  }
  l3() {
    return this.l7q_1;
  }
  h7n() {
    return this.m7q_1;
  }
  v2c() {
    return this.n7q_1;
  }
  static p7q(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.o7q(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.l7q_1 + ', ops=' + toString(this.m7q_1) + ', type=' + this.n7q_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.l7q_1);
    result = imul(result, 31) + hashCode(this.m7q_1) | 0;
    result = imul(result, 31) + this.n7q_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.l7q_1 === tmp0_other_with_cast.l7q_1))
      return false;
    if (!equals(this.m7q_1, tmp0_other_with_cast.m7q_1))
      return false;
    if (!this.n7q_1.equals(tmp0_other_with_cast.n7q_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  static q7q(ref, ops) {
    var $this = this.j7q(ref.r7q());
    $this.h7k_1 = ref;
    $this.i7k_1 = ops;
    return $this;
  }
  j7k() {
    return this.h7k_1;
  }
  h7n() {
    return this.i7k_1;
  }
  l3() {
    return this.j7k().l3();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.s7q_1 = ArrayList.i1();
    this.t7q_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.b7j_1 + '-' + fragment.b7j_1 : name;
    this.e6u_1 = vertex;
    this.f6u_1 = fragment;
    this.g6u_1 = name;
    this.h6u_1 = plus_0(this.e6u_1.g7j_1, this.f6u_1.g7j_1);
    this.i6u_1 = plus_0(this.e6u_1.h7j_1, this.f6u_1.h7j_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.i6u_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.c6v_1;
      destination.h(tmp$ret$0);
    }
    tmp.j6u_1 = distinct(destination);
    this.k6u_1 = plus_0(this.e6u_1.j7j_1, this.f6u_1.j7j_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.h6u_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.ic(capacity);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.cl_1, new UniformInProgram(element.cl_1, element.bl_1));
      destination_0.b3(pair.gl_1, pair.hl_1);
    }
    tmp_0.l6u_1 = destination_0;
    this.m6u_1 = plus_0(this.e6u_1.i7j_1, this.f6u_1.i7j_1);
    this.n6u_1 = (imul(this.e6u_1.hashCode(), 11) + imul(this.f6u_1.hashCode(), 7) | 0) + getStringHashCode(this.g6u_1) | 0;
  }
  hashCode() {
    return this.n6u_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.e6u_1.equals(other.e6u_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.f6u_1.equals(other.f6u_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.g6u_1 === other.g6u_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  g6() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.m6u_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.y78_1;
      destination.h(tmp$ret$0);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.h6u_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.y78_1;
      destination_0.h(tmp$ret$3);
    }
    return 'Program(name=' + this.g6u_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  x7q(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  y7q(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.e6u_1 : vertex;
    fragment = fragment === VOID ? this.f6u_1 : fragment;
    name = name === VOID ? this.g6u_1 : name;
    return $super === VOID ? this.x7q(vertex, fragment, name) : $super.x7q.call(this, vertex, fragment, name);
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.y7i_1 = type;
    this.z7i_1 = stm;
    this.a7j_1 = functions;
    this.b7j_1 = name;
    this.c7j_1 = hashCode(this.z7i_1);
    this.d7j_1 = hashCode(this.a7j_1);
    this.e7j_1 = (imul(this.y7i_1.hashCode(), 17) + this.c7j_1 | 0) + imul(this.d7j_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.n7k(this.z7i_1);
    tmp.f7j_1 = this_0;
    this.g7j_1 = this.f7j_1.q7j_1;
    this.h7j_1 = this.f7j_1.r7j_1;
    this.i7j_1 = this.f7j_1.o7j_1;
    this.j7j_1 = this.f7j_1.t7j_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.y7i_1.equals(other.y7i_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.e7j_1 === other.e7j_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.z7i_1, other.z7i_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.a7j_1, other.a7j_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.e7j_1;
  }
  toString() {
    return 'Shader(type=' + this.y7i_1.toString() + ', stm=' + toString(this.z7i_1) + ', functions=' + toString(this.a7j_1) + ', name=' + this.b7j_1 + ')';
  }
}
class Varying extends Variable {
  static z7q(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.a7r(name, type, arrayCount, precision);
  }
  static y72(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.z7q(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.y78_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.b79_1 === other.b79_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v2c().equals(other.v2c());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y78_1 === other.y78_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
  }
}
class Output extends Varying {
  static m7r() {
    Output_instance = null;
    var $this = this.y72('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.b79_1 === other.b79_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v2c().equals(other.v2c());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y78_1 === other.y78_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
  }
}
class Provider {
  constructor(index, stype) {
    this.t71_1 = index;
    this.u71_1 = stype;
  }
  v71(thisRef, property) {
    return Sampler.n7r(property.callableName, this.t71_1, this.u71_1);
  }
}
class Sampler extends Variable {
  static n7r(name, index, stype) {
    var $this = this.r7r(name, stype.q7r_1);
    $this.s6q_1 = index;
    $this.t6q_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.y78_1 + ', ' + this.s6q_1 + ', ' + this.t6q_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.b79_1 === other.b79_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v2c().equals(other.v2c());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y78_1 === other.y78_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
  }
  ho(thisRef, property) {
    return this;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.q7r_1 = vtype;
  }
}
class Uniform extends VariableWithOffset {
  static y7h(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.k7h(name, type, arrayCount, precision, offset);
    $this.x7h_1 = typedUniform;
    if (type.s7r()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.a5(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.y78_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.b79_1 === other.b79_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v2c().equals(other.v2c());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y78_1 === other.y78_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
  }
}
class Companion_49 {
  t7r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  u7r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  v7r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  w7r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  x7r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  y7r(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.v7a_1 = kind;
    this.w7a_1 = elementCount;
    this.x7a_1 = isMatrix;
    this.y7a_1 = imul(this.v7a_1.i7o_1, this.w7a_1);
  }
  i7q(length) {
    var tmp;
    switch (this.v7a_1.k3_1) {
      case 1:
        tmp = Companion_instance_58.t7r(length);
        break;
      case 2:
        tmp = Companion_instance_58.u7r(length);
        break;
      case 3:
        tmp = Companion_instance_58.v7r(length);
        break;
      case 4:
        tmp = Companion_instance_58.w7r(length);
        break;
      case 5:
        tmp = Companion_instance_58.x7r(length);
        break;
      case 6:
        tmp = Companion_instance_58.y7r(length);
        break;
      default:
        throw NotImplementedError.ud();
    }
    return tmp;
  }
  s7r() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Precision extends Enum {}
class Temp extends Variable {
  static u7q(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.a7r('temp' + id, type, arrayCount, precision);
  }
  static k73(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.u7q(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.y78_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.b79_1 === other.b79_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v2c().equals(other.v2c());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y78_1 === other.y78_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.b7m_1 = name;
    this.c7m_1 = rettype;
    this.d7m_1 = args;
    this.e7m_1 = stm;
    this.f7m_1 = this;
  }
  l3() {
    return this.b7m_1;
  }
  r7q() {
    return this.c7m_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.b7m_1 + ', rettype=' + this.c7m_1.toString() + ', args=' + toString(this.d7m_1) + ', stm=' + toString(this.e7m_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.b7m_1);
    result = imul(result, 31) + this.c7m_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.d7m_1) | 0;
    result = imul(result, 31) + hashCode(this.e7m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.b7m_1 === tmp0_other_with_cast.b7m_1))
      return false;
    if (!this.c7m_1.equals(tmp0_other_with_cast.c7m_1))
      return false;
    if (!equals(this.d7m_1, tmp0_other_with_cast.d7m_1))
      return false;
    if (!equals(this.e7m_1, tmp0_other_with_cast.e7m_1))
      return false;
    return true;
  }
}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.i7o_1 = bytesSize;
  }
}
class UniformInProgram {
  constructor(uniform, index) {
    this.a7s_1 = uniform;
    this.b7s_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.a7s_1.toString() + ', index=' + this.b7s_1 + ')';
  }
  hashCode() {
    var result = this.a7s_1.hashCode();
    result = imul(result, 31) + this.b7s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.a7s_1.equals(tmp0_other_with_cast.a7s_1))
      return false;
    if (!(this.b7s_1 === tmp0_other_with_cast.b7s_1))
      return false;
    return true;
  }
}
class Arg extends Variable {
  static j7p(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.a7r(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.y78_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.b79_1 === other.b79_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.v2c().equals(other.v2c());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.o7a_1 === other.o7a_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.y78_1 === other.y78_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.b79_1 + imul(this.v2c().hashCode(), 7) | 0) + imul(getStringHashCode(this.y78_1), 11) | 0;
  }
}
class ShaderType extends Enum {}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.c7s_1 = function_0;
  }
  m19() {
    return this.c7s_1();
  }
  h4() {
    return this.c7s_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.d7s_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.d7s_1());
  }
}
class Companion_50 {
  constructor() {
    this.e7s_1 = 33309;
    this.f7s_1 = 33084;
    this.g7s_1 = 33085;
    this.h7s_1 = 256;
    this.i7s_1 = 1024;
    this.j7s_1 = 16384;
    this.k7s_1 = 0;
    this.l7s_1 = 1;
    this.m7s_1 = 0;
    this.n7s_1 = 1;
    this.o7s_1 = 2;
    this.p7s_1 = 3;
    this.q7s_1 = 4;
    this.r7s_1 = 5;
    this.s7s_1 = 6;
    this.t7s_1 = 0;
    this.u7s_1 = 1;
    this.v7s_1 = 768;
    this.w7s_1 = 769;
    this.x7s_1 = 770;
    this.y7s_1 = 771;
    this.z7s_1 = 772;
    this.a7t_1 = 773;
    this.b7t_1 = 774;
    this.c7t_1 = 775;
    this.d7t_1 = 776;
    this.e7t_1 = 32774;
    this.f7t_1 = 32777;
    this.g7t_1 = 32777;
    this.h7t_1 = 34877;
    this.i7t_1 = 32778;
    this.j7t_1 = 32779;
    this.k7t_1 = 32968;
    this.l7t_1 = 32969;
    this.m7t_1 = 32970;
    this.n7t_1 = 32971;
    this.o7t_1 = 32769;
    this.p7t_1 = 32770;
    this.q7t_1 = 32771;
    this.r7t_1 = 32772;
    this.s7t_1 = 32773;
    this.t7t_1 = 34962;
    this.u7t_1 = 34963;
    this.v7t_1 = 34964;
    this.w7t_1 = 34965;
    this.x7t_1 = 35040;
    this.y7t_1 = 35044;
    this.z7t_1 = 35048;
    this.a7u_1 = 34660;
    this.b7u_1 = 34661;
    this.c7u_1 = 34342;
    this.d7u_1 = 1028;
    this.e7u_1 = 1029;
    this.f7u_1 = 1032;
    this.g7u_1 = 3553;
    this.h7u_1 = 32879;
    this.i7u_1 = 2884;
    this.j7u_1 = 3042;
    this.k7u_1 = 3024;
    this.l7u_1 = 2960;
    this.m7u_1 = 2929;
    this.n7u_1 = 3089;
    this.o7u_1 = 32823;
    this.p7u_1 = 32926;
    this.q7u_1 = 32928;
    this.r7u_1 = 0;
    this.s7u_1 = 1280;
    this.t7u_1 = 1281;
    this.u7u_1 = 1282;
    this.v7u_1 = 1285;
    this.w7u_1 = 2304;
    this.x7u_1 = 2305;
    this.y7u_1 = 2849;
    this.z7u_1 = 33901;
    this.a7v_1 = 33902;
    this.b7v_1 = 2885;
    this.c7v_1 = 2886;
    this.d7v_1 = 2928;
    this.e7v_1 = 2930;
    this.f7v_1 = 2931;
    this.g7v_1 = 2932;
    this.h7v_1 = 2961;
    this.i7v_1 = 2962;
    this.j7v_1 = 2964;
    this.k7v_1 = 2965;
    this.l7v_1 = 2966;
    this.m7v_1 = 2967;
    this.n7v_1 = 2963;
    this.o7v_1 = 2968;
    this.p7v_1 = 34816;
    this.q7v_1 = 34817;
    this.r7v_1 = 34818;
    this.s7v_1 = 34819;
    this.t7v_1 = 36003;
    this.u7v_1 = 36004;
    this.v7v_1 = 36005;
    this.w7v_1 = 2978;
    this.x7v_1 = 3088;
    this.y7v_1 = 3106;
    this.z7v_1 = 3107;
    this.a7w_1 = 3317;
    this.b7w_1 = 3333;
    this.c7w_1 = 3379;
    this.d7w_1 = 3386;
    this.e7w_1 = 3408;
    this.f7w_1 = 3410;
    this.g7w_1 = 3411;
    this.h7w_1 = 3412;
    this.i7w_1 = 3413;
    this.j7w_1 = 3414;
    this.k7w_1 = 3415;
    this.l7w_1 = 10752;
    this.m7w_1 = 32824;
    this.n7w_1 = 32873;
    this.o7w_1 = 32936;
    this.p7w_1 = 32937;
    this.q7w_1 = 32938;
    this.r7w_1 = 32939;
    this.s7w_1 = 34466;
    this.t7w_1 = 34467;
    this.u7w_1 = 4352;
    this.v7w_1 = 4353;
    this.w7w_1 = 4354;
    this.x7w_1 = 33170;
    this.y7w_1 = 5120;
    this.z7w_1 = 5121;
    this.a7x_1 = 5122;
    this.b7x_1 = 5123;
    this.c7x_1 = 5124;
    this.d7x_1 = 5125;
    this.e7x_1 = 5126;
    this.f7x_1 = 5132;
    this.g7x_1 = 6402;
    this.h7x_1 = 6406;
    this.i7x_1 = 6407;
    this.j7x_1 = 6408;
    this.k7x_1 = 6409;
    this.l7x_1 = 6410;
    this.m7x_1 = 32819;
    this.n7x_1 = 32820;
    this.o7x_1 = 33635;
    this.p7x_1 = 35632;
    this.q7x_1 = 35633;
    this.r7x_1 = 34921;
    this.s7x_1 = 36347;
    this.t7x_1 = 36348;
    this.u7x_1 = 35661;
    this.v7x_1 = 35660;
    this.w7x_1 = 34930;
    this.x7x_1 = 36349;
    this.y7x_1 = 35663;
    this.z7x_1 = 35712;
    this.a7y_1 = 35714;
    this.b7y_1 = 35715;
    this.c7y_1 = 35717;
    this.d7y_1 = 35718;
    this.e7y_1 = 35719;
    this.f7y_1 = 35721;
    this.g7y_1 = 35722;
    this.h7y_1 = 35724;
    this.i7y_1 = 35725;
    this.j7y_1 = 512;
    this.k7y_1 = 513;
    this.l7y_1 = 514;
    this.m7y_1 = 515;
    this.n7y_1 = 516;
    this.o7y_1 = 517;
    this.p7y_1 = 518;
    this.q7y_1 = 519;
    this.r7y_1 = 7680;
    this.s7y_1 = 7681;
    this.t7y_1 = 7682;
    this.u7y_1 = 7683;
    this.v7y_1 = 5386;
    this.w7y_1 = 34055;
    this.x7y_1 = 34056;
    this.y7y_1 = 7936;
    this.z7y_1 = 7937;
    this.a7z_1 = 7938;
    this.b7z_1 = 7939;
    this.c7z_1 = 9728;
    this.d7z_1 = 9729;
    this.e7z_1 = 9984;
    this.f7z_1 = 9985;
    this.g7z_1 = 9986;
    this.h7z_1 = 9987;
    this.i7z_1 = 10240;
    this.j7z_1 = 10241;
    this.k7z_1 = 10242;
    this.l7z_1 = 10243;
    this.m7z_1 = 32882;
    this.n7z_1 = 5890;
    this.o7z_1 = 34067;
    this.p7z_1 = 34068;
    this.q7z_1 = 34069;
    this.r7z_1 = 34070;
    this.s7z_1 = 34071;
    this.t7z_1 = 34072;
    this.u7z_1 = 34073;
    this.v7z_1 = 34074;
    this.w7z_1 = 34076;
    this.x7z_1 = 33984;
    this.y7z_1 = 33985;
    this.z7z_1 = 33986;
    this.a80_1 = 33987;
    this.b80_1 = 33988;
    this.c80_1 = 33989;
    this.d80_1 = 33990;
    this.e80_1 = 33991;
    this.f80_1 = 33992;
    this.g80_1 = 33993;
    this.h80_1 = 33994;
    this.i80_1 = 33995;
    this.j80_1 = 33996;
    this.k80_1 = 33997;
    this.l80_1 = 33998;
    this.m80_1 = 33999;
    this.n80_1 = 34000;
    this.o80_1 = 34001;
    this.p80_1 = 34002;
    this.q80_1 = 34003;
    this.r80_1 = 34004;
    this.s80_1 = 34005;
    this.t80_1 = 34006;
    this.u80_1 = 34007;
    this.v80_1 = 34008;
    this.w80_1 = 34009;
    this.x80_1 = 34010;
    this.y80_1 = 34011;
    this.z80_1 = 34012;
    this.a81_1 = 34013;
    this.b81_1 = 34014;
    this.c81_1 = 34015;
    this.d81_1 = 34016;
    this.e81_1 = 10497;
    this.f81_1 = 33071;
    this.g81_1 = 33648;
    this.h81_1 = 35664;
    this.i81_1 = 35665;
    this.j81_1 = 35666;
    this.k81_1 = 35667;
    this.l81_1 = 35668;
    this.m81_1 = 35669;
    this.n81_1 = 35670;
    this.o81_1 = 35671;
    this.p81_1 = 35672;
    this.q81_1 = 35673;
    this.r81_1 = 35674;
    this.s81_1 = 35675;
    this.t81_1 = 35676;
    this.u81_1 = 35678;
    this.v81_1 = 35680;
    this.w81_1 = 34338;
    this.x81_1 = 34339;
    this.y81_1 = 34340;
    this.z81_1 = 34341;
    this.a82_1 = 34922;
    this.b82_1 = 34373;
    this.c82_1 = 34975;
    this.d82_1 = 35738;
    this.e82_1 = 35739;
    this.f82_1 = 35713;
    this.g82_1 = 35716;
    this.h82_1 = 35720;
    this.i82_1 = 36346;
    this.j82_1 = 36344;
    this.k82_1 = 36345;
    this.l82_1 = 36336;
    this.m82_1 = 36337;
    this.n82_1 = 36338;
    this.o82_1 = 36339;
    this.p82_1 = 36340;
    this.q82_1 = 36341;
    this.r82_1 = 36160;
    this.s82_1 = 36161;
    this.t82_1 = 32854;
    this.u82_1 = 32855;
    this.v82_1 = 36194;
    this.w82_1 = 33189;
    this.x82_1 = 6401;
    this.y82_1 = 36168;
    this.z82_1 = 36162;
    this.a83_1 = 36163;
    this.b83_1 = 36164;
    this.c83_1 = 36176;
    this.d83_1 = 36177;
    this.e83_1 = 36178;
    this.f83_1 = 36179;
    this.g83_1 = 36180;
    this.h83_1 = 36181;
    this.i83_1 = 36048;
    this.j83_1 = 36049;
    this.k83_1 = 36050;
    this.l83_1 = 36051;
    this.m83_1 = 36064;
    this.n83_1 = 36096;
    this.o83_1 = 33306;
    this.p83_1 = 34041;
    this.q83_1 = 36128;
    this.r83_1 = 0;
    this.s83_1 = 36053;
    this.t83_1 = 36054;
    this.u83_1 = 36055;
    this.v83_1 = 36057;
    this.w83_1 = 36061;
    this.x83_1 = 36006;
    this.y83_1 = 36007;
    this.z83_1 = 34024;
    this.a84_1 = 1286;
    this.b84_1 = 37120;
    this.c84_1 = 34836;
    this.d84_1 = 3313;
    this.e84_1 = 3314;
    this.f84_1 = 3316;
    this.g84_1 = 3315;
    this.h84_1 = 3312;
    this.i84_1 = 37441;
    this.j84_1 = 36197;
    this.k84_1 = 35345;
    this.l84_1 = 35368;
    this.m84_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.w77_1 = new Mixin();
    this.x77_1 = new ContextInfo();
    this.y77_1 = null;
    var tmp = this;
    tmp.z77_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  l7b(texture) {
    throw NotImplementedError.ud();
  }
  q7f(program, shader) {
    throw NotImplementedError.ud();
  }
  p7f(program, index, name) {
    throw NotImplementedError.ud();
  }
  f7a(target, buffer) {
    throw NotImplementedError.ud();
  }
  i7e(target, framebuffer) {
    throw NotImplementedError.ud();
  }
  p7e(target, renderbuffer) {
    throw NotImplementedError.ud();
  }
  g7e(target, texture) {
    throw NotImplementedError.ud();
  }
  t7c(modeRGB, modeAlpha) {
    throw NotImplementedError.ud();
  }
  u7c(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw NotImplementedError.ud();
  }
  p7b(target, size, data, usage) {
    throw NotImplementedError.ud();
  }
  o7b(target, offset, size, data) {
    throw NotImplementedError.ud();
  }
  p7c(mask) {
    throw NotImplementedError.ud();
  }
  k7c(red, green, blue, alpha) {
    throw NotImplementedError.ud();
  }
  m7c(d) {
    throw NotImplementedError.ud();
  }
  o7c(s) {
    throw NotImplementedError.ud();
  }
  w7e(red, green, blue, alpha) {
    throw NotImplementedError.ud();
  }
  h7f(shader) {
    throw NotImplementedError.ud();
  }
  j7f() {
    throw NotImplementedError.ud();
  }
  f7f(type) {
    throw NotImplementedError.ud();
  }
  m7d(mode) {
    throw NotImplementedError.ud();
  }
  n84(n, items) {
    throw NotImplementedError.ud();
  }
  o84(n, items) {
    throw NotImplementedError.ud();
  }
  e7f(program) {
    throw NotImplementedError.ud();
  }
  p84(n, items) {
    throw NotImplementedError.ud();
  }
  d7f(shader) {
    throw NotImplementedError.ud();
  }
  q84(n, items) {
    throw NotImplementedError.ud();
  }
  v7e(func) {
    throw NotImplementedError.ud();
  }
  l7c(flag) {
    throw NotImplementedError.ud();
  }
  u7e(n, f) {
    throw NotImplementedError.ud();
  }
  y7c(cap) {
    throw NotImplementedError.ud();
  }
  o7d(index) {
    throw NotImplementedError.ud();
  }
  f7d(mode, first, count) {
    throw NotImplementedError.ud();
  }
  h7d(mode, count, type, indices) {
    throw NotImplementedError.ud();
  }
  z7c(cap) {
    throw NotImplementedError.ud();
  }
  s7d(index) {
    throw NotImplementedError.ud();
  }
  rc() {
    throw NotImplementedError.ud();
  }
  s7e(target, attachment, renderbuffertarget, renderbuffer) {
    throw NotImplementedError.ud();
  }
  r7e(target, attachment, textarget, texture, level) {
    throw NotImplementedError.ud();
  }
  t7e(mode) {
    throw NotImplementedError.ud();
  }
  r84(n, buffers) {
    throw NotImplementedError.ud();
  }
  t7b(target) {
    throw NotImplementedError.ud();
  }
  s84(n, framebuffers) {
    throw NotImplementedError.ud();
  }
  t84(n, renderbuffers) {
    throw NotImplementedError.ud();
  }
  u84(n, textures) {
    throw NotImplementedError.ud();
  }
  b7f(program, name) {
    throw NotImplementedError.ud();
  }
  i7f() {
    throw NotImplementedError.ud();
  }
  v84(pname, data) {
    throw NotImplementedError.ud();
  }
  w84(program, pname, params) {
    throw NotImplementedError.ud();
  }
  x84(shader, pname, params) {
    throw NotImplementedError.ud();
  }
  y84(shader, bufSize, length, infoLog) {
    throw NotImplementedError.ud();
  }
  a78(name) {
    throw NotImplementedError.ud();
  }
  r7f(program) {
    throw NotImplementedError.ud();
  }
  q7b(pname, param) {
    throw NotImplementedError.ud();
  }
  q7e(target, internalformat, width, height) {
    throw NotImplementedError.ud();
  }
  x7e(x, y, width, height) {
    throw NotImplementedError.ud();
  }
  g7f(shader, string) {
    throw NotImplementedError.ud();
  }
  b7d(func, ref, mask) {
    throw NotImplementedError.ud();
  }
  a7d(face, func, ref, mask) {
    throw NotImplementedError.ud();
  }
  n7c(mask) {
    throw NotImplementedError.ud();
  }
  e7d(face, mask) {
    throw NotImplementedError.ud();
  }
  d7d(fail, zfail, zpass) {
    throw NotImplementedError.ud();
  }
  c7d(face, sfail, dpfail, dppass) {
    throw NotImplementedError.ud();
  }
  r7b(target, level, internalformat, width, height, border, format, type, pixels) {
    throw NotImplementedError.ud();
  }
  s7b(target, level, internalformat, format, type, data) {
    var buffer = Buffer.m13(imul(imul(data.a3y_1, data.b3y_1), 4), true);
    setArrayLE(buffer, 0, data.x45().q3x_1);
    this.r7b(target, level, internalformat, data.a3y_1, data.b3y_1, 0, format, type, buffer);
  }
  k7b(target, pname, param) {
    throw NotImplementedError.ud();
  }
  g7b(location, count, value) {
    throw NotImplementedError.ud();
  }
  e79(location, v0) {
    throw NotImplementedError.ud();
  }
  z7a(location, count, value) {
    throw NotImplementedError.ud();
  }
  h7b(location, count, value) {
    throw NotImplementedError.ud();
  }
  a7b(location, count, value) {
    throw NotImplementedError.ud();
  }
  i7b(location, count, value) {
    throw NotImplementedError.ud();
  }
  b7b(location, count, value) {
    throw NotImplementedError.ud();
  }
  j7b(location, count, value) {
    throw NotImplementedError.ud();
  }
  c7b(location, count, value) {
    throw NotImplementedError.ud();
  }
  d7b(location, count, transpose, value) {
    throw NotImplementedError.ud();
  }
  e7b(location, count, transpose, value) {
    throw NotImplementedError.ud();
  }
  f7b(location, count, transpose, value) {
    throw NotImplementedError.ud();
  }
  c7f(program) {
    throw NotImplementedError.ud();
  }
  t7d(index, size, type, normalized, stride, pointer) {
    throw NotImplementedError.ud();
  }
  h7e(x, y, width, height) {
    throw NotImplementedError.ud();
  }
  v7c(cap, enable) {
    if (enable) {
      this.z7c(cap);
    } else {
      this.y7c(cap);
    }
    return enable;
  }
  g7d(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  i7d(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  n7d(index, divisor) {
    unsupported();
  }
  a7e(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  f79(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  g79(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  z84(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  p7d(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  m7b() {
    return Companion_instance_54.r7i();
  }
  f7c() {
    return Unit_instance;
  }
  k7d(contextVersion) {
    return Unit_instance;
  }
  a85(name, index) {
    throw NotImplementedError.ud();
  }
  j5u() {
    if (this.y77_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.ud();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList.i1();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = this_0.w1_1;
        var last = this_0.x1_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
            var it = element;
            // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
            var tmp0_safe_receiver = this.a85(7939, it);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              destination.h(tmp0_safe_receiver);
            }
          }
           while (!(element === last));
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.a78(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.y77_1 = tmp_0;
    }
    return ensureNotNull(this.y77_1);
  }
  g7c() {
    return this.j5u();
  }
  cz(value) {
    this.w77_1.cz(value);
  }
  dz() {
    return this.w77_1.dz();
  }
}
class KmlGlContext {
  constructor(window_0, gl, parent, $box) {
    parent = parent === VOID ? null : parent;
    boxApply(this, $box);
    this.c7c_1 = window_0;
    this.d7c_1 = gl;
    this.e7c_1 = parent;
  }
  j7d() {
  }
  l7d() {
  }
  g6() {
  }
}
class KorgeReloadInternalImpl {
  b85(clazz, context) {
    return clazz;
  }
  c85(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.d85_1 = injector;
    this.e85_1 = refreshedClasses;
    this.f85_1 = rootFolders;
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.g85_1 = null;
    this.h85_1 = Companion_getInstance_1().tx('KorgeReload');
  }
  i85(eventDispatcher) {
    if (!Companion_getInstance_3().jv().uv() || !(Companion_instance_1.ei('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.g85_1 = eventDispatcher;
  }
  j85() {
    if (!Companion_getInstance_3().jv().uv())
      return Unit_instance;
    if (!(this.g85_1 == null))
      this.g85_1 = null;
  }
}
class Companion_51 {}
class Companion_52 {
  constructor() {
    Companion_instance_61 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_42().j6n_1;
    tmp.k85_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.l85_1 = this.k85_1.x88(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_42().y6w(Companion_getInstance_52().p6w_1, Companion_getInstance_52().w6w_1);
    tmp_0.m85_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_42().l6n_1;
    tmp_1.n85_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_42().y6w(Companion_getInstance_52().o6w_1, Companion_getInstance_52().s6w_1);
    tmp_2.o85_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_42().y6w(Companion_getInstance_52().p6w_1, Companion_getInstance_52().t6w_1);
    tmp_3.p85_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_42().y6w(Companion_getInstance_52().w6w_1, Companion_getInstance_52().s6w_1);
    tmp_4.q85_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_42().y6w(Companion_getInstance_52().w6w_1, Companion_getInstance_52().u6w_1);
    tmp_5.r85_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_42().y6w(Companion_getInstance_52().q6w_1, Companion_getInstance_52().n6w_1);
    tmp_6.s85_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().n6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_53().c6x_1);
    tmp_7.t85_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_42().x6w(Companion_getInstance_52().r6w_1, Companion_getInstance_52().w6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
    tmp_8.u85_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().n6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
    tmp_9.v85_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().n6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
    tmp_10.w85_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().n6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
    tmp_11.x85_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().n6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
    tmp_12.y85_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_42().x6w(Companion_getInstance_52().u6w_1, Companion_getInstance_52().n6w_1, Companion_getInstance_52().p6w_1, Companion_getInstance_52().p6w_1);
    tmp_13.z85_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.a86_1 = [this.l85_1, this.m85_1, this.k85_1, this.n85_1, this.o85_1, this.p85_1, this.q85_1, this.r85_1, this.s85_1, this.t85_1, this.u85_1, this.v85_1, this.w85_1, this.x85_1, this.y85_1, this.z85_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.a86_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.ic(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.blend.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.v88_1);
      destination.b3(tmp$ret$3, element);
    }
    tmp_15.b86_1 = destination;
    this.c86_1 = toList_0(this.a86_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.a86_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.ic(capacity_0);
    var inductionVariable_0 = this_1.w1_1;
    var last_0 = this_1.x1_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'korlibs.korge.blend.Companion.TO_ORDINAL.<anonymous>' call
        var it = element_0;
        var tmp$ret$6 = Companion_getInstance_67().a86_1[it];
        destination_0.b3(tmp$ret$6, element_0);
      }
       while (!(element_0 === last_0));
    tmp_16.d86_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_67();
    name = name === VOID ? null : name;
    this.u88_1 = factors;
    this.v88_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.u88_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.v88_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.w88_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.w88_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.u88_1 === other.u88_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.v88_1 == other.v88_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.v88_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  y88(factors, name) {
    return new BlendMode(factors, name);
  }
  x88(factors, name, $super) {
    factors = factors === VOID ? this.u88_1 : factors;
    name = name === VOID ? this.v88_1 : name;
    return $super === VOID ? this.y88(factors, name) : $super.y88.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.z88_1 = booleanArray(Companion_getInstance_34().u6k_1);
    this.a89_1 = booleanArray(Companion_getInstance_34().u6k_1);
    this.b89_1 = false;
    this.c89_1 = false;
    this.d89_1 = false;
    this.e89_1 = false;
  }
  f89(key) {
    return this.g89(key);
  }
  g89(key) {
    return this.z88_1[key.k3_1];
  }
  h89(key) {
    return this.z88_1[key.k3_1] && !this.a89_1[key.k3_1];
  }
  i89(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.z88_1[key.k3_1] = false;
        break;
      case false:
        this.z88_1[key.k3_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.b89_1 = shift || this.f89(Companion_getInstance_34().i6l()) || this.f89(Companion_getInstance_34().j6l());
    this.c89_1 = ctrl || this.f89(Companion_getInstance_34().g6l()) || this.f89(Companion_getInstance_34().h6l());
    this.d89_1 = alt || this.f89(Companion_getInstance_34().k6l()) || this.f89(Companion_getInstance_34().l6l());
    this.e89_1 = meta || this.f89(Key_META_getInstance());
  }
  j89(e) {
    switch (e.l6f_1.k3_1) {
      case 0:
      case 1:
        this.i89(e.n6f_1, e.l6f_1.equals(Type_UP_getInstance()), this.b89_1, this.c89_1, this.d89_1, this.e89_1);
        break;
      default:
        break;
    }
  }
  k89(delta) {
  }
  l89(delta) {
    arraycopy_4(this.z88_1, 0, this.a89_1, 0, this.z88_1.length);
  }
}
class Companion_53 {
  constructor() {
    this.m89_1 = 256;
  }
}
class Input {
  constructor() {
    this.n89_1 = new Mixin();
    this.o89_1 = Companion_getInstance_27().n6h_1;
    this.p89_1 = new TouchEvent();
    var tmp = this;
    tmp.q89_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.r89_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.s89_1 = 20.0;
    this.t89_1 = Vector2D.d2b(-1000.0, -1000.0);
    this.u89_1 = Vector2D.d2b(-1000.0, -1000.0);
    this.v89_1 = 0;
    this.w89_1 = false;
    this.x89_1 = true;
    this.y89_1 = false;
    this.z89_1 = new InputKeys();
    this.a8a_1 = booleanArray(256);
    this.b8a_1 = booleanArray(256);
    this.c8a_1 = new Float64Array(256);
    this.d8a_1 = new Float64Array(256);
    this.e8a_1 = booleanArray(256);
    this.f8a_1 = booleanArray(256);
    this.g8a_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.w1_1;
    var last = this_0.x1_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
        var it = item;
        var tmp$ret$2 = new GamepadInfo(it);
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    tmp_1.h8a_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.i8a_1 = ArrayList.i1();
  }
  k8a(touchEvent) {
    this.p89_1.w6i(touchEvent);
  }
  l8a() {
    return this.t89_1;
  }
  m8a(p, down) {
    if (down)
      this.u89_1 = p;
    else
      this.t89_1 = p;
  }
  n8a(button, down) {
    this.v89_1 = setBits(this.v89_1, button.w6l_1, down);
  }
  o8a() {
    this.i8a_1.e3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.h8a_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.r6j_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.i8a_1.h(gamepad);
      }
    }
  }
  p8a(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.a8a_1.length - 1 | 0) : false) {
      this.a8a_1[pKeyCode] = b;
    }
  }
  q8a(delta) {
    var tmp0_safe_receiver = this.dz();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.e3();
    }
    this.z89_1.k89(delta);
  }
  r8a(delta) {
    this.y89_1 = false;
    this.z89_1.l89(delta);
    endFrameOldKeys(this, delta);
  }
  s8a(e) {
    switch (e.l6f_1.k3_1) {
      case 1:
        this.p8a(e.o6f_1, true);
        break;
      case 0:
        this.p8a(e.o6f_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  cz(value) {
    this.n89_1.cz(value);
  }
  dz() {
    return this.n89_1.dz();
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.t8a_1 = 1280;
    this.u8a_1 = 720;
    this.v8a_1 = Size2D.e2a(1280, 720);
  }
}
class Companion_54 {
  w8a(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.y8a(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.hc() : props;
    this.x8a_1 = props;
  }
  z8a(str) {
    var _iterator__ex2g4s = split(str, ['\n']).a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.d1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= 1 ? 1 < parts.e1() : false) {
        tmp = parts.d1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.x8a_1.b3(key, value);
    }
  }
  y8a(str) {
    this.e3();
    this.z8a(str);
  }
  e3() {
    this.x8a_1.e3();
  }
  a8b(key, value) {
    return this.x8a_1.b3(key, value);
  }
  b3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.a8b(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  oz(key) {
    return this.x8a_1.c3(key);
  }
  c3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.oz((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  l1() {
    return this.x8a_1.l1();
  }
  a3() {
    return this.x8a_1.a3();
  }
  f3() {
    return this.x8a_1.f3();
  }
  qz(key) {
    return this.x8a_1.x2(key);
  }
  x2(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.qz((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  ei(key) {
    return this.x8a_1.z2(key);
  }
  z2(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.ei((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  g1() {
    return this.x8a_1.g1();
  }
  e1() {
    return this.x8a_1.e1();
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.b8b_1 = closeable;
  }
  c8b() {
    var tmp0_safe_receiver = this.b8b_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.g6();
    }
    this.b8b_1 = null;
  }
  v2t() {
    this.b8b_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.d8b_1 = Pool.c2t(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.e8b_1 = FastIdentityMap();
    this.f8b_1 = fastArrayListOf([]);
    this.g8b_1 = 0;
    this.h8b_1 = 60;
  }
  i8b(closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.e8b_1;
      var res = get_0(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.d8b_1.f2t();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.b8b_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  }
  j8b() {
    this.g8b_1 = this.g8b_1 + 1 | 0;
    if (this.g8b_1 >= this.h8b_1) {
      this.g8b_1 = 0;
      this.k8b();
    }
  }
  k8b() {
    var _iterator__ex2g4s = this.f8b_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var entry = _iterator__ex2g4s.c1();
      if (!contains_1(this.e8b_1, entry.b8b_1)) {
        var tmp0_safe_receiver = entry.b8b_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.g6();
        }
        this.d8b_1.g2t(entry);
      }
    }
    this.f8b_1.e3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.e8b_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.f8b_1.h(it_0);
    }
    clear(this.e8b_1);
  }
  g6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.f8b_1.sz_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].c8b();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.e8b_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).c8b();
    }
    this.f8b_1.e3();
    this.d8b_1.e3();
    clear(this.e8b_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.l8b_1 = 0;
    this.m8b_1 = TextureBase.r8b(null, 0, 0);
    this.n8b_1 = FastIdentityMap();
  }
  v2t() {
    this.l8b_1 = 0;
    this.m8b_1.o8b_1 = null;
    this.m8b_1.q8b_1 = -1;
    this.m8b_1.s8b(0);
    this.m8b_1.t8b(0);
    clear(this.n8b_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.m8b_1.toString() + ', usedMemory=' + this.l8b_1 + ', slices=' + get_size(this.n8b_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.u8b_1 = ag;
    this.v8b_1 = new Long(0, 0);
    this.w8b_1 = FastSmallSet.s2q();
    this.x8b_1 = FastSmallSet.s2q();
    this.y8b_1 = FastArrayList.uz();
    this.z8b_1 = 60;
    this.a8c_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.b8c_1 = Pool.c2t(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.c8c_1 = FastIdentityMap();
    this.d8c_1 = null;
    this.e8c_1 = null;
    this.f8c_1 = null;
    this.g8c_1 = null;
    this.h8c_1 = null;
    this.i8c_1 = null;
    this.j8c_1 = null;
    this.k8c_1 = null;
    this.l8c_1 = 0;
  }
  n8c() {
    return this.w8b_1.e1();
  }
  o8c() {
    return this.x8b_1.e1();
  }
  p8c() {
    return this.y8b_1.e1();
  }
  toString() {
    return this.q8c();
  }
  q8c() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.n8c() + ', numReferencedBitmapsSinceGC=' + this.o8c() + ', numReferencedBitmaps=' + this.p8c() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().r15(this.v8b_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().r15(this.a8c_1)) + ')';
  }
  r8c(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).m8b_1);
  }
  s8c(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  t8c(slice) {
    return _getTexture(this, slice);
  }
  u8c() {
    clearFastCacheAccess(this);
    this.l8c_1 = this.l8c_1 + 1 | 0;
    if (this.l8c_1 >= this.z8b_1) {
      this.l8c_1 = 0;
      this.k8b();
    }
  }
  k8b() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.y8b_1.sz_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.x8b_1.zk(bmp))
        if (this.v8b_1.s1(this.a8c_1) < 0 || this.a8c_1.s1(new Long(0, 0)) < 0) {
          this.v8c(bmp, 'GC');
        } else
          this.w8b_1.t2q(bmp);
    }
    this.y8b_1.e3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.x8b_1.o2q_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.y8b_1.h(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.w8b_1.o2q_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.y8b_1.h(element_0);
    }
    this.x8b_1.e3();
  }
  v8c(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.c8c_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.a8c_1;
    var other = info.l8b_1;
    tmp_0.a8c_1 = this_0.t1(toLong(other));
    this.x8b_1.u2q(bmp);
    if (this.e8c_1 === info || this.g8c_1 === info) {
      clearFastCacheAccess(this);
    }
    info.m8b_1.g6();
    this.b8c_1.g2t(info);
    this.w8b_1.u2q(bmp);
  }
  g6() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.c8c_1)).a1();
    while (_iterator__ex2g4s.b1()) {
      var bmp = _iterator__ex2g4s.c1();
      this.v8c(bmp, 'close');
    }
    clear(this.c8c_1);
    this.y8b_1.e3();
    this.x8b_1.e3();
    this.w8b_1.e3();
    this.b8c_1.e3();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.w8c_1 = ag;
    this.x8c_1 = FastIdentityMap();
    this.y8c_1 = FastSmallSet.s2q();
    var tmp = this;
    tmp.z8c_1 = Pool.d2t(VOID, AgBufferManager$bufferPool$lambda);
    this.a8d_1 = 0;
    this.b8d_1 = 60;
    this.c8d_1 = Buffer.m13(0);
  }
  d8d(cached) {
    this.y8c_1.t2q(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.x8c_1;
      var res = get_0(this_0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.z8c_1.f2t();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      this_1.z6p(cached.e8d_1);
      var out = this_1;
      set(this_0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  j8b() {
    removeCache(this);
    this.a8d_1 = this.a8d_1 + 1 | 0;
    if (this.a8d_1 >= this.b8d_1) {
      this.a8d_1 = 0;
      this.k8b();
    }
  }
  k8b() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.y8c_1.o2q_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.f8d(element);
    }
    this.y8c_1.e3();
  }
  g8d(buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.e1()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = buffer.d1(_unary__edvuaz);
      this.f8d(it);
    }
  }
  f8d(buffer) {
    var buf = getAndRemove(this.x8c_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.z6p(this.c8d_1);
      this.z8c_1.g2t(buf);
    }
  }
}
class AgCachedBuffer {
  constructor(data) {
    this.e8d_1 = data;
  }
}
class BatchBuffers {
  constructor() {
    this.r8d_1 = new AGBuffer();
    this.s8d_1 = new AGBuffer();
    this.t8d_1 = new AGBuffer();
    this.u8d_1 = AGVertexArrayObject.o6v([new AGVertexData(Companion_getInstance_70().o8d_1, this.r8d_1), new AGVertexData(Companion_getInstance_70().p8d_1, this.s8d_1)], false);
  }
}
class Companion_55 {
  constructor() {
    Companion_instance_64 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.n7r('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.h8d_1 = tmp_2;
    this.i8d_1 = 16383;
    this.j8d_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_4;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.e2x(level, tmp$ret$2);
      tmp_4 = Unit_instance;
    }
    this.k8d_1 = Attribute.m72('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_5;
    if (this_1.d2x(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.e2x(level_0, tmp$ret$4);
      tmp_5 = Unit_instance;
    }
    this.l8d_1 = Varying.y72('v_Col2', VarType_Float4_getInstance());
    this.m8d_1 = Attribute.m72('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.n8d_1 = Varying.y72('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_2.d2x(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.e2x(level_1, tmp$ret$6);
      tmp_6 = Unit_instance;
    }
    this.o8d_1 = ProgramLayout.x6v([DefaultShaders_getInstance().h6z_1, DefaultShaders_getInstance().i6z_1, this.v8d(), this.k8d_1]);
    this.p8d_1 = ProgramLayout.x6v([this.m8d_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.d2x(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.e2x(level_2, tmp$ret$8);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = ProgramBuilderDefault.n73();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.s73(this_4.o73(), this_4.p73());
    this_4.s73(Companion_getInstance_70().n8d_1, Companion_getInstance_70().m8d_1);
    this_4.s73(Companion_getInstance_70().w8d(), this_4.z73([this_4.w73(this_4.b74(Companion_getInstance_70().v8d(), 'rgb'), this_4.b74(Companion_getInstance_70().v8d(), 'a')), this_4.b74(Companion_getInstance_70().v8d(), 'a')]));
    this_4.s73(Companion_getInstance_70().l8d_1, Companion_getInstance_70().k8d_1);
    this_4.s73(this_4.v73(), this_4.w73(this_4.w73(this_4.h71(), this_4.i71()), this_4.z73([this_4.x73(), this_4.y73(0.0), this_4.y73(1.0)])));
    var tmp_9 = VertexShader(this_4.a74());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = ProgramBuilderDefault.n73();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_70().x8d(this_5);
    this_5.s73(this_5.v73(), this_5.w73(this_5.v73(), Companion_getInstance_70().w8d()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.v75(this_5.b74(this_5.v73(), 'a'), this_5.y73(0.0));
    var body = this_5.j74();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.a75();
    var stmIf = new If(cond, body.l74());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.r73_1.h(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.a74());
    tmp_8.q8d_1 = new Program(tmp_9, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_6.d2x(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.e2x(level_3, tmp$ret$15);
      tmp_10 = Unit_instance;
    }
  }
  v8d() {
    return DefaultShaders_getInstance().j6z_1;
  }
  w8d() {
    return DefaultShaders_getInstance().l6z_1;
  }
  x8d(builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_70().n8d_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.y74(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_70();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_70().j8d_1 : reqMaxQuads;
    this.m87_1 = ctx;
    this.n87_1 = reqMaxQuads;
    this.o87_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.n87_1;
    var b = Companion_getInstance_70().i8d_1;
    tmp.p87_1 = Math.min(a, b);
    this.q87_1 = this.m87_1.y86_1;
    this.r87_1 = this.m87_1.f86_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.e2x(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.m87_1.a87_1.n1z(BatchBuilder2D$lambda(this));
    this.s87_1 = imul(this.p87_1, 4);
    this.t87_1 = imul(this.p87_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.d2x(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.e2x(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.u87_1 = Buffer.m13(imul(24, this.s87_1));
    this.v87_1 = new Int8Array(this.s87_1);
    this.w87_1 = Buffer.m13(imul(2, this.t87_1));
    this.x87_1 = get_u16(this.w87_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.d2x(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.e2x(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.y87_1 = 0;
    this.z87_1 = 0;
    this.a88_1 = 0;
    this.b88_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.o87_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.c88_1 = tmp_6;
    this.d88_1 = false;
    this.e88_1 = Companion_getInstance_67().k85_1;
    this.f88_1 = Companion_getInstance_70().q8d_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.d2x(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.e2x(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.g88_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.d2x(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.e2x(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.h88_1 = Companion_getInstance_45().q6n_1;
    this.i88_1 = Companion_getInstance_46().s6n_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.d2x(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.e2x(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.j88_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.d2x(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.e2x(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.k88_1 = Companion_getInstance_43().e6o_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.d2x(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.e2x(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.d2x(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.e2x(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.l88_1 = new Signal();
    this.m88_1 = new Signal();
    this.n88_1 = fastArrayListOf([]);
    this.o88_1 = 0;
    this.p88_1 = 0;
    this.q88_1 = 0;
  }
  a8e() {
    return this.m87_1.t86_1;
  }
  b8e(value) {
    this.y87_1 = value;
  }
  c8e() {
    return this.y87_1;
  }
  d8e() {
    var inductionVariable = 0;
    var last = this.o87_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.c88_1[n] = null;
      }
       while (inductionVariable < last);
    this.b88_1 = 0;
  }
  j8b() {
    this.g88_1.v2t();
  }
  e8e() {
    return this.k88_1;
  }
  f8e(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.v87_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  g8e(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.h8e(6, 4);
    this.i8e();
    var vp = this.z87_1;
    var vd = this.u87_1;
    vp = vp + this.f8e(vd, vp, x0, y0, tex.k3k(), tex.l3k(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.f8e(vd, vp, x1, y1, tex.m3k(), tex.n3k(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.f8e(vd, vp, x2, y2, tex.o3k(), tex.p3k(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.f8e(vd, vp, x3, y3, tex.q3k(), tex.r3k(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.z87_1 = vp;
    this.b8e(this.c8e() + 4 | 0);
  }
  j8e(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.b88_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.g8e(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.g8e.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  k8e(vc) {
    this.a88_1 = this.a88_1 + _addIndices(this, this.x87_1, this.a88_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  i8e(vc, $super) {
    vc = vc === VOID ? this.c8e() : vc;
    var tmp;
    if ($super === VOID) {
      this.k8e(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.k8e.call(this, vc);
    }
    return tmp;
  }
  l8e(array, matrix, vcount, icount, texIndex) {
    this.h8e(icount, vcount);
    var i16 = this.x87_1;
    var ip = this.a88_1;
    var vc = this.c8e();
    var arrayIndices = array.m8e_1;
    // Inline function 'kotlin.math.min' call
    var b = array.p8e_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.z87_1;
    var src = get_i32(array.q8e_1);
    var dst = get_i32(this.u87_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.z87_1 / 6 | 0;
    arrayfill(this.v87_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.n29()) {
      applyMatrix(this, matrix, this.z87_1, vcount);
    }
    this.y87_1 = this.y87_1 + vcount | 0;
    this.z87_1 = this.z87_1 + imul(vcount, 6) | 0;
    this.a88_1 = this.a88_1 + icount_0 | 0;
  }
  t8e(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.o8e_1 : vcount;
    icount = icount === VOID ? array.p8e_1 : icount;
    texIndex = texIndex === VOID ? this.b88_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.l8e(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.l8e.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  h8e(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.u8e();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.a5(toString(message));
    }
    return doFlush;
  }
  v8e(tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.o8b_1;
      this.h8e(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_70().q8d_1 : program;
      if (this.w8e(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.y8d();
      if (!contains_0(this.c88_1, tex_0)) {
        this.b88_1 = 0;
        this.c88_1[0] = tex_0;
      }
      this.d88_1 = smoothing;
      this.e88_1 = blendMode;
      this.f88_1 = pprogram;
    }
  }
  x8e(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.c88_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  w8e(tex, smoothing, blendMode, program) {
    var hasTex = this.x8e(tex);
    if (!(this.c88_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.c88_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.c88_1[n] === null) {
            this.c88_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.c88_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.c88_1[n_0]) {
          this.b88_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.d88_1 === smoothing && this.e88_1 === blendMode && this.f88_1 === program;
  }
  y8e(tex, smoothing, blendMode, program, icount, vcount) {
    this.v8e(this.q87_1.r8c(tex), smoothing, blendMode, program, icount, vcount);
  }
  z8e(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.a8f(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  t88(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.k2l() : width;
    height = height === VOID ? tex.l2l() : height;
    m = m === VOID ? Companion_getInstance_7().f2c_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().h3z_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_67().k85_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.z8e(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.z8e.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  a8f(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.v8e(tex.z3j(), filtering, blendMode, program, 6, 4);
    this.b8f(x, y, width, height, m, tex, colorMul);
  }
  b8f(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.j8e(m.y2c(x0, y0), m.z2c(x0, y0), m.y2c(x1, y0), m.z2c(x1, y0), m.y2c(x1, y1), m.z2c(x1, y1), m.y2c(x0, y1), m.z2c(x0, y1), tex, colorMul);
  }
  c8f() {
    this.g88_1.u2t_1.t8d_1.y6p(this.w87_1, 0, imul(this.a88_1, 2));
  }
  d8f() {
    this.m87_1.d8f();
    var inductionVariable = 0;
    var last = this.o87_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_39().h6t(VOID, this.d88_1);
        this.m87_1.o86_1.g6q(Companion_getInstance_70().h8d_1[n], this.c88_1[n], info);
      }
       while (inductionVariable < last);
  }
  y8d() {
    if (this.o88_1 === this.a88_1)
      return Unit_instance;
    this.d8f();
    this.p88_1 = this.p88_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.n88_1;
    var tmp0_frameBuffer = this.m87_1.i87_1.e6m_1;
    var tmp1_frameBufferInfo = this.m87_1.i87_1.k6o();
    var tmp2_vertexData = this.g88_1.u2t_1.u8d_1;
    var tmp3_indices = this.g88_1.u2t_1.t8d_1;
    var tmp4_program = this.f88_1;
    var tmp5_drawType = Companion_getInstance_40().f6w_1;
    var tmp6_blending = this.e88_1.u88_1;
    var tmp7_uniformBlocks = this.m87_1.e8f(this.f88_1, false);
    var tmp8_textureUnits = this.m87_1.o86_1.zy();
    var tmp9_stencilOpFunc = this.i88_1;
    var tmp10_stencilRef = this.h88_1;
    var tmp11_colorMask = this.j88_1;
    var tmp12_scissor = this.k88_1;
    var tmp13_drawOffset = imul(this.o88_1, 2);
    var tmp14_vertexCount = this.a88_1 - this.o88_1 | 0;
    var element = new AGBatch(tmp0_frameBuffer, tmp1_frameBufferInfo, tmp2_vertexData, tmp3_indices, VOID, tmp4_program, tmp7_uniformBlocks, tmp8_textureUnits, tmp6_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp12_scissor, VOID, tmp5_drawType, tmp13_drawOffset, tmp14_vertexCount);
    this_0.h(element);
    this.o88_1 = this.a88_1;
  }
  f8f(uploadVertices, uploadIndices) {
    this.g8f(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.o87_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.c88_1[n] = null;
      }
       while (inductionVariable < last);
    this.b88_1 = 0;
  }
  z8d(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.f8f(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.f8f.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  g8f(uploadVertices, uploadIndices) {
    this.y8d();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.n88_1.g1()) {
      if (uploadVertices) {
        this.g88_1.u2t_1.r8d_1.y6p(this.u87_1, 0, imul(this.z87_1, 4));
        this.g88_1.u2t_1.s8d_1.x6p(this.v87_1, 0, this.z87_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.c8f();
      }
      this.m87_1.h8f();
      draw_0(this.r87_1, new AGMultiBatch(toList(this.n88_1)));
      this.n88_1.e3();
      this.l88_1.u1z(this);
      this.q88_1 = this.q88_1 + 1 | 0;
      this.m87_1.i8f();
      this.g88_1.c1();
    }
    this.b8e(0);
    this.z87_1 = 0;
    this.o88_1 = 0;
    this.a88_1 = 0;
  }
  u8e(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.g8f(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.g8f.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  j8f(vertexCount) {
    var oldVertexCount = this.c8e();
    this.b8e(vertexCount);
    try {
      this.l88_1.u1z(this);
    }finally {
      this.b8e(oldVertexCount);
    }
  }
}
class BoundsProvider {}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.s8f()).q2e();
}
function get_globalToWindowScaleAvg() {
  return this.w8f().q2e();
}
function windowToGlobalCoords(pos) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = this.q8f();
    if (this_0.m29()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.d2b(this_0.x2c(pos.x28_1, pos.y28_1), this_0.a2d(pos.x28_1, pos.y28_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.k8f_1 = Companion_getInstance_7().i2c();
    this.l8f_1 = MatrixTransform.o2e();
    this.m8f_1 = Companion_getInstance_7().i2c();
    this.n8f_1 = MatrixTransform.o2e();
    this.o8f_1 = Companion_getInstance_5().b2h(0, 0, 1280, 720);
  }
  p8f(_set____db54di) {
    this.k8f_1 = _set____db54di;
  }
  q8f() {
    return this.k8f_1;
  }
  r8f(_set____db54di) {
    this.l8f_1 = _set____db54di;
  }
  s8f() {
    return this.l8f_1;
  }
  t8f(_set____db54di) {
    this.m8f_1 = _set____db54di;
  }
  u8f() {
    return this.m8f_1;
  }
  v8f(_set____db54di) {
    this.n8f_1 = _set____db54di;
  }
  w8f() {
    return this.n8f_1;
  }
  x8f(_set____db54di) {
    this.o8f_1 = _set____db54di;
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    this.b8g_1 = ProgramLayout.x6v([DefaultShaders_getInstance().h6z_1, DefaultShaders_getInstance().j6z_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.s73(builder.v73(), builder.w73(builder.w73(this_0.h71(), this_0.i71()), builder.z73([this_0.h6z_1, builder.y73(0.0), builder.y73(1.0)])));
    builder.s73(this_0.l6z_1, this_0.j6z_1);
    tmp.c8g_1 = VertexShader(builder.a74());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.n73();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.s73(builder_0.v73(), this_1.l6z_1);
    tmp_0.d8g_1 = FragmentShader(builder_0.a74());
    this.e8g_1 = new Program(this.c8g_1, this.d8g_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_71();
    this.f8g_1 = ctx;
    this.g8g_1 = new Signal();
    this.f8g_1.a87_1.n1z(LineRenderBatcher$lambda(this));
    this.h8g_1 = this.f8g_1.f86_1;
    this.i8g_1 = Colors_getInstance().x44_1;
    this.j8g_1 = new AGBuffer();
    this.k8g_1 = AGVertexArrayObject.o6v([new AGVertexData(Companion_getInstance_71().b8g_1, this.j8g_1)], false);
    this.l8g_1 = 1024;
    this.m8g_1 = allocDirect(Companion_instance_4, imul(24, this.l8g_1));
    this.n8g_1 = Matrix4.n2f();
    this.o8g_1 = 0;
    this.p8g_1 = 0;
    this.q8g_1 = Companion_getInstance_67().k85_1;
    this.r8g_1 = Companion_getInstance_7().i2c();
  }
  s8g(p0, p1, color0, color1, m) {
    return this.t8g(p0.x28_1, p0.y28_1, p1.x28_1, p1.y28_1, this.i8g_1, color1, m);
  }
  u8g(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.i8g_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.r8g_1 : m;
    var tmp;
    if ($super === VOID) {
      this.s8g(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.s8g.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  v8g(x0, y0, x1, y1, color0, color1, m) {
    if (this.o8g_1 >= (this.l8g_1 - 2 | 0)) {
      this.rc();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  w8g(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.i8g_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.r8g_1 : m;
    var tmp;
    if ($super === VOID) {
      this.v8g(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.v8g.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  t8g(x0, y0, x1, y1, color0, color1, m) {
    return this.v8g(x0, y0, x1, y1, color0, color1, m);
  }
  x8g(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.i8g_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.r8g_1 : m;
    var tmp;
    if ($super === VOID) {
      this.t8g(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.t8g.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  y8g(path, m) {
    var lastPos = {_v: Vector2D.o2b()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.o2b();
    var l = Vector2D.o2b();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.x3g_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.xy(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.y3g_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.d2b(tmp, path.y3g_1.d1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!true) {
            this.u8g(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.y3g_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.d2b(tmp_0, path.y3g_1.d1(_unary__edvuaz_3));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!false) {
            this.u8g(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.y3g_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.d2b(tmp_1, path.y3g_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.y3g_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.d2b(tmp_2, path.y3g_1.d1(_unary__edvuaz_7));
          var sum = Companion_getInstance_4().z2j(l, c) + Companion_getInstance_4().z2j(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.o2b()};
          var prevPos = {_v: Vector2D.o2b()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_10().ry_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_12().q3e(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_12().q3e(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.u8g(lastPos._v, it_1, VOID, VOID, m);
              }
              lastPos._v = it_1;
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos_0._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.y3g_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.d2b(tmp_3, path.y3g_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.y3g_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.d2b(tmp_4, path.y3g_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.y3g_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.d2b(tmp_5, path.y3g_1.d1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_4().z2j(l, c0) + Companion_getInstance_4().z2j(c0, c1) + Companion_getInstance_4().z2j(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.o2b()};
          var prevPos_0 = {_v: Vector2D.o2b()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_10().ry_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_12().p3e(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_12().p3e(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.u8g(lastPos._v, it_2, VOID, VOID, m);
              }
              lastPos._v = it_2;
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_1._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          var p = i;
          if (!false) {
            this.u8g(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  }
  rc() {
    if (this.o8g_1 > 0) {
      this.g8g_1.u1z(this);
      this.j8g_1.y6p(this.m8g_1, 0, imul(this.p8g_1, 4));
      this.f8g_1.d8f();
      var tmp0_$receiver = this.h8g_1;
      var tmp1_frameBuffer = this.f8g_1.i87_1;
      var tmp2_vertexData = this.k8g_1;
      var tmp3_program = Companion_getInstance_71().e8g_1;
      var tmp4_drawType = Companion_getInstance_40().e6w_1;
      var tmp5_vertexCount = this.o8g_1;
      var tmp6_uniformBlocks = this.f8g_1.z8g(Companion_getInstance_71().e8g_1);
      var tmp7_blending = this.q8g_1.u88_1;
      draw(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.o8g_1 = 0;
    this.p8g_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.s8h();
}
function get_pixelsPerLogicalInchRatio() {
  return this.t8h() / 96.0;
}
function get_computedPixelRatio() {
  return this.s8h() * this.u8h();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_70().j8d_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.e86_1 = new Mixin();
    this.f86_1 = ag;
    this.g86_1 = bp;
    this.h86_1 = deviceDimensionsProvider;
    this.i86_1 = stats;
    this.j86_1 = coroutineContext;
    this.k86_1 = batchMaxQuads;
    this.l86_1 = windowConfig;
    this.m86_1 = new BufferCache();
    this.n86_1 = FastIdentityMap();
    this.o86_1 = AGTextureUnits.d6q();
    this.p86_1 = Companion_getInstance_7().i2c();
    this.q86_1 = Companion_getInstance_7().i2c();
    this.r86_1 = Matrix4.n2f();
    this.s86_1 = Matrix4.n2f();
    this.t86_1 = Companion_getInstance_7().i2c();
    this.u86_1 = true;
    var tmp_0 = this;
    tmp_0.v86_1 = Pool.d2t(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.w86_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.x86_1 = new AgAutoFreeManager();
    this.y86_1 = new AgBitmapTextureManager(this.f86_1);
    this.z86_1 = new AgBufferManager(this.f86_1);
    this.a87_1 = new Signal();
    this.b87_1 = 1.0;
    this.c87_1 = Colors_getInstance().h3z_1;
    this.d87_1 = new BatchBuilder2D(this, this.k86_1);
    var tmp_2 = this;
    tmp_2.e87_1 = Pool.d2t(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.f87_1 = new RenderContext2D(this.d87_1, this.y86_1);
    this.g87_1 = true;
    this.h87_1 = null;
    this.i87_1 = this.f86_1.s6m();
    this.j87_1 = LinkedHashSet.h1();
    var tmp_3 = this;
    tmp_3.k87_1 = Pool.d2t(VOID, RenderContext$frameBuffers$lambda);
    this.l87_1 = FastArrayList.uz();
  }
  a8h() {
    return this.l86_1.a8h();
  }
  i8f() {
  }
  b8h() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w86_1;
    projViewMatUB$factory();
    return this_0.n1();
  }
  d8f() {
    if (this.u86_1 && this.i87_1.a6r()) {
      this.r86_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().f2h(0, this.i87_1.m6m_1, this.i87_1.l6m_1, 0), -1.0, 1.0);
    } else {
      this.r86_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().f2h(0, 0, this.i87_1.l6m_1, this.i87_1.m6m_1), -1.0, 1.0);
      this.r86_1 = this.r86_1.k2g(toMatrix4(this.p86_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.b8h();
      var _unary__edvuaz = this_0.j6v();
      this_0.a7i(_unary__edvuaz + 1 | 0);
      this_0.b7i(this_0.j6v() + 1 | 0);
      var blockSize = this_0.n6t_1;
      var index0 = imul(this_0.j6v() - 1 | 0, blockSize);
      var index1 = imul(this_0.j6v(), blockSize);
      var texBlockSize = this_0.k6t_1.j71().e1();
      var texIndex0 = imul(this_0.j6v() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.j6v(), texBlockSize);
      if (this_0.j6v() > 0) {
        arraycopy_0(this_0.p6t_1, index0, this_0.p6t_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.p6t_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.k6t_1;
      var it = this_0.q6t_1;
      it.k7i($this$push.h71(), this.r86_1);
      it.k7i($this$push.i71(), this.s86_1);
      if (true && this_0.j6v() >= 1) {
        var equals = arrayequal(this_0.p6t_1, index0, this_0.p6t_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.j6v();
          this_0.a7i(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  c8h() {
    return coerceAtLeast_0(round(this.d8h() * this.b87_1), 1.0);
  }
  e8h(kind) {
    this.a87_1.u1z(kind);
  }
  r88(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.e8h(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.e8h.call(this, kind);
    }
    return tmp;
  }
  f8h() {
    var tmp0_elvis_lhs = this.i87_1;
    return tmp0_elvis_lhs == null ? this.s6m() : tmp0_elvis_lhs;
  }
  g8h() {
    return this.f8h() === this.s6m();
  }
  s6m() {
    return this.f86_1.s6m();
  }
  h8h(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.f86_1.x6m(this.i87_1.e6m_1, this.i87_1.k6o(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  i8h(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().m3z_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_43().e6o_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.h8h(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.h8h.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  u6m() {
    this.f86_1.u6m();
    this.k87_1.h2t(this.j87_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.j87_1.g1()) {
      this.j87_1.e3();
    }
  }
  s88(bmp) {
    return this.y86_1.s8c(bmp);
  }
  j8h(bmp) {
    return this.y86_1.t8c(bmp);
  }
  d8d(buffer) {
    return this.z86_1.d8d(buffer);
  }
  k8h(closeable) {
    return this.x86_1.i8b(closeable);
  }
  l8h() {
    this.d87_1.d8e();
  }
  u8c() {
    this.r88();
    this.u6m();
    this.d87_1.j8b();
    this.x86_1.j8b();
    this.y86_1.u8c();
    this.z86_1.j8b();
  }
  g6() {
    this.y86_1.g6();
    this.x86_1.g6();
  }
  m8h(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.k87_1.f2t();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.j87_1.h(rb);
    }
    rb.m6r(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.d6s(hasDepth, hasStencil);
    rb.c6s(msamples);
    return rb;
  }
  n8h(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.m8h(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.m8h.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  o8h(rb) {
    this.j87_1.g3(rb);
    this.k87_1.g2t(rb);
  }
  p8h(frameBuffer) {
    this.l87_1.h(this.i87_1);
    this.i87_1 = frameBuffer;
  }
  q8h() {
    this.i87_1 = this.l87_1.i3(this.l87_1.e1() - 1 | 0);
  }
  u6t(uniformBlock) {
    return this.m86_1.u6t(uniformBlock);
  }
  r8h(program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.n86_1;
      var res = get_0(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.m86_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  e8f(program, autoUpload) {
    if (autoUpload) {
      this.h8f();
    }
    return this.r8h(program).i6v();
  }
  z8g(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.e8f(program, autoUpload) : $super.e8f.call(this, program, autoUpload);
  }
  h8f() {
    this.m86_1.s6t();
  }
  cz(value) {
    this.e86_1.cz(value);
  }
  dz() {
    return this.e86_1.dz();
  }
  p8f(_set____db54di) {
    this.g86_1.p8f(_set____db54di);
  }
  q8f() {
    return this.g86_1.q8f();
  }
  r8f(_set____db54di) {
    this.g86_1.r8f(_set____db54di);
  }
  s8f() {
    return this.g86_1.s8f();
  }
  t8f(_set____db54di) {
    this.g86_1.t8f(_set____db54di);
  }
  u8f() {
    return this.g86_1.u8f();
  }
  v8f(_set____db54di) {
    this.g86_1.v8f(_set____db54di);
  }
  w8f() {
    return this.g86_1.w8f();
  }
  x8f(_set____db54di) {
    this.g86_1.x8f(_set____db54di);
  }
  y8f() {
    return this.g86_1.y8f();
  }
  z8f() {
    return this.g86_1.z8f();
  }
  a8g(pos) {
    return this.g86_1.a8g(pos);
  }
  z6m() {
    return this.f86_1.z6m();
  }
  a6n() {
    return this.f86_1.a6n();
  }
  b6n() {
    return this.f86_1.b6n();
  }
  s8h() {
    return this.h86_1.s8h();
  }
  t8h() {
    return this.h86_1.t8h();
  }
  u8h() {
    return this.h86_1.u8h();
  }
  d8h() {
    return this.h86_1.d8h();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.v8h_1 = new Mixin();
    this.w8h_1 = batch;
    this.x8h_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.y8h_1 = Size2D.e2a(0, 0);
    var tmp_0 = this;
    tmp_0.z8h_1 = Pool.d2t(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.d2x(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.e2x(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.a8i_1 = Companion_getInstance_7().f2c_1;
    this.b8i_1 = Companion_getInstance_67().k85_1;
    this.c8i_1 = Colors_getInstance().h3z_1;
    this.d8i_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.d2x(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.e2x(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  e8i(scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.a8i_1;
      var p = Vector2D.q2b(scissor.o29(), scissor.q29());
      if (this_0.m29()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.d2b(this_0.x2c(p.x28_1, p.y28_1), this_0.a2d(p.x28_1, p.y28_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.a8i_1;
      var p_0 = Vector2D.q2b(scissor.p29(), scissor.r29());
      if (this_1.m29()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.d2b(this_1.x2c(p_0.x28_1, p_0.y28_1), this_1.a2d(p_0.x28_1, p_0.y28_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_43().j6x(tl.x28_1, tl.y28_1, br.x28_1, br.y28_1);
  }
  cz(value) {
    this.v8h_1.cz(value);
  }
  dz() {
    return this.v8h_1.dz();
  }
}
class SDFShaders extends Builder {
  static x8i() {
    SDFShaders_instance = null;
    var $this = this.i74();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.e75();
    var tmp_1 = $this.e75();
    var tmp_2 = $this.e75();
    var tmp_3 = $this.e75();
    tmp.h8i_1 = $this.t74(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).v71($this, opInterpolate$factory());
    var tmp_4 = $this;
    var tmp_5 = $this.e75();
    var tmp_6 = $this.e75();
    var tmp_7 = $this.e75();
    tmp_4.i8i_1 = $this.r74(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).v71($this, opUnion$factory());
    var tmp_8 = $this;
    var tmp_9 = $this.e75();
    var tmp_10 = $this.e75();
    var tmp_11 = $this.e75();
    tmp_8.j8i_1 = $this.r74(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).v71($this, opIntersect$factory());
    var tmp_12 = $this;
    var tmp_13 = $this.e75();
    var tmp_14 = $this.e75();
    var tmp_15 = $this.e75();
    tmp_12.k8i_1 = $this.r74(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).v71($this, opSubtract$factory());
    var tmp_16 = $this;
    var tmp_17 = $this.e75();
    var tmp_18 = $this.e75();
    var tmp_19 = $this.e75();
    tmp_16.l8i_1 = $this.r74(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).v71($this, opRound$factory());
    var tmp_20 = $this;
    var tmp_21 = $this.e75();
    var tmp_22 = $this.e75();
    var tmp_23 = $this.e75();
    tmp_20.m8i_1 = $this.r74(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).v71($this, opBorder$factory());
    var tmp_24 = $this;
    var tmp_25 = $this.e75();
    var tmp_26 = $this.e75();
    var tmp_27 = $this.e75();
    tmp_24.n8i_1 = $this.r74(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).v71($this, opBorderInner$factory());
    var tmp_28 = $this;
    var tmp_29 = $this.e75();
    var tmp_30 = $this.e75();
    tmp_28.o8i_1 = $this.p74(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).v71($this, opAA$factory());
    var tmp_31 = $this;
    var tmp_32 = $this.e75();
    var tmp_33 = $this.e75();
    tmp_31.p8i_1 = $this.p74(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).v71($this, opAARev$factory());
    var tmp_34 = $this;
    var tmp_35 = $this.e75();
    var tmp_36 = $this.e75();
    var tmp_37 = $this.e75();
    var tmp_38 = $this.e75();
    tmp_34.q8i_1 = $this.t74(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).v71($this, opSmoothUnion$factory());
    var tmp_39 = $this;
    var tmp_40 = $this.e75();
    var tmp_41 = $this.e75();
    var tmp_42 = $this.e75();
    var tmp_43 = $this.e75();
    tmp_39.r8i_1 = $this.t74(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).v71($this, opSmoothSubtraction$factory());
    var tmp_44 = $this;
    var tmp_45 = $this.e75();
    var tmp_46 = $this.e75();
    var tmp_47 = $this.e75();
    var tmp_48 = $this.e75();
    tmp_44.s8i_1 = $this.t74(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).v71($this, opSmoothIntersection$factory());
    var tmp_49 = $this;
    var tmp_50 = $this.v7q();
    var tmp_51 = $this.e75();
    var tmp_52 = $this.e75();
    tmp_49.t8i_1 = $this.r74(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).v71($this, circle$factory());
    var tmp_53 = $this;
    var tmp_54 = $this.v7q();
    var tmp_55 = $this.v7q();
    var tmp_56 = $this.w7q();
    var tmp_57 = $this.e75();
    tmp_53.u8i_1 = $this.t74(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).v71($this, roundedBox$factory());
    var tmp_58 = $this;
    var tmp_59 = $this.v7q();
    var tmp_60 = $this.v7q();
    var tmp_61 = $this.e75();
    tmp_58.v8i_1 = $this.r74(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).v71($this, box$factory());
    var tmp_62 = $this;
    var tmp_63 = $this.w7q();
    var tmp_64 = $this.w7q();
    var tmp_65 = $this.w7q();
    tmp_62.w8i_1 = $this.r74(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).v71($this, opCombinePremultipliedColors$factory());
    return $this;
  }
  y8i() {
    return this.h8i_1.ho(this, opInterpolate$factory_0());
  }
  z8i() {
    return this.i8i_1.ho(this, opUnion$factory_0());
  }
  a8j() {
    return this.j8i_1.ho(this, opIntersect$factory_0());
  }
  b8j() {
    return this.k8i_1.ho(this, opSubtract$factory_0());
  }
  c8j() {
    return this.l8i_1.ho(this, opRound$factory_0());
  }
  d8j() {
    return this.m8i_1.ho(this, opBorder$factory_0());
  }
  e8j() {
    return this.n8i_1.ho(this, opBorderInner$factory_0());
  }
  f8j() {
    return this.o8i_1.ho(this, opAA$factory_0());
  }
  g8j() {
    return this.p8i_1.ho(this, opAARev$factory_0());
  }
  h8j() {
    return this.q8i_1.ho(this, opSmoothUnion$factory_0());
  }
  i8j() {
    return this.r8i_1.ho(this, opSmoothSubtraction$factory_0());
  }
  j8j() {
    return this.s8i_1.ho(this, opSmoothIntersection$factory_0());
  }
  k8j() {
    return this.t8i_1.ho(this, circle$factory_0());
  }
  l8j() {
    return this.u8i_1.ho(this, roundedBox$factory_0());
  }
  m8j() {
    return this.v8i_1.ho(this, box$factory_0());
  }
  n8j() {
    return this.w8i_1.ho(this, opCombinePremultipliedColors$factory_0());
  }
}
class TextureBase {
  static o8j(base, size) {
    var $this = createThis(this);
    $this.o8b_1 = base;
    $this.p8b_1 = size;
    $this.q8b_1 = -1;
    return $this;
  }
  e1() {
    return this.p8b_1;
  }
  static r8b(base, width, height) {
    return this.o8j(base, SizeInt.q2j(width, height));
  }
  s8b(width) {
    this.p8b_1 = SizeInt.q2j(width, this.l2l());
  }
  k2l() {
    return this.p8b_1.o2j_1;
  }
  t8b(height) {
    this.p8b_1 = SizeInt.q2j(this.k2l(), height);
  }
  l2l() {
    return this.p8b_1.p2j_1;
  }
  g6() {
    var tmp0_safe_receiver = this.o8b_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.g6();
    }
    this.o8b_1 = null;
  }
  m8c(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.o8b_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.z6s(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.o8b_1) + ')';
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.p8j_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_72();
    icount = icount === VOID ? indices.length : icount;
    this.m8e_1 = indices;
    this.n8e_1 = vcount;
    this.o8e_1 = vcount;
    this.p8e_1 = icount;
    this.q8e_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.n8e_1), 4));
    this.r8e_1 = this.q8e_1;
    this.s8e_1 = 0;
  }
  q8j(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  r8j(index, x, y, width, height, matrix, bmp, colMul) {
    this.s8j(index, x, y, width, height, matrix, bmp.k3k(), bmp.l3k(), bmp.m3k(), bmp.n3k(), bmp.q3k(), bmp.r3k(), bmp.o3k(), bmp.p3k(), colMul);
  }
  s8j(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.k2c_1;
    var cf = matrix.m2c_1;
    var txf = matrix.o2c_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.n2c_1;
    var bf = matrix.l2c_1;
    var tyf = matrix.p2c_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.r8e_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.q8j(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.q8j(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.q8j(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.q8j(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ResourcesRoot {
  v8j(path, file) {
    _get_mountable__707cy(this).y31(path, file);
  }
  l6b(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.u8j_1 = this_0;
    tmp.t8j_1 = this_0.b27();
    this.v8j('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class RCollection {
  constructor() {
    this.w8j_1 = ArrayList.i1();
    this.x8j_1 = LinkedHashMap.hc();
  }
}
class Stats {
  constructor() {
    this.y8j_1 = new RCollection();
    this.z8j_1 = new RCollection();
  }
  w6m() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.y8j_1.w8j_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).w6m();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.z8j_1.w8j_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.d1(_unary__edvuaz_0).w6m();
    }
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.u1w() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.v1w() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.h8k_1 = key;
    this.i8k_1 = initial;
    this.j8k_1 = end;
    this.k8k_1 = interpolator;
    this.l8k_1 = includeStart;
    this.m8k_1 = fastStartTime;
    this.n8k_1 = fastDuration;
    this.o8k_1 = initialization;
    this.p8k_1 = FastDuration__plus_impl_q1enab(this.m8k_1, equals(this.n8k_1, Companion_instance_3.v1w()) ? get_fastNanoseconds_0(0) : this.n8k_1);
  }
  q8k() {
    return toDuration_1(this.m8k_1);
  }
  r8k() {
    return toDuration_1(this.n8k_1);
  }
  z38() {
    if (!this.l8k_1) {
      this.i8k_1 = this.h8k_1.get();
    }
    var tmp0_safe_receiver = this.o8k_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  s8k(ratio) {
    this.h8k_1.set(this.k8k_1(new Ratio(ratio), this.i8k_1, this.j8k_1));
  }
  toString() {
    return 'V2(key=' + this.h8k_1.callableName + ', range=[' + toString_1(this.i8k_1) + '-' + toString_1(this.j8k_1) + '], startTime=' + Duration__toString_impl_8d916b(this.q8k()) + ', duration=' + Duration__toString_impl_8d916b(this.r8k()) + ')';
  }
  hashCode() {
    var result = hashCode(this.h8k_1);
    result = imul(result, 31) + (this.i8k_1 == null ? 0 : hashCode(this.i8k_1)) | 0;
    result = imul(result, 31) + (this.j8k_1 == null ? 0 : hashCode(this.j8k_1)) | 0;
    result = imul(result, 31) + hashCode(this.k8k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l8k_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.m8k_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.n8k_1) | 0;
    result = imul(result, 31) + (this.o8k_1 == null ? 0 : hashCode(this.o8k_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.h8k_1, tmp0_other_with_cast.h8k_1))
      return false;
    if (!equals(this.i8k_1, tmp0_other_with_cast.i8k_1))
      return false;
    if (!equals(this.j8k_1, tmp0_other_with_cast.j8k_1))
      return false;
    if (!equals(this.k8k_1, tmp0_other_with_cast.k8k_1))
      return false;
    if (!(this.l8k_1 === tmp0_other_with_cast.l8k_1))
      return false;
    if (!equals(this.m8k_1, tmp0_other_with_cast.m8k_1))
      return false;
    if (!equals(this.n8k_1, tmp0_other_with_cast.n8k_1))
      return false;
    if (!equals(this.o8k_1, tmp0_other_with_cast.o8k_1))
      return false;
    return true;
  }
}
class DEFAULT {}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.t8k_1 = quality;
  }
  a8h() {
    return this.t8k_1;
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.u8k_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.x8k_1 = text;
    this.y8k_1 = enabled;
    this.z8k_1 = children;
    this.a8l_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.x8k_1 + ', enabled=' + this.y8k_1 + ', children=' + toString_1(this.z8k_1) + ', action=' + toString(this.a8l_1) + ')';
  }
  hashCode() {
    var result = this.x8k_1 == null ? 0 : getStringHashCode(this.x8k_1);
    result = imul(result, 31) + getBooleanHashCode(this.y8k_1) | 0;
    result = imul(result, 31) + (this.z8k_1 == null ? 0 : hashCode(this.z8k_1)) | 0;
    result = imul(result, 31) + hashCode(this.a8l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.x8k_1 == tmp0_other_with_cast.x8k_1))
      return false;
    if (!(this.y8k_1 === tmp0_other_with_cast.y8k_1))
      return false;
    if (!equals(this.z8k_1, tmp0_other_with_cast.z8k_1))
      return false;
    if (!equals(this.a8l_1, tmp0_other_with_cast.a8l_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.b8l_1 = 60;
    this.c8l_1 = Companion_getInstance_1().tx('GameWindow');
    this.d8l_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.r8n_1 = level;
    this.s8n_1 = 4000000;
  }
  b2x() {
    return this.r8n_1;
  }
  t8n(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.k3_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  u8n(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.s8n_1 : targetPixels;
    return $super === VOID ? this.t8n(width, height, devicePixelRatio, targetPixels) : $super.t8n.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.v8k_1 = $entry;
    this.w8k_1 = this$0;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
  }
}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.b8o_1 = this$0;
    super($initialValue, $box);
  }
  c8o(property, oldValue, newValue) {
    var tmp0_safe_receiver = this.b8o_1.v8m_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  }
  go(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    return this.c8o(property, tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  }
}
class GameWindow extends BaseEventListener {
  static d8o() {
    CoroutineKey_getInstance();
    var $this = this.t6d();
    $this.i8l_1 = new Mixin();
    $this.j8l_1 = Cursor_DEFAULT_getInstance();
    $this.k8l_1 = false;
    $this.l8l_1 = AGDummy.w7f();
    $this.m8l_1 = SyncEventLoopCoroutineDispatcher.g8o();
    $this.n8l_1 = GameWindowCoroutineDispatcher.r8o();
    $this.o8l_1 = new PauseEvent();
    $this.p8l_1 = new ResumeEvent();
    $this.q8l_1 = new StopEvent();
    $this.r8l_1 = new DestroyEvent();
    $this.s8l_1 = new UpdateEvent();
    $this.t8l_1 = new RenderEvent();
    $this.u8l_1 = new InitEvent();
    $this.v8l_1 = new DisposeEvent();
    $this.w8l_1 = new FullScreenEvent();
    $this.x8l_1 = new ReshapeEvent();
    $this.y8l_1 = new KeyEvent();
    $this.z8l_1 = new MouseEvent();
    $this.a8m_1 = new GestureEvent();
    $this.b8m_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.c8m_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.d8m_1 = 60;
    $this.e8m_1 = 0;
    $this.f8m_1 = 0;
    $this.g8m_1 = true;
    $this.h8m_1 = null;
    $this.i8m_1 = false;
    $this.j8m_1 = false;
    $this.k8m_1 = Colors_getInstance().i3z_1;
    $this.l8m_1 = new Signal();
    $this.m8m_1 = new Signal();
    $this.n8m_1 = null;
    $this.o8m_1 = false;
    $this.p8m_1 = true;
    $this.q8m_1 = 0;
    $this.r8m_1 = true;
    $this.s8m_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.t8m_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.u8m_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.v8m_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.w8m_1 = new _no_name_provided__qut3iv(true, $this);
    $this.x8m_1 = false;
    $this.y8m_1 = -1;
    $this.z8m_1 = -1;
    $this.a8n_1 = -1;
    $this.b8n_1 = -1;
    $this.c8n_1 = false;
    $this.d8n_1 = false;
    $this.e8n_1 = false;
    $this.f8n_1 = 0;
    $this.g8n_1 = Companion_instance_3.u1w();
    $this.h8n_1 = new Lock();
    $this.i8n_1 = booleanArray(Companion_getInstance_34().u6k_1);
    $this.j8n_1 = 0;
    $this.k8n_1 = 0.0;
    $this.l8n_1 = 0.0;
    $this.m8n_1 = 0.0;
    $this.n8n_1 = false;
    $this.o8n_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  s8o(_set____db54di) {
    this.j8l_1 = _set____db54di;
  }
  t8o() {
    return this.j8l_1;
  }
  m1() {
    return CoroutineKey_getInstance();
  }
  u8o() {
    return this.l8l_1;
  }
  v8o() {
    return this.n8l_1;
  }
  w8o(coroutineContext) {
    return coroutineContext.ym(this.v8o());
  }
  v8n($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.sc();
    return this.w8o(tmp$ret$0);
  }
  x8o(block) {
    return this.v6d(Companion_getInstance_18(), block);
  }
  x8n() {
    return get_fastMicroseconds(1000000.0 / this.y8o());
  }
  z8o() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.y8o();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  z8n() {
    return 60;
  }
  a8p(name, time) {
  }
  y8o() {
    return _get_fpsCached__581dty(this);
  }
  b8p(value) {
    return Unit_instance;
  }
  k2l() {
    return this.e8m_1;
  }
  l2l() {
    return this.f8m_1;
  }
  c8p(_set____db54di) {
    this.h8m_1 = _set____db54di;
  }
  d8p(_set____db54di) {
    this.i8m_1 = _set____db54di;
  }
  e8p(_set____db54di) {
    this.j8m_1 = _set____db54di;
  }
  f8p(_set____db54di) {
    this.k8m_1 = _set____db54di;
  }
  g8p() {
    return this.k8m_1;
  }
  h8p(value) {
    return Unit_instance;
  }
  a8h() {
    return Quality_AUTOMATIC_getInstance();
  }
  i8p(value) {
    this.o8m_1 = value;
    this.m8m_1.u1z(value);
    if (value) {
      invoke(this.l8m_1);
    }
  }
  j8p() {
    return this.o8m_1;
  }
  k8p(width, height) {
    return Unit_instance;
  }
  l8p(exitCode) {
    return this.k1e(exitCode);
  }
  m8p(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.l8p(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.l8p.call(this, exitCode);
    }
    return tmp;
  }
  k1e(exitCode) {
    if (this.s8m_1)
      return Unit_instance;
    this.s8m_1 = true;
    this.r8m_1 = false;
    this.q8m_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().c8l_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.v8o().g6();
    cancelChildren(this.v8o());
  }
  n8p(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.k1e(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.k1e.call(this, exitCode);
    }
    return tmp;
  }
  o8p($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_waitClose__fhnm35.bind(VOID, this), $completion);
  }
  p8p(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8.bind(VOID, this, entry), $completion);
  }
  y8n(time, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loopDelay__vgtnit.bind(VOID, this, time), $completion);
  }
  q8p(_set____db54di) {
    return this.w8m_1.ko(this, continuousRenderMode$factory(), _set____db54di);
  }
  r8p() {
    return this.w8m_1.io(this, continuousRenderMode$factory_0());
  }
  s8p(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().v6b();
    if (doRender) {
      var tmp = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark = Monotonic_instance.hj();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.t8p(doUpdate, true);
      tmp.t8m_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark_0 = Monotonic_instance.hj();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.t8p(true, false);
      }
      this.u8p(frameStartTime);
      tmp_0.u8m_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().w6b();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  w8n(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().w6b() : frameStartTime;
    return $super === VOID ? this.s8p(doUpdate, doRender, frameStartTime) : $super.s8p.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).x1w_1;
  }
  t8p(doUpdate, doRender) {
    if (doRender) {
      if (this.e8n_1) {
        this.e8n_1 = false;
        this.u8o().t6m();
      }
      if (this.x8m_1) {
        this.x8m_1 = false;
        this.u8o().s6m().l6r(this.y8m_1, this.z8m_1, this.a8n_1, this.b8n_1);
        this.v8p(this.y8m_1, this.z8m_1, this.a8n_1, this.b8n_1);
      }
    }
    if (this.c8n_1) {
      this.c8n_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.k2l() + ', ' + this.l2l() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.u8l_1;
      this_0.o6e_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.g6e(this_0);
    }
    try {
      this.w8p(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  w6m() {
    this.f8n_1 = 0;
  }
  x8p() {
    this.f8n_1 = this.f8n_1 + 1 | 0;
  }
  u8p(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.y8p();
    tmp.g8n_1 = stopwatch.b6c();
    try {
      var now = PerformanceCounter_getInstance().v6b();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.v8o().p8o_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.z8o(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.v8o().z8p(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  y8p() {
  }
  w8p(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.h8n_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.f1x();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.t8l_1;
        this_1.o6e_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.u6e_1 = update;
        this_1.v6e_1 = render;
        this.g6e(this_1);
        break $l$block;
      }finally {
        this_0.h1x();
      }
    }
  }
  a8q(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.b8m_1;
    this_0.o6e_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.h6h_1 = type;
    this_0.i6h_1 = files;
    return this.g6e(this_0);
  }
  v8p(x, y, width, height) {
    this.b8q(x, y, width, height, width, height);
  }
  b8q(x, y, width, height, fullWidth, fullHeight) {
    this.u8o().s6m().m6r(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.x8l_1;
    this_0.o6e_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.d6f_1 = x;
    this_0.e6f_1 = y;
    this_0.f6f_1 = width;
    this_0.g6f_1 = height;
    this.g6e(this_0);
  }
  l6j() {
    this.o8n_1.l6j();
  }
  x6j(info) {
    this.o8n_1.x6j(info);
  }
  z6j(out) {
    return this.o8n_1.z6j(out);
  }
  c8q(out, $super) {
    out = out === VOID ? IntArrayList.t2n() : out;
    return $super === VOID ? this.z6j(out) : $super.z6j.call(this, out);
  }
  cz(_set____db54di) {
    this.i8l_1.cz(_set____db54di);
  }
  dz() {
    return this.i8l_1.dz();
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.d8q_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    Companion_getInstance_74();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    title = title === VOID ? '' : title;
    this.e8q_1 = multithreaded;
    this.f8q_1 = hdr;
    this.g8q_1 = msaa;
    this.h8q_1 = checkGl;
    this.i8q_1 = logGl;
    this.j8q_1 = cacheGl;
    this.k8q_1 = fullscreen;
    this.l8q_1 = decorated;
    this.m8q_1 = transparent;
    this.n8q_1 = resizable;
    this.o8q_1 = title;
  }
  p8q(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    return new GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  q8q(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title, $super) {
    multithreaded = multithreaded === VOID ? this.e8q_1 : multithreaded;
    hdr = hdr === VOID ? this.f8q_1 : hdr;
    msaa = msaa === VOID ? this.g8q_1 : msaa;
    checkGl = checkGl === VOID ? this.h8q_1 : checkGl;
    logGl = logGl === VOID ? this.i8q_1 : logGl;
    cacheGl = cacheGl === VOID ? this.j8q_1 : cacheGl;
    fullscreen = fullscreen === VOID ? this.k8q_1 : fullscreen;
    decorated = decorated === VOID ? this.l8q_1 : decorated;
    transparent = transparent === VOID ? this.m8q_1 : transparent;
    resizable = resizable === VOID ? this.n8q_1 : resizable;
    title = title === VOID ? this.o8q_1 : title;
    return $super === VOID ? this.p8q(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) : $super.p8q.call(this, multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.e8q_1 + ', hdr=' + this.f8q_1 + ', msaa=' + this.g8q_1 + ', checkGl=' + this.h8q_1 + ', logGl=' + this.i8q_1 + ', cacheGl=' + this.j8q_1 + ', fullscreen=' + this.k8q_1 + ', decorated=' + this.l8q_1 + ', transparent=' + this.m8q_1 + ', resizable=' + this.n8q_1 + ', title=' + this.o8q_1 + ')';
  }
  hashCode() {
    var result = this.e8q_1 == null ? 0 : getBooleanHashCode(this.e8q_1);
    result = imul(result, 31) + (this.f8q_1 == null ? 0 : getBooleanHashCode(this.f8q_1)) | 0;
    result = imul(result, 31) + (this.g8q_1 == null ? 0 : this.g8q_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h8q_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8q_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j8q_1) | 0;
    result = imul(result, 31) + (this.k8q_1 == null ? 0 : getBooleanHashCode(this.k8q_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l8q_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m8q_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n8q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o8q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.e8q_1 == tmp0_other_with_cast.e8q_1))
      return false;
    if (!(this.f8q_1 == tmp0_other_with_cast.f8q_1))
      return false;
    if (!(this.g8q_1 == tmp0_other_with_cast.g8q_1))
      return false;
    if (!(this.h8q_1 === tmp0_other_with_cast.h8q_1))
      return false;
    if (!(this.i8q_1 === tmp0_other_with_cast.i8q_1))
      return false;
    if (!(this.j8q_1 === tmp0_other_with_cast.j8q_1))
      return false;
    if (!(this.k8q_1 == tmp0_other_with_cast.k8q_1))
      return false;
    if (!(this.l8q_1 === tmp0_other_with_cast.l8q_1))
      return false;
    if (!(this.m8q_1 === tmp0_other_with_cast.m8q_1))
      return false;
    if (!(this.n8q_1 === tmp0_other_with_cast.n8q_1))
      return false;
    if (!(this.o8q_1 === tmp0_other_with_cast.o8q_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.r8q_1 = time;
    this.s8q_1 = continuation;
    this.t8q_1 = callback;
    this.u8q_1 = null;
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_69 = this;
    this.v8q_1 = Companion_getInstance_1().tx('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.w8q_1 = function_0;
  }
  m19() {
    return this.w8q_1();
  }
  h4() {
    return this.w8q_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  static r8o(nowProvider, fast) {
    Companion_getInstance_75();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.p1c();
    $this.i8o_1 = nowProvider;
    $this.j8o_1 = fast;
    $this.k8o_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.l8o_1 = tmp_1.z2t(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.m8o_1 = new NonRecursiveLock();
    $this.n8o_1 = get_fastMilliseconds_0(0);
    $this.o8o_1 = get_fastMilliseconds_0(0);
    $this.p8o_1 = null;
    $this.q8o_1 = Companion_getInstance_1().tx('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  s1c(context, block) {
    return this.r1c(context, block);
  }
  x8q(block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m8o_1.a1x_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.k8o_1.j2u(block);
  }
  r1c(context, block) {
    return this.x8q(block);
  }
  y8q() {
    return this.i8o_1().x1w_1;
  }
  d1d(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.g4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.z8q(tmp$ret$0, continuation);
  }
  z8q(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.y8q(), time), continuation, null);
    continuation.a19(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m8o_1.a1x_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
    this.l8o_1.w2p(task);
  }
  e1d(timeMillis, block, context) {
    var tmp = this.y8q();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.g4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m8o_1.a1x_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
    this.l8o_1.w2p(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  z8p(availableTime) {
    this.a8r(get_fast(availableTime));
  }
  a8r(availableTime) {
    try {
      var startTime = this.y8q();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.m8o_1.a1x_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.l8o_1.g1()) {
          tmp_1 = this.j8o_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.l8o_1.f2u().r8q_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.l8o_1.g2u();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.u8q_1 == null)) {
            var tmp1_safe_receiver = item.s8q_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.u8q_1);
              var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.uc(tmp$ret$5);
            }
            if (!(item.t8q_1 == null)) {
              var tmp2_safe_receiver = item.u8q_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.s8q_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.uc(tmp$ret$7);
            }
            var tmp4_safe_receiver = item.t8q_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.n1b();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.y8q(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.b8r(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.n8o_1 = stopwatch.b6c();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.m8o_1.a1x_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.k8o_1.g1()) {
          tmp_4 = this.k8o_1.k2u();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.n1b();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.b6c();
        var elapsed = FastDuration__minus_impl_evs237(this.y8q(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.b8r(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.o8o_1 = stopwatch_0.b6c();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  }
  b8r(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.q8o_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.l8o_1.c2u_1 + ', tasks=' + this.k8o_1.e1() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  g6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.z8p(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_75().v8q_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.e2x(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.l8o_1.g1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.l8o_1.g2u().s8q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.uc(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.k8o_1.g1()) {
        break $l$loop_0;
      }
      this.k8o_1.k2u().n1b();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.j8o_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  static c8r(eventLoop) {
    var $this = this.p1c();
    $this.f8o_1 = eventLoop;
    return $this;
  }
  static g8o(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.c8r(new SyncEventLoop(immediateRun));
  }
  g6() {
    this.f8o_1.g6();
  }
  r1c(context, block) {
    this.f8o_1.b6d(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  d1d(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.a19(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.f8o_1.c6d(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  e1d(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.f8o_1.c6d(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_61 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.u1w() : fastDeltaTime;
    super();
    this.f8r_1 = fastDeltaTime;
  }
  g8r() {
    return toDuration_1(this.f8r_1);
  }
  v2c() {
    return Companion_instance_70;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.f8r_1) + ')';
  }
}
class Companion_62 {
  constructor() {
    this.h8r_1 = 536805376;
    this.i8r_1 = 805240832;
    this.j8r_1 = 2;
    this.k8r_1 = 32;
    this.l8r_1 = 256;
    this.m8r_1 = 512;
    this.n8r_1 = 768;
    this.o8r_1 = 769;
    this.p8r_1 = 1024;
    this.q8r_1 = 1025;
    this.r8r_1 = 1026;
    this.s8r_1 = 1027;
  }
}
class SDL extends FFILib {
  static l8s() {
    var $this = this.u2y([get_SDLPath()]);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().y2y_1;
    tmp.y8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config, true)).n2y($this, SDL_Init$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().y2y_1;
    tmp_0.z8r_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_0, true)).n2y($this, SDL_CreateWindow$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().y2y_1;
    tmp_1.a8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).n2y($this, SDL_SetWindowTitle$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().y2y_1;
    tmp_2.b8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).n2y($this, SDL_SetWindowSize$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().y2y_1;
    tmp_3.c8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).n2y($this, SDL_SetWindowPosition$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().y2y_1;
    tmp_4.d8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).n2y($this, SDL_ShowWindow$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().y2y_1;
    tmp_5.e8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).n2y($this, SDL_RaiseWindow$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().y2y_1;
    tmp_6.f8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), false))]), false), null, config_6, true)).n2y($this, SDL_PollEvent$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().y2y_1;
    tmp_7.g8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).n2y($this, SDL_Quit$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().y2y_1;
    tmp_8.h8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_8, true)).n2y($this, SDL_GL_CreateContext$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().y2y_1;
    tmp_9.i8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).n2y($this, SDL_GL_DeleteContext$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().y2y_1;
    tmp_10.j8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_10, true)).n2y($this, SDL_GL_MakeCurrent$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().y2y_1;
    tmp_11.k8s_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).n2y($this, SDL_GL_SwapWindow$factory());
    return $this;
  }
  m8s() {
    return this.y8r_1.io(this, SDL_Init$factory_0());
  }
  n8s() {
    return this.z8r_1.io(this, SDL_CreateWindow$factory_0());
  }
  o8s() {
    return this.a8s_1.io(this, SDL_SetWindowTitle$factory_0());
  }
  p8s() {
    return this.b8s_1.io(this, SDL_SetWindowSize$factory_0());
  }
  q8s() {
    return this.c8s_1.io(this, SDL_SetWindowPosition$factory_0());
  }
  r8s() {
    return this.d8s_1.io(this, SDL_ShowWindow$factory_0());
  }
  s8s() {
    return this.e8s_1.io(this, SDL_RaiseWindow$factory_0());
  }
  t8s() {
    return this.f8s_1.io(this, SDL_PollEvent$factory_0());
  }
  u8s() {
    return this.g8s_1.io(this, SDL_Quit$factory_0());
  }
  v8s() {
    return this.h8s_1.io(this, SDL_GL_CreateContext$factory_0());
  }
  w8s() {
    return this.i8s_1.io(this, SDL_GL_DeleteContext$factory_0());
  }
  x8s() {
    return this.j8s_1.io(this, SDL_GL_MakeCurrent$factory_0());
  }
  y8s() {
    return this.k8s_1.io(this, SDL_GL_SwapWindow$factory_0());
  }
}
class KmlGlOpenGL extends KmlGl {
  constructor(gl) {
    gl = gl === VOID ? OpenGL.c8z() : gl;
    super();
    this.h8z_1 = gl;
  }
  i8z(_this__u8e3s4) {
    return CreateFFIPointer(toLong(_this__u8e3s4));
  }
  j8z(_this__u8e3s4) {
    return CreateFFIPointer(_this__u8e3s4);
  }
  l7b(texture) {
    return this.h8z_1.k8z()(texture);
  }
  q7f(program, shader) {
    return this.h8z_1.l8z()(program, shader);
  }
  p7f(program, index, name) {
    return this.h8z_1.m8z()(program, index, name);
  }
  f7a(target, buffer) {
    return this.h8z_1.n8z()(target, buffer);
  }
  i7e(target, framebuffer) {
    return this.h8z_1.o8z()(target, framebuffer);
  }
  p7e(target, renderbuffer) {
    return this.h8z_1.p8z()(target, renderbuffer);
  }
  g7e(target, texture) {
    return this.h8z_1.q8z()(target, texture);
  }
  t7c(modeRGB, modeAlpha) {
    return this.h8z_1.r8z()(modeRGB, modeAlpha);
  }
  u7c(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.h8z_1.s8z()(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  p7b(target, size, data, usage) {
    return this.h8z_1.t8z()(target, this.i8z(size), get_pointer_0(data), usage);
  }
  o7b(target, offset, size, data) {
    return this.h8z_1.u8z()(target, this.i8z(offset), this.i8z(size), get_pointer_0(data));
  }
  p7c(mask) {
    return this.h8z_1.v8z()(mask);
  }
  k7c(red, green, blue, alpha) {
    return this.h8z_1.w8z()(red, green, blue, alpha);
  }
  m7c(d) {
    return this.h8z_1.x8z()(d);
  }
  o7c(s) {
    return this.h8z_1.y8z()(s);
  }
  w7e(red, green, blue, alpha) {
    var tmp = this.h8z_1.z8z();
    // Inline function 'korlibs.math.toInt' call
    var tmp_0 = red ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_1 = green ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_2 = blue ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    return tmp(tmp_0, tmp_1, tmp_2, alpha ? 1 : 0);
  }
  h7f(shader) {
    return this.h8z_1.a90()(shader);
  }
  j7f() {
    return this.h8z_1.b90()();
  }
  f7f(type) {
    return this.h8z_1.c90()(type);
  }
  m7d(mode) {
    return this.h8z_1.d90()(mode);
  }
  n84(n, items) {
    return this.h8z_1.e90()(n, get_pointer_0(items));
  }
  o84(n, items) {
    return this.h8z_1.f90()(n, get_pointer_0(items));
  }
  e7f(program) {
    return this.h8z_1.g90()(program);
  }
  p84(n, items) {
    return this.h8z_1.h90()(n, get_pointer_0(items));
  }
  d7f(shader) {
    return this.h8z_1.i90()(shader);
  }
  q84(n, items) {
    return this.h8z_1.j90()(n, get_pointer_0(items));
  }
  v7e(func) {
    return this.h8z_1.k90()(func);
  }
  l7c(flag) {
    var tmp = this.h8z_1.l90();
    // Inline function 'korlibs.math.toInt' call
    return tmp(flag ? 1 : 0);
  }
  u7e(n, f) {
    return this.h8z_1.m90()(n, f);
  }
  y7c(cap) {
    return this.h8z_1.n90()(cap);
  }
  o7d(index) {
    return this.h8z_1.o90()(index);
  }
  f7d(mode, first, count) {
    return this.h8z_1.p90()(mode, first, count);
  }
  h7d(mode, count, type, indices) {
    return this.h8z_1.q90()(mode, count, type, this.i8z(indices));
  }
  z7c(cap) {
    return this.h8z_1.r90()(cap);
  }
  s7d(index) {
    return this.h8z_1.s90()(index);
  }
  rc() {
    return this.h8z_1.t90()();
  }
  s7e(target, attachment, renderbuffertarget, renderbuffer) {
    return this.h8z_1.u90()(target, attachment, renderbuffertarget, renderbuffer);
  }
  r7e(target, attachment, textarget, texture, level) {
    return this.h8z_1.v90()(target, attachment, textarget, texture, level);
  }
  t7e(mode) {
    return this.h8z_1.w90()(mode);
  }
  r84(n, buffers) {
    return this.h8z_1.x90()(n, get_pointer_0(buffers));
  }
  t7b(target) {
    return this.h8z_1.y90()(target);
  }
  s84(n, framebuffers) {
    return this.h8z_1.z90()(n, get_pointer_0(framebuffers));
  }
  t84(n, renderbuffers) {
    return this.h8z_1.a91()(n, get_pointer_0(renderbuffers));
  }
  u84(n, textures) {
    return this.h8z_1.b91()(n, get_pointer_0(textures));
  }
  b7f(program, name) {
    return this.h8z_1.c91()(program, name);
  }
  i7f() {
    return this.h8z_1.d91()();
  }
  v84(pname, data) {
    return this.h8z_1.e91()(pname, get_pointer_0(data));
  }
  w84(program, pname, params) {
    return this.h8z_1.f91()(program, pname, get_pointer_0(params));
  }
  x84(shader, pname, params) {
    return this.h8z_1.g91()(shader, pname, get_pointer_0(params));
  }
  y84(shader, bufSize, length, infoLog) {
    this.h8z_1.h91()(shader, bufSize, get_pointer_0(length), get_pointer_0(infoLog));
  }
  a78(name) {
    var tmp0_elvis_lhs = this.h8z_1.i91()(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  r7f(program) {
    return this.h8z_1.j91()(program);
  }
  q7b(pname, param) {
    return this.h8z_1.k91()(pname, param);
  }
  q7e(target, internalformat, width, height) {
    return this.h8z_1.l91()(target, internalformat, width, height);
  }
  x7e(x, y, width, height) {
    return this.h8z_1.m91()(x, y, width, height);
  }
  g7f(shader, string) {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = CreateFFIMemory(8);
    var lengthsPtr = get_pointer(Deno.UnsafePointer.of(this_0));
    var bytes = encodeToByteArray(string + '\x00');
    set32(lengthsPtr, bytes.length - 1 | 0);
    // Inline function 'korlibs.ffi.usePointer' call
    var this_1 = CreateFFIMemory_0(bytes);
    var strPtr = get_pointer(Deno.UnsafePointer.of(this_1));
    // Inline function 'korlibs.ffi.usePointer' call
    var this_2 = CreateFFIMemory(8);
    var strPtrPtr = get_pointer(Deno.UnsafePointer.of(this_2));
    setFFIPointer(strPtrPtr, strPtr);
    this.h8z_1.n91()(shader, 1, strPtrPtr, lengthsPtr);
  }
  b7d(func, ref, mask) {
    return this.h8z_1.o91()(func, ref, mask);
  }
  a7d(face, func, ref, mask) {
    return this.h8z_1.p91()(face, func, ref, mask);
  }
  n7c(mask) {
    return this.h8z_1.q91()(mask);
  }
  e7d(face, mask) {
    return this.h8z_1.r91()(face, mask);
  }
  d7d(fail, zfail, zpass) {
    return this.h8z_1.s91()(fail, zfail, zpass);
  }
  c7d(face, sfail, dpfail, dppass) {
    return this.h8z_1.t91()(face, sfail, dpfail, dppass);
  }
  r7b(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp = this.h8z_1.u91();
    tmp(target, level, internalformat, width, height, border, format, type, pixels == null ? null : get_pointer_0(pixels));
  }
  k7b(target, pname, param) {
    return this.h8z_1.v91()(target, pname, param);
  }
  g7b(location, count, value) {
    return this.h8z_1.w91()(location, count, get_pointer_0(value));
  }
  e79(location, v0) {
    return this.h8z_1.x91()(location, v0);
  }
  z7a(location, count, value) {
    return this.h8z_1.y91()(location, count, get_pointer_0(value));
  }
  h7b(location, count, value) {
    return this.h8z_1.z91()(location, count, get_pointer_0(value));
  }
  a7b(location, count, value) {
    return this.h8z_1.a92()(location, count, get_pointer_0(value));
  }
  i7b(location, count, value) {
    return this.h8z_1.b92()(location, count, get_pointer_0(value));
  }
  b7b(location, count, value) {
    return this.h8z_1.c92()(location, count, get_pointer_0(value));
  }
  j7b(location, count, value) {
    return this.h8z_1.d92()(location, count, get_pointer_0(value));
  }
  c7b(location, count, value) {
    return this.h8z_1.e92()(location, count, get_pointer_0(value));
  }
  d7b(location, count, transpose, value) {
    var tmp = this.h8z_1.f92();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  e7b(location, count, transpose, value) {
    var tmp = this.h8z_1.g92();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  f7b(location, count, transpose, value) {
    var tmp = this.h8z_1.h92();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  c7f(program) {
    return this.h8z_1.i92()(program);
  }
  t7d(index, size, type, normalized, stride, pointer) {
    var tmp = this.h8z_1.j92();
    // Inline function 'korlibs.math.toInt' call
    return tmp(index, size, type, normalized ? 1 : 0, stride, this.j8z(pointer));
  }
  h7e(x, y, width, height) {
    return this.h8z_1.k92()(x, y, width, height);
  }
  g7d(mode, first, count, instancecount) {
    return this.h8z_1.l92()(mode, first, count, instancecount);
  }
  i7d(mode, count, type, indices, instancecount) {
    return this.h8z_1.m92()(mode, count, type, this.i8z(indices), instancecount);
  }
  n7d(index, divisor) {
    return this.h8z_1.n92()(index, divisor);
  }
  a6n() {
    return true;
  }
  a7e(target, index, buffer, offset, size) {
    return this.h8z_1.o92()(target, index, buffer, this.i8z(offset), this.i8z(size));
  }
  f79(program, name) {
    return this.h8z_1.p92()(program, name);
  }
  g79(program, uniformBlockIndex, uniformBlockBinding) {
    return this.h8z_1.q92()(program, uniformBlockIndex, uniformBlockBinding);
  }
  b6n() {
    return true;
  }
  z84(n, arrays) {
    return this.h8z_1.r92()(n, get_pointer_0(arrays));
  }
  p7d(array) {
    return this.h8z_1.s92()(array);
  }
}
class Companion_63 {
  constructor() {
    this.t92_1 = 16384;
  }
}
class OpenGL extends FFILib {
  static c8z() {
    var $this = this.u2y(['/System/Library/Frameworks/OpenGL.framework/OpenGL']);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().y2y_1;
    tmp.e8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config, true)).n2y($this, glDrawArraysInstanced$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().y2y_1;
    tmp_0.f8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_0, true)).n2y($this, glDrawElementsInstanced$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().y2y_1;
    tmp_1.g8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).n2y($this, glVertexAttribDivisor$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().y2y_1;
    tmp_2.h8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).n2y($this, glTexSubImage2D$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().y2y_1;
    tmp_3.i8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).n2y($this, glTexImage2D$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().y2y_1;
    tmp_4.j8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).n2y($this, glTexParameteri$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().y2y_1;
    tmp_5.k8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).n2y($this, glTexParameterf$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().y2y_1;
    tmp_6.l8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_6, true)).n2y($this, glTexParameterfv$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().y2y_1;
    tmp_7.m8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).n2y($this, glTexParameteriv$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().y2y_1;
    tmp_8.n8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_8, true)).n2y($this, glStencilOp$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().y2y_1;
    tmp_9.o8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).n2y($this, glStencilMask$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().y2y_1;
    tmp_10.p8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_10, true)).n2y($this, glReadPixels$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().y2y_1;
    tmp_11.q8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).n2y($this, glStencilFunc$factory());
    var tmp_12 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_12 = Companion_getInstance_13().y2y_1;
    tmp_12.r8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_12, true)).n2y($this, glScissor$factory());
    var tmp_13 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_13 = Companion_getInstance_13().y2y_1;
    tmp_13.s8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_13, true)).n2y($this, glPolygonOffset$factory());
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_14 = Companion_getInstance_13().y2y_1;
    tmp_14.t8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_14, true)).n2y($this, glPixelStorei$factory());
    var tmp_15 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_15 = Companion_getInstance_13().y2y_1;
    tmp_15.u8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_15, true)).n2y($this, glLineWidth$factory());
    var tmp_16 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_16 = Companion_getInstance_13().y2y_1;
    tmp_16.v8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_16, true)).n2y($this, glGetTexParameterfv$factory());
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_17 = Companion_getInstance_13().y2y_1;
    tmp_17.w8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_17, true)).n2y($this, glGetTexParameteriv$factory());
    var tmp_18 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_18 = Companion_getInstance_13().y2y_1;
    tmp_18.x8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_18, true)).n2y($this, glGetError$factory());
    var tmp_19 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_19 = Companion_getInstance_13().y2y_1;
    tmp_19.y8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_19, true)).n2y($this, glGetFloatv$factory());
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_20 = Companion_getInstance_13().y2y_1;
    tmp_20.z8t_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_20, true)).n2y($this, glGetIntegerv$factory());
    var tmp_21 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_21 = Companion_getInstance_13().y2y_1;
    tmp_21.a8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_21, true)).n2y($this, glGetBooleanv$factory());
    var tmp_22 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_22 = Companion_getInstance_13().y2y_1;
    tmp_22.b8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_22, true)).n2y($this, glGenTextures$factory());
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_23 = Companion_getInstance_13().y2y_1;
    tmp_23.c8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_23, true)).n2y($this, glDepthRange$factory());
    var tmp_24 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_24 = Companion_getInstance_13().y2y_1;
    tmp_24.d8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_24, true)).n2y($this, glDepthRangef$factory());
    var tmp_25 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_25 = Companion_getInstance_13().y2y_1;
    tmp_25.e8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_25, true)).n2y($this, glClearDepth$factory());
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_26 = Companion_getInstance_13().y2y_1;
    tmp_26.f8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_26, true)).n2y($this, glClearDepthf$factory());
    var tmp_27 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_27 = Companion_getInstance_13().y2y_1;
    tmp_27.g8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_27, true)).n2y($this, glDrawArrays$factory());
    var tmp_28 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_28 = Companion_getInstance_13().y2y_1;
    tmp_28.h8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_28, true)).n2y($this, glDrawElements$factory());
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_29 = Companion_getInstance_13().y2y_1;
    tmp_29.i8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_29, true)).n2y($this, glFrontFace$factory());
    var tmp_30 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_30 = Companion_getInstance_13().y2y_1;
    tmp_30.j8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_30, true)).n2y($this, glFinish$factory());
    var tmp_31 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_31 = Companion_getInstance_13().y2y_1;
    tmp_31.k8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_31, true)).n2y($this, glFlush$factory());
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_32 = Companion_getInstance_13().y2y_1;
    tmp_32.l8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_32, true)).n2y($this, glEnable$factory());
    var tmp_33 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_33 = Companion_getInstance_13().y2y_1;
    tmp_33.m8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_33, true)).n2y($this, glIsEnabled$factory());
    var tmp_34 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_34 = Companion_getInstance_13().y2y_1;
    tmp_34.n8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_34, true)).n2y($this, glDisable$factory());
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_35 = Companion_getInstance_13().y2y_1;
    tmp_35.o8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_35, true)).n2y($this, glDepthMask$factory());
    var tmp_36 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_36 = Companion_getInstance_13().y2y_1;
    tmp_36.p8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_36, true)).n2y($this, glDepthFunc$factory());
    var tmp_37 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_37 = Companion_getInstance_13().y2y_1;
    tmp_37.q8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_37, true)).n2y($this, glDeleteTextures$factory());
    var tmp_38 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_38 = Companion_getInstance_13().y2y_1;
    tmp_38.r8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_38, true)).n2y($this, glCullFace$factory());
    var tmp_39 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_39 = Companion_getInstance_13().y2y_1;
    tmp_39.s8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_39, true)).n2y($this, glCopyTexImage2D$factory());
    var tmp_40 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_40 = Companion_getInstance_13().y2y_1;
    tmp_40.t8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_40, true)).n2y($this, glCopyTexSubImage2D$factory());
    var tmp_41 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_41 = Companion_getInstance_13().y2y_1;
    tmp_41.u8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_41, true)).n2y($this, glColorMask$factory());
    var tmp_42 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_42 = Companion_getInstance_13().y2y_1;
    tmp_42.v8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_42, true)).n2y($this, glClearStencil$factory());
    var tmp_43 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_43 = Companion_getInstance_13().y2y_1;
    tmp_43.w8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_43, true)).n2y($this, glClearColor$factory());
    var tmp_44 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_44 = Companion_getInstance_13().y2y_1;
    tmp_44.x8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_44, true)).n2y($this, glClear$factory());
    var tmp_45 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_45 = Companion_getInstance_13().y2y_1;
    tmp_45.y8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_45, true)).n2y($this, glBindTexture$factory());
    var tmp_46 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_46 = Companion_getInstance_13().y2y_1;
    tmp_46.z8u_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_46, true)).n2y($this, glHint$factory());
    var tmp_47 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_47 = Companion_getInstance_13().y2y_1;
    tmp_47.a8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_47, true)).n2y($this, glViewport$factory());
    var tmp_48 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_48 = Companion_getInstance_13().y2y_1;
    tmp_48.b8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), true))]), false), null, config_48, true)).n2y($this, glGetString$factory());
    var tmp_49 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_49 = Companion_getInstance_13().y2y_1;
    tmp_49.c8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), true))]), false), null, config_49, true)).n2y($this, glGetStringi$factory());
    var tmp_50 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_50 = Companion_getInstance_13().y2y_1;
    tmp_50.d8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_50, true)).n2y($this, glVertexAttribPointer$factory());
    var tmp_51 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_51 = Companion_getInstance_13().y2y_1;
    tmp_51.e8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_51, true)).n2y($this, glVertexAttrib4fv$factory());
    var tmp_52 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_52 = Companion_getInstance_13().y2y_1;
    tmp_52.f8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_52, true)).n2y($this, glActiveTexture$factory());
    var tmp_53 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_53 = Companion_getInstance_13().y2y_1;
    tmp_53.g8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_53, true)).n2y($this, glAttachShader$factory());
    var tmp_54 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_54 = Companion_getInstance_13().y2y_1;
    tmp_54.h8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_54, true)).n2y($this, glBindAttribLocation$factory());
    var tmp_55 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_55 = Companion_getInstance_13().y2y_1;
    tmp_55.i8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_55, true)).n2y($this, glBindBuffer$factory());
    var tmp_56 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_56 = Companion_getInstance_13().y2y_1;
    tmp_56.j8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_56, true)).n2y($this, glBindFramebuffer$factory());
    var tmp_57 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_57 = Companion_getInstance_13().y2y_1;
    tmp_57.k8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_57, true)).n2y($this, glBindRenderbuffer$factory());
    var tmp_58 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_58 = Companion_getInstance_13().y2y_1;
    tmp_58.l8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_58, true)).n2y($this, glBlendColor$factory());
    var tmp_59 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_59 = Companion_getInstance_13().y2y_1;
    tmp_59.m8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_59, true)).n2y($this, glBlendEquation$factory());
    var tmp_60 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_60 = Companion_getInstance_13().y2y_1;
    tmp_60.n8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_60, true)).n2y($this, glBlendEquationSeparate$factory());
    var tmp_61 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_61 = Companion_getInstance_13().y2y_1;
    tmp_61.o8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_61, true)).n2y($this, glBlendFunc$factory());
    var tmp_62 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_62 = Companion_getInstance_13().y2y_1;
    tmp_62.p8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_62, true)).n2y($this, glBlendFuncSeparate$factory());
    var tmp_63 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_63 = Companion_getInstance_13().y2y_1;
    tmp_63.q8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_63, true)).n2y($this, glBufferData$factory());
    var tmp_64 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_64 = Companion_getInstance_13().y2y_1;
    tmp_64.r8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_64, true)).n2y($this, glBufferSubData$factory());
    var tmp_65 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_65 = Companion_getInstance_13().y2y_1;
    tmp_65.s8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_65, true)).n2y($this, glCheckFramebufferStatus$factory());
    var tmp_66 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_66 = Companion_getInstance_13().y2y_1;
    tmp_66.t8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_66, true)).n2y($this, glCompileShader$factory());
    var tmp_67 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_67 = Companion_getInstance_13().y2y_1;
    tmp_67.u8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_67, true)).n2y($this, glCompressedTexImage2D$factory());
    var tmp_68 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_68 = Companion_getInstance_13().y2y_1;
    tmp_68.v8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_68, true)).n2y($this, glCompressedTexSubImage2D$factory());
    var tmp_69 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_69 = Companion_getInstance_13().y2y_1;
    tmp_69.w8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_69, true)).n2y($this, glCreateProgram$factory());
    var tmp_70 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_70 = Companion_getInstance_13().y2y_1;
    tmp_70.x8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_70, true)).n2y($this, glCreateShader$factory());
    var tmp_71 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_71 = Companion_getInstance_13().y2y_1;
    tmp_71.y8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_71, true)).n2y($this, glDeleteBuffers$factory());
    var tmp_72 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_72 = Companion_getInstance_13().y2y_1;
    tmp_72.z8v_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_72, true)).n2y($this, glDeleteFramebuffers$factory());
    var tmp_73 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_73 = Companion_getInstance_13().y2y_1;
    tmp_73.a8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_73, true)).n2y($this, glDeleteProgram$factory());
    var tmp_74 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_74 = Companion_getInstance_13().y2y_1;
    tmp_74.b8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_74, true)).n2y($this, glDeleteRenderbuffers$factory());
    var tmp_75 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_75 = Companion_getInstance_13().y2y_1;
    tmp_75.c8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_75, true)).n2y($this, glDeleteShader$factory());
    var tmp_76 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_76 = Companion_getInstance_13().y2y_1;
    tmp_76.d8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_76, true)).n2y($this, glDetachShader$factory());
    var tmp_77 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_77 = Companion_getInstance_13().y2y_1;
    tmp_77.e8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_77, true)).n2y($this, glDisableVertexAttribArray$factory());
    var tmp_78 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_78 = Companion_getInstance_13().y2y_1;
    tmp_78.f8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_78, true)).n2y($this, glEnableVertexAttribArray$factory());
    var tmp_79 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_79 = Companion_getInstance_13().y2y_1;
    tmp_79.g8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_79, true)).n2y($this, glFramebufferRenderbuffer$factory());
    var tmp_80 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_80 = Companion_getInstance_13().y2y_1;
    tmp_80.h8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_80, true)).n2y($this, glFramebufferTexture2D$factory());
    var tmp_81 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_81 = Companion_getInstance_13().y2y_1;
    tmp_81.i8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_81, true)).n2y($this, glGenBuffers$factory());
    var tmp_82 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_82 = Companion_getInstance_13().y2y_1;
    tmp_82.j8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_82, true)).n2y($this, glGenerateMipmap$factory());
    var tmp_83 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_83 = Companion_getInstance_13().y2y_1;
    tmp_83.k8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_83, true)).n2y($this, glGenFramebuffers$factory());
    var tmp_84 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_84 = Companion_getInstance_13().y2y_1;
    tmp_84.l8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_84, true)).n2y($this, glGenRenderbuffers$factory());
    var tmp_85 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_85 = Companion_getInstance_13().y2y_1;
    tmp_85.m8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_85, true)).n2y($this, glGetActiveAttrib$factory());
    var tmp_86 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_86 = Companion_getInstance_13().y2y_1;
    tmp_86.n8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_86, true)).n2y($this, glGetActiveUniform$factory());
    var tmp_87 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_87 = Companion_getInstance_13().y2y_1;
    tmp_87.o8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_87, true)).n2y($this, glGetAttachedShaders$factory());
    var tmp_88 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_88 = Companion_getInstance_13().y2y_1;
    tmp_88.p8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_88, true)).n2y($this, glGetAttribLocation$factory());
    var tmp_89 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_89 = Companion_getInstance_13().y2y_1;
    tmp_89.q8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_89, true)).n2y($this, glGetUniformLocation$factory());
    var tmp_90 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_90 = Companion_getInstance_13().y2y_1;
    tmp_90.r8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_90, true)).n2y($this, glGetBufferParameteriv$factory());
    var tmp_91 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_91 = Companion_getInstance_13().y2y_1;
    tmp_91.s8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_91, true)).n2y($this, glGetFramebufferAttachmentParameteriv$factory());
    var tmp_92 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_92 = Companion_getInstance_13().y2y_1;
    tmp_92.t8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_92, true)).n2y($this, glGetProgramInfoLog$factory());
    var tmp_93 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_93 = Companion_getInstance_13().y2y_1;
    tmp_93.u8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_93, true)).n2y($this, glGetRenderbufferParameteriv$factory());
    var tmp_94 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_94 = Companion_getInstance_13().y2y_1;
    tmp_94.v8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_94, true)).n2y($this, glGetProgramiv$factory());
    var tmp_95 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_95 = Companion_getInstance_13().y2y_1;
    tmp_95.w8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_95, true)).n2y($this, glGetShaderiv$factory());
    var tmp_96 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_96 = Companion_getInstance_13().y2y_1;
    tmp_96.x8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_96, true)).n2y($this, glGetShaderInfoLog$factory());
    var tmp_97 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_97 = Companion_getInstance_13().y2y_1;
    tmp_97.y8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_97, true)).n2y($this, glGetShaderPrecisionFormat$factory());
    var tmp_98 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_98 = Companion_getInstance_13().y2y_1;
    tmp_98.z8w_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_98, true)).n2y($this, glGetShaderSource$factory());
    var tmp_99 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_99 = Companion_getInstance_13().y2y_1;
    tmp_99.a8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_99, true)).n2y($this, glGetUniformfv$factory());
    var tmp_100 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_100 = Companion_getInstance_13().y2y_1;
    tmp_100.b8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_100, true)).n2y($this, glGetUniformiv$factory());
    var tmp_101 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_101 = Companion_getInstance_13().y2y_1;
    tmp_101.c8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_101, true)).n2y($this, glGetVertexAttribfv$factory());
    var tmp_102 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_102 = Companion_getInstance_13().y2y_1;
    tmp_102.d8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_102, true)).n2y($this, glGetVertexAttribiv$factory());
    var tmp_103 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_103 = Companion_getInstance_13().y2y_1;
    tmp_103.e8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_103, true)).n2y($this, glGetVertexAttribPointerv$factory());
    var tmp_104 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_104 = Companion_getInstance_13().y2y_1;
    tmp_104.f8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_104, true)).n2y($this, glIsBuffer$factory());
    var tmp_105 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_105 = Companion_getInstance_13().y2y_1;
    tmp_105.g8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_105, true)).n2y($this, glIsFramebuffer$factory());
    var tmp_106 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_106 = Companion_getInstance_13().y2y_1;
    tmp_106.h8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_106, true)).n2y($this, glIsProgram$factory());
    var tmp_107 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_107 = Companion_getInstance_13().y2y_1;
    tmp_107.i8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_107, true)).n2y($this, glIsRenderbuffer$factory());
    var tmp_108 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_108 = Companion_getInstance_13().y2y_1;
    tmp_108.j8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_108, true)).n2y($this, glIsTexture$factory());
    var tmp_109 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_109 = Companion_getInstance_13().y2y_1;
    tmp_109.k8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_109, true)).n2y($this, glIsShader$factory());
    var tmp_110 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_110 = Companion_getInstance_13().y2y_1;
    tmp_110.l8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_110, true)).n2y($this, glLinkProgram$factory());
    var tmp_111 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_111 = Companion_getInstance_13().y2y_1;
    tmp_111.m8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_111, true)).n2y($this, glReleaseShaderCompiler$factory());
    var tmp_112 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_112 = Companion_getInstance_13().y2y_1;
    tmp_112.n8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_112, true)).n2y($this, glRenderbufferStorage$factory());
    var tmp_113 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_113 = Companion_getInstance_13().y2y_1;
    tmp_113.o8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_113, true)).n2y($this, glSampleCoverage$factory());
    var tmp_114 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_114 = Companion_getInstance_13().y2y_1;
    tmp_114.p8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_114, true)).n2y($this, glShaderBinary$factory());
    var tmp_115 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_115 = Companion_getInstance_13().y2y_1;
    tmp_115.q8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_115, true)).n2y($this, glShaderSource$factory());
    var tmp_116 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_116 = Companion_getInstance_13().y2y_1;
    tmp_116.r8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_116, true)).n2y($this, glStencilFuncSeparate$factory());
    var tmp_117 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_117 = Companion_getInstance_13().y2y_1;
    tmp_117.s8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_117, true)).n2y($this, glStencilMaskSeparate$factory());
    var tmp_118 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_118 = Companion_getInstance_13().y2y_1;
    tmp_118.t8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_118, true)).n2y($this, glStencilOpSeparate$factory());
    var tmp_119 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_119 = Companion_getInstance_13().y2y_1;
    tmp_119.u8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_119, true)).n2y($this, glUniform1f$factory());
    var tmp_120 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_120 = Companion_getInstance_13().y2y_1;
    tmp_120.v8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_120, true)).n2y($this, glUniform2f$factory());
    var tmp_121 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_121 = Companion_getInstance_13().y2y_1;
    tmp_121.w8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_121, true)).n2y($this, glUniform3f$factory());
    var tmp_122 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_122 = Companion_getInstance_13().y2y_1;
    tmp_122.x8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_122, true)).n2y($this, glUniform4f$factory());
    var tmp_123 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_123 = Companion_getInstance_13().y2y_1;
    tmp_123.y8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_123, true)).n2y($this, glUniform1i$factory());
    var tmp_124 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_124 = Companion_getInstance_13().y2y_1;
    tmp_124.z8x_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_124, true)).n2y($this, glUniform2i$factory());
    var tmp_125 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_125 = Companion_getInstance_13().y2y_1;
    tmp_125.a8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_125, true)).n2y($this, glUniform3i$factory());
    var tmp_126 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_126 = Companion_getInstance_13().y2y_1;
    tmp_126.b8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_126, true)).n2y($this, glUniform4i$factory());
    var tmp_127 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_127 = Companion_getInstance_13().y2y_1;
    tmp_127.c8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_127, true)).n2y($this, glUniform1fv$factory());
    var tmp_128 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_128 = Companion_getInstance_13().y2y_1;
    tmp_128.d8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_128, true)).n2y($this, glUniform2fv$factory());
    var tmp_129 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_129 = Companion_getInstance_13().y2y_1;
    tmp_129.e8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_129, true)).n2y($this, glUniform3fv$factory());
    var tmp_130 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_130 = Companion_getInstance_13().y2y_1;
    tmp_130.f8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_130, true)).n2y($this, glUniform4fv$factory());
    var tmp_131 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_131 = Companion_getInstance_13().y2y_1;
    tmp_131.g8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_131, true)).n2y($this, glUniform1iv$factory());
    var tmp_132 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_132 = Companion_getInstance_13().y2y_1;
    tmp_132.h8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_132, true)).n2y($this, glUniform2iv$factory());
    var tmp_133 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_133 = Companion_getInstance_13().y2y_1;
    tmp_133.i8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_133, true)).n2y($this, glUniform3iv$factory());
    var tmp_134 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_134 = Companion_getInstance_13().y2y_1;
    tmp_134.j8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_134, true)).n2y($this, glUniform4iv$factory());
    var tmp_135 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_135 = Companion_getInstance_13().y2y_1;
    tmp_135.k8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_135, true)).n2y($this, glUniformMatrix2fv$factory());
    var tmp_136 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_136 = Companion_getInstance_13().y2y_1;
    tmp_136.l8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_136, true)).n2y($this, glUniformMatrix3fv$factory());
    var tmp_137 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_137 = Companion_getInstance_13().y2y_1;
    tmp_137.m8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_137, true)).n2y($this, glUniformMatrix4fv$factory());
    var tmp_138 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_138 = Companion_getInstance_13().y2y_1;
    tmp_138.n8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_138, true)).n2y($this, glUseProgram$factory());
    var tmp_139 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_139 = Companion_getInstance_13().y2y_1;
    tmp_139.o8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_139, true)).n2y($this, glValidateProgram$factory());
    var tmp_140 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_140 = Companion_getInstance_13().y2y_1;
    tmp_140.p8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_140, true)).n2y($this, glVertexAttrib1f$factory());
    var tmp_141 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_141 = Companion_getInstance_13().y2y_1;
    tmp_141.q8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_141, true)).n2y($this, glVertexAttrib2f$factory());
    var tmp_142 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_142 = Companion_getInstance_13().y2y_1;
    tmp_142.r8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_142, true)).n2y($this, glVertexAttrib3f$factory());
    var tmp_143 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_143 = Companion_getInstance_13().y2y_1;
    tmp_143.s8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_143, true)).n2y($this, glVertexAttrib4f$factory());
    var tmp_144 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_144 = Companion_getInstance_13().y2y_1;
    tmp_144.t8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_144, true)).n2y($this, glVertexAttrib1fv$factory());
    var tmp_145 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_145 = Companion_getInstance_13().y2y_1;
    tmp_145.u8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_145, true)).n2y($this, glVertexAttrib2fv$factory());
    var tmp_146 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_146 = Companion_getInstance_13().y2y_1;
    tmp_146.v8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_146, true)).n2y($this, glVertexAttrib3fv$factory());
    var tmp_147 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_147 = Companion_getInstance_13().y2y_1;
    tmp_147.w8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_147, true)).n2y($this, glBindBufferRange$factory());
    var tmp_148 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_148 = Companion_getInstance_13().y2y_1;
    tmp_148.x8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().fg(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false), null, config_148, true)).n2y($this, glGetUniformBlockIndex$factory());
    var tmp_149 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_149 = Companion_getInstance_13().y2y_1;
    tmp_149.y8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_149, true)).n2y($this, glUniformBlockBinding$factory());
    var tmp_150 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_150 = Companion_getInstance_13().y2y_1;
    tmp_150.z8y_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_150, true)).n2y($this, glGenVertexArrays$factory());
    var tmp_151 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_151 = Companion_getInstance_13().y2y_1;
    tmp_151.a8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_151, true)).n2y($this, glDeleteVertexArrays$factory());
    var tmp_152 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_152 = Companion_getInstance_13().y2y_1;
    tmp_152.b8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_152, true)).n2y($this, glBindVertexArray$factory());
    return $this;
  }
  l92() {
    return this.e8t_1.io(this, glDrawArraysInstanced$factory_0());
  }
  m92() {
    return this.f8t_1.io(this, glDrawElementsInstanced$factory_0());
  }
  n92() {
    return this.g8t_1.io(this, glVertexAttribDivisor$factory_0());
  }
  u92() {
    return this.h8t_1.io(this, glTexSubImage2D$factory_0());
  }
  u91() {
    return this.i8t_1.io(this, glTexImage2D$factory_0());
  }
  v91() {
    return this.j8t_1.io(this, glTexParameteri$factory_0());
  }
  v92() {
    return this.k8t_1.io(this, glTexParameterf$factory_0());
  }
  w92() {
    return this.l8t_1.io(this, glTexParameterfv$factory_0());
  }
  x92() {
    return this.m8t_1.io(this, glTexParameteriv$factory_0());
  }
  s91() {
    return this.n8t_1.io(this, glStencilOp$factory_0());
  }
  q91() {
    return this.o8t_1.io(this, glStencilMask$factory_0());
  }
  y92() {
    return this.p8t_1.io(this, glReadPixels$factory_0());
  }
  o91() {
    return this.q8t_1.io(this, glStencilFunc$factory_0());
  }
  m91() {
    return this.r8t_1.io(this, glScissor$factory_0());
  }
  z92() {
    return this.s8t_1.io(this, glPolygonOffset$factory_0());
  }
  k91() {
    return this.t8t_1.io(this, glPixelStorei$factory_0());
  }
  a93() {
    return this.u8t_1.io(this, glLineWidth$factory_0());
  }
  b93() {
    return this.v8t_1.io(this, glGetTexParameterfv$factory_0());
  }
  c93() {
    return this.w8t_1.io(this, glGetTexParameteriv$factory_0());
  }
  d91() {
    return this.x8t_1.io(this, glGetError$factory_0());
  }
  d93() {
    return this.y8t_1.io(this, glGetFloatv$factory_0());
  }
  e91() {
    return this.z8t_1.io(this, glGetIntegerv$factory_0());
  }
  e93() {
    return this.a8u_1.io(this, glGetBooleanv$factory_0());
  }
  b91() {
    return this.b8u_1.io(this, glGenTextures$factory_0());
  }
  f93() {
    return this.c8u_1.io(this, glDepthRange$factory_0());
  }
  m90() {
    return this.d8u_1.io(this, glDepthRangef$factory_0());
  }
  g93() {
    return this.e8u_1.io(this, glClearDepth$factory_0());
  }
  x8z() {
    return this.f8u_1.io(this, glClearDepthf$factory_0());
  }
  p90() {
    return this.g8u_1.io(this, glDrawArrays$factory_0());
  }
  q90() {
    return this.h8u_1.io(this, glDrawElements$factory_0());
  }
  w90() {
    return this.i8u_1.io(this, glFrontFace$factory_0());
  }
  h93() {
    return this.j8u_1.io(this, glFinish$factory_0());
  }
  t90() {
    return this.k8u_1.io(this, glFlush$factory_0());
  }
  r90() {
    return this.l8u_1.io(this, glEnable$factory_0());
  }
  i93() {
    return this.m8u_1.io(this, glIsEnabled$factory_0());
  }
  n90() {
    return this.n8u_1.io(this, glDisable$factory_0());
  }
  l90() {
    return this.o8u_1.io(this, glDepthMask$factory_0());
  }
  k90() {
    return this.p8u_1.io(this, glDepthFunc$factory_0());
  }
  j90() {
    return this.q8u_1.io(this, glDeleteTextures$factory_0());
  }
  d90() {
    return this.r8u_1.io(this, glCullFace$factory_0());
  }
  j93() {
    return this.s8u_1.io(this, glCopyTexImage2D$factory_0());
  }
  k93() {
    return this.t8u_1.io(this, glCopyTexSubImage2D$factory_0());
  }
  z8z() {
    return this.u8u_1.io(this, glColorMask$factory_0());
  }
  y8z() {
    return this.v8u_1.io(this, glClearStencil$factory_0());
  }
  w8z() {
    return this.w8u_1.io(this, glClearColor$factory_0());
  }
  v8z() {
    return this.x8u_1.io(this, glClear$factory_0());
  }
  q8z() {
    return this.y8u_1.io(this, glBindTexture$factory_0());
  }
  l93() {
    return this.z8u_1.io(this, glHint$factory_0());
  }
  k92() {
    return this.a8v_1.io(this, glViewport$factory_0());
  }
  i91() {
    return this.b8v_1.io(this, glGetString$factory_0());
  }
  m93() {
    return this.c8v_1.io(this, glGetStringi$factory_0());
  }
  j92() {
    return this.d8v_1.io(this, glVertexAttribPointer$factory_0());
  }
  n93() {
    return this.e8v_1.io(this, glVertexAttrib4fv$factory_0());
  }
  k8z() {
    return this.f8v_1.io(this, glActiveTexture$factory_0());
  }
  l8z() {
    return this.g8v_1.io(this, glAttachShader$factory_0());
  }
  m8z() {
    return this.h8v_1.io(this, glBindAttribLocation$factory_0());
  }
  n8z() {
    return this.i8v_1.io(this, glBindBuffer$factory_0());
  }
  o8z() {
    return this.j8v_1.io(this, glBindFramebuffer$factory_0());
  }
  p8z() {
    return this.k8v_1.io(this, glBindRenderbuffer$factory_0());
  }
  o93() {
    return this.l8v_1.io(this, glBlendColor$factory_0());
  }
  p93() {
    return this.m8v_1.io(this, glBlendEquation$factory_0());
  }
  r8z() {
    return this.n8v_1.io(this, glBlendEquationSeparate$factory_0());
  }
  q93() {
    return this.o8v_1.io(this, glBlendFunc$factory_0());
  }
  s8z() {
    return this.p8v_1.io(this, glBlendFuncSeparate$factory_0());
  }
  t8z() {
    return this.q8v_1.io(this, glBufferData$factory_0());
  }
  u8z() {
    return this.r8v_1.io(this, glBufferSubData$factory_0());
  }
  r93() {
    return this.s8v_1.io(this, glCheckFramebufferStatus$factory_0());
  }
  a90() {
    return this.t8v_1.io(this, glCompileShader$factory_0());
  }
  s93() {
    return this.u8v_1.io(this, glCompressedTexImage2D$factory_0());
  }
  t93() {
    return this.v8v_1.io(this, glCompressedTexSubImage2D$factory_0());
  }
  b90() {
    return this.w8v_1.io(this, glCreateProgram$factory_0());
  }
  c90() {
    return this.x8v_1.io(this, glCreateShader$factory_0());
  }
  e90() {
    return this.y8v_1.io(this, glDeleteBuffers$factory_0());
  }
  f90() {
    return this.z8v_1.io(this, glDeleteFramebuffers$factory_0());
  }
  g90() {
    return this.a8w_1.io(this, glDeleteProgram$factory_0());
  }
  h90() {
    return this.b8w_1.io(this, glDeleteRenderbuffers$factory_0());
  }
  i90() {
    return this.c8w_1.io(this, glDeleteShader$factory_0());
  }
  u93() {
    return this.d8w_1.io(this, glDetachShader$factory_0());
  }
  o90() {
    return this.e8w_1.io(this, glDisableVertexAttribArray$factory_0());
  }
  s90() {
    return this.f8w_1.io(this, glEnableVertexAttribArray$factory_0());
  }
  u90() {
    return this.g8w_1.io(this, glFramebufferRenderbuffer$factory_0());
  }
  v90() {
    return this.h8w_1.io(this, glFramebufferTexture2D$factory_0());
  }
  x90() {
    return this.i8w_1.io(this, glGenBuffers$factory_0());
  }
  y90() {
    return this.j8w_1.io(this, glGenerateMipmap$factory_0());
  }
  z90() {
    return this.k8w_1.io(this, glGenFramebuffers$factory_0());
  }
  a91() {
    return this.l8w_1.io(this, glGenRenderbuffers$factory_0());
  }
  v93() {
    return this.m8w_1.io(this, glGetActiveAttrib$factory_0());
  }
  w93() {
    return this.n8w_1.io(this, glGetActiveUniform$factory_0());
  }
  x93() {
    return this.o8w_1.io(this, glGetAttachedShaders$factory_0());
  }
  y93() {
    return this.p8w_1.io(this, glGetAttribLocation$factory_0());
  }
  c91() {
    return this.q8w_1.io(this, glGetUniformLocation$factory_0());
  }
  z93() {
    return this.r8w_1.io(this, glGetBufferParameteriv$factory_0());
  }
  a94() {
    return this.s8w_1.io(this, glGetFramebufferAttachmentParameteriv$factory_0());
  }
  b94() {
    return this.t8w_1.io(this, glGetProgramInfoLog$factory_0());
  }
  c94() {
    return this.u8w_1.io(this, glGetRenderbufferParameteriv$factory_0());
  }
  f91() {
    return this.v8w_1.io(this, glGetProgramiv$factory_0());
  }
  g91() {
    return this.w8w_1.io(this, glGetShaderiv$factory_0());
  }
  h91() {
    return this.x8w_1.io(this, glGetShaderInfoLog$factory_0());
  }
  d94() {
    return this.y8w_1.io(this, glGetShaderPrecisionFormat$factory_0());
  }
  e94() {
    return this.z8w_1.io(this, glGetShaderSource$factory_0());
  }
  f94() {
    return this.a8x_1.io(this, glGetUniformfv$factory_0());
  }
  g94() {
    return this.b8x_1.io(this, glGetUniformiv$factory_0());
  }
  h94() {
    return this.c8x_1.io(this, glGetVertexAttribfv$factory_0());
  }
  i94() {
    return this.d8x_1.io(this, glGetVertexAttribiv$factory_0());
  }
  j94() {
    return this.e8x_1.io(this, glGetVertexAttribPointerv$factory_0());
  }
  k94() {
    return this.f8x_1.io(this, glIsBuffer$factory_0());
  }
  l94() {
    return this.g8x_1.io(this, glIsFramebuffer$factory_0());
  }
  m94() {
    return this.h8x_1.io(this, glIsProgram$factory_0());
  }
  n94() {
    return this.i8x_1.io(this, glIsRenderbuffer$factory_0());
  }
  o94() {
    return this.j8x_1.io(this, glIsTexture$factory_0());
  }
  p94() {
    return this.k8x_1.io(this, glIsShader$factory_0());
  }
  j91() {
    return this.l8x_1.io(this, glLinkProgram$factory_0());
  }
  q94() {
    return this.m8x_1.io(this, glReleaseShaderCompiler$factory_0());
  }
  l91() {
    return this.n8x_1.io(this, glRenderbufferStorage$factory_0());
  }
  r94() {
    return this.o8x_1.io(this, glSampleCoverage$factory_0());
  }
  s94() {
    return this.p8x_1.io(this, glShaderBinary$factory_0());
  }
  n91() {
    return this.q8x_1.io(this, glShaderSource$factory_0());
  }
  p91() {
    return this.r8x_1.io(this, glStencilFuncSeparate$factory_0());
  }
  r91() {
    return this.s8x_1.io(this, glStencilMaskSeparate$factory_0());
  }
  t91() {
    return this.t8x_1.io(this, glStencilOpSeparate$factory_0());
  }
  t94() {
    return this.u8x_1.io(this, glUniform1f$factory_0());
  }
  u94() {
    return this.v8x_1.io(this, glUniform2f$factory_0());
  }
  v94() {
    return this.w8x_1.io(this, glUniform3f$factory_0());
  }
  w94() {
    return this.x8x_1.io(this, glUniform4f$factory_0());
  }
  x91() {
    return this.y8x_1.io(this, glUniform1i$factory_0());
  }
  x94() {
    return this.z8x_1.io(this, glUniform2i$factory_0());
  }
  y94() {
    return this.a8y_1.io(this, glUniform3i$factory_0());
  }
  z94() {
    return this.b8y_1.io(this, glUniform4i$factory_0());
  }
  w91() {
    return this.c8y_1.io(this, glUniform1fv$factory_0());
  }
  z91() {
    return this.d8y_1.io(this, glUniform2fv$factory_0());
  }
  b92() {
    return this.e8y_1.io(this, glUniform3fv$factory_0());
  }
  d92() {
    return this.f8y_1.io(this, glUniform4fv$factory_0());
  }
  y91() {
    return this.g8y_1.io(this, glUniform1iv$factory_0());
  }
  a92() {
    return this.h8y_1.io(this, glUniform2iv$factory_0());
  }
  c92() {
    return this.i8y_1.io(this, glUniform3iv$factory_0());
  }
  e92() {
    return this.j8y_1.io(this, glUniform4iv$factory_0());
  }
  f92() {
    return this.k8y_1.io(this, glUniformMatrix2fv$factory_0());
  }
  g92() {
    return this.l8y_1.io(this, glUniformMatrix3fv$factory_0());
  }
  h92() {
    return this.m8y_1.io(this, glUniformMatrix4fv$factory_0());
  }
  i92() {
    return this.n8y_1.io(this, glUseProgram$factory_0());
  }
  a95() {
    return this.o8y_1.io(this, glValidateProgram$factory_0());
  }
  b95() {
    return this.p8y_1.io(this, glVertexAttrib1f$factory_0());
  }
  c95() {
    return this.q8y_1.io(this, glVertexAttrib2f$factory_0());
  }
  d95() {
    return this.r8y_1.io(this, glVertexAttrib3f$factory_0());
  }
  e95() {
    return this.s8y_1.io(this, glVertexAttrib4f$factory_0());
  }
  f95() {
    return this.t8y_1.io(this, glVertexAttrib1fv$factory_0());
  }
  g95() {
    return this.u8y_1.io(this, glVertexAttrib2fv$factory_0());
  }
  h95() {
    return this.v8y_1.io(this, glVertexAttrib3fv$factory_0());
  }
  o92() {
    return this.w8y_1.io(this, glBindBufferRange$factory_0());
  }
  p92() {
    return this.x8y_1.io(this, glGetUniformBlockIndex$factory_0());
  }
  q92() {
    return this.y8y_1.io(this, glUniformBlockBinding$factory_0());
  }
  r92() {
    return this.z8y_1.io(this, glGenVertexArrays$factory_0());
  }
  i95() {
    return this.a8z_1.io(this, glDeleteVertexArrays$factory_0());
  }
  s92() {
    return this.b8z_1.io(this, glBindVertexArray$factory_0());
  }
}
class SDLGameWindow$ag$1 extends KmlGlContext {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.m95_1 = this$0;
    super(this$0.b98_1, new KmlGlOpenGL(), VOID, $box);
  }
  j7d() {
    var tmp = this.m95_1.a98_1.x8s();
    var tmp_0 = this.c7c_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), this.m95_1.c98_1);
  }
  l7d() {
    var tmp = this.m95_1.a98_1.x8s();
    var tmp_0 = this.c7c_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), null);
  }
  g6() {
    this.m95_1.a98_1.w8s()(this.m95_1.c98_1);
  }
}
class SDLGameWindow extends GameWindow {
  static h98(size, config) {
    size = size === VOID ? Size2D.e2a(640, 480) : size;
    config = config === VOID ? Companion_getInstance_74().d8q_1 : config;
    var $this = this.d8o();
    $this.y97_1 = size;
    $this.z97_1 = config;
    $this.a98_1 = SDL.l8s();
    $this.b98_1 = $this.a98_1.n8s()($this.z97_1.o8q_1, 805240832, 805240832, numberToInt($this.y97_1.c2a_1), numberToInt($this.y97_1.d2a_1), 34);
    $this.c98_1 = $this.a98_1.v8s()($this.b98_1);
    $this.a98_1.r8s()($this.b98_1);
    var tmp = $this;
    tmp.d98_1 = AGOpengl.b7c(new SDLGameWindow$ag$1($this));
    $this.e98_1 = $this.u8o().q76_1;
    $this.f98_1 = '';
    $this.g98_1 = CreateFFIMemory(1024);
    return $this;
  }
  u8o() {
    return this.d98_1;
  }
  b8p(value) {
    this.f98_1 = value;
    this.a98_1.o8s()(this.b98_1, this.i98());
  }
  i98() {
    return this.f98_1;
  }
  k8p(width, height) {
    this.a98_1.p8s()(this.b98_1, width, height);
    this.a98_1.q8s()(this.b98_1, 805240832, 805240832);
  }
  j98() {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = this.g98_1;
    var it = get_pointer(Deno.UnsafePointer.of(this_0));
    while (this.a98_1.t8s()(it)) {
      var type = getS32(it, 0);
      switch (type) {
        case 512:
          println('WINDOW EVENT');
          break;
        case 1024:
          println('MOUSE MOTION');
          break;
        case 1025:
          println('MOUSE DOWN');
          break;
        case 1026:
          println('MOUSE UP');
          break;
        case 256:
          this.n8p();
          break;
        default:
          println('EVENT: type=' + type);
          break;
      }
    }
    this.a98_1.x8s()(this.b98_1, this.c98_1);
    this.e98_1.k7c(1.0, 0.0, 0.0, 1.0);
    this.e98_1.p7c(16384);
  }
  k98() {
    this.a98_1.y8s()(this.b98_1);
  }
  k1e(exitCode) {
    super.k1e(exitCode);
    this.a98_1.w8s()(this.c98_1);
    this.a98_1.u8s()();
  }
}
class Size3D {
  constructor(width, height, depthOrArrayLayers) {
    height = height === VOID ? 1 : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? 1 : depthOrArrayLayers;
    this.width = width;
    this.height = height;
    this.depthOrArrayLayers = depthOrArrayLayers;
  }
  s8b(_set____db54di) {
    this.width = _set____db54di;
  }
  k2l() {
    return this.width;
  }
  t8b(_set____db54di) {
    this.height = _set____db54di;
  }
  l2l() {
    return this.height;
  }
  l98(_set____db54di) {
    this.depthOrArrayLayers = _set____db54di;
  }
  m98() {
    return this.depthOrArrayLayers;
  }
  toArray() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.width, this.height, this.depthOrArrayLayers];
  }
  il() {
    return this.width;
  }
  jl() {
    return this.height;
  }
  qr() {
    return this.depthOrArrayLayers;
  }
  n98(width, height, depthOrArrayLayers) {
    return new Size3D(width, height, depthOrArrayLayers);
  }
  copy(width, height, depthOrArrayLayers, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? this.depthOrArrayLayers : depthOrArrayLayers;
    return this.n98(width, height, depthOrArrayLayers);
  }
  toString() {
    return 'Size3D(width=' + this.width + ', height=' + this.height + ', depthOrArrayLayers=' + this.depthOrArrayLayers + ')';
  }
  hashCode() {
    var result = this.width;
    result = imul(result, 31) + this.height | 0;
    result = imul(result, 31) + this.depthOrArrayLayers | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size3D))
      return false;
    var tmp0_other_with_cast = other instanceof Size3D ? other : THROW_CCE();
    if (!(this.width === tmp0_other_with_cast.width))
      return false;
    if (!(this.height === tmp0_other_with_cast.height))
      return false;
    if (!(this.depthOrArrayLayers === tmp0_other_with_cast.depthOrArrayLayers))
      return false;
    return true;
  }
}
class AGOpenglFactory {
  j8a() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.s98_1 = canvas;
    this.t98_1 = glOpts;
    this.u98_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp1_safe_receiver = this.s98_1.getContext('webgl2', this.t98_1);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.u98_1 = 2;
        tmp_1 = tmp1_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.s98_1.getContext('webgl', this.t98_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.s98_1.getContext('experimental-webgl', this.t98_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.u98_1 + ', opts=' + JSON.stringify(this.t98_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      try {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException.a5(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.v98_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.w98_1 = fillArrayVal(Array(8192), null);
    this.x98_1 = toMutableList(reversed_0(until(1, this.w98_1.length)));
    var tmp_7 = this;
    tmp_7.y98_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.z98_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.a99_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.b99_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  m7b() {
    return Companion_instance_54.s7i(this.u98_1);
  }
  l7b(texture) {
    return this.v98_1.activeTexture(texture);
  }
  q7f(program, shader) {
    return this.v98_1.attachShader(get_2(program, this), get_2(shader, this));
  }
  p7f(program, index, name) {
    return this.v98_1.bindAttribLocation(get_2(program, this), index, name);
  }
  f7a(target, buffer) {
    return this.v98_1.bindBuffer(target, get_2(buffer, this));
  }
  i7e(target, framebuffer) {
    return this.v98_1.bindFramebuffer(target, get_2(framebuffer, this));
  }
  p7e(target, renderbuffer) {
    return this.v98_1.bindRenderbuffer(target, get_2(renderbuffer, this));
  }
  g7e(target, texture) {
    return this.v98_1.bindTexture(target, get_2(texture, this));
  }
  t7c(modeRGB, modeAlpha) {
    return this.v98_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  u7c(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.v98_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  p7b(target, size, data, usage) {
    return this.v98_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  o7b(target, offset, size, data) {
    return this.v98_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  p7c(mask) {
    return this.v98_1.clear(mask);
  }
  k7c(red, green, blue, alpha) {
    return this.v98_1.clearColor(red, green, blue, alpha);
  }
  m7c(d) {
    return this.v98_1.clearDepth(d);
  }
  o7c(s) {
    return this.v98_1.clearStencil(s);
  }
  w7e(red, green, blue, alpha) {
    return this.v98_1.colorMask(red, green, blue, alpha);
  }
  h7f(shader) {
    return this.v98_1.compileShader(get_2(shader, this));
  }
  j7f() {
    return alloc(this.v98_1.createProgram(), this);
  }
  f7f(type) {
    return alloc(this.v98_1.createShader(type), this);
  }
  m7d(mode) {
    return this.v98_1.cullFace(mode);
  }
  n84(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.v98_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  o84(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.v98_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  e7f(program) {
    return this.v98_1.deleteProgram(get_2(program, this));
  }
  p84(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.v98_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  d7f(shader) {
    return this.v98_1.deleteShader(get_2(shader, this));
  }
  q84(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.v98_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  v7e(func) {
    return this.v98_1.depthFunc(func);
  }
  l7c(flag) {
    return this.v98_1.depthMask(flag);
  }
  u7e(n, f) {
    return this.v98_1.depthRange(n, f);
  }
  y7c(cap) {
    return this.v98_1.disable(cap);
  }
  o7d(index) {
    return this.v98_1.disableVertexAttribArray(index);
  }
  f7d(mode, first, count) {
    return this.v98_1.drawArrays(mode, first, count);
  }
  h7d(mode, count, type, indices) {
    return this.v98_1.drawElements(mode, count, type, indices);
  }
  z7c(cap) {
    return this.v98_1.enable(cap);
  }
  s7d(index) {
    return this.v98_1.enableVertexAttribArray(index);
  }
  rc() {
    return this.v98_1.flush();
  }
  s7e(target, attachment, renderbuffertarget, renderbuffer) {
    return this.v98_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_2(renderbuffer, this));
  }
  r7e(target, attachment, textarget, texture, level) {
    return this.v98_1.framebufferTexture2D(target, attachment, textarget, get_2(texture, this), level);
  }
  t7e(mode) {
    return this.v98_1.frontFace(mode);
  }
  r84(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.v98_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  }
  t7b(target) {
    return this.v98_1.generateMipmap(target);
  }
  s84(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.v98_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  }
  t84(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.v98_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  }
  u84(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.v98_1.createTexture(), this);
      }
       while (inductionVariable < n);
  }
  b7f(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_2(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this.v98_1.getUniformLocation(prg, name), this);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  i7f() {
    return this.v98_1.getError();
  }
  v84(pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.v98_1.getParameter(pname);
  }
  w84(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.v98_1.getProgramInfoLog(get_2(program, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.v98_1.getProgramParameter(get_2(program, this), pname);
    }
  }
  x84(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.v98_1.getShaderInfoLog(get_2(shader, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.v98_1.getShaderParameter(get_2(shader, this), pname);
    }
  }
  y84(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.v98_1.getShaderInfoLog(get_2(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  a78(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.v98_1.getParameter(name);
  }
  r7f(program) {
    return this.v98_1.linkProgram(get_2(program, this));
  }
  q7b(pname, param) {
    return this.v98_1.pixelStorei(pname, param);
  }
  q7e(target, internalformat, width, height) {
    return this.v98_1.renderbufferStorage(target, internalformat, width, height);
  }
  x7e(x, y, width, height) {
    return this.v98_1.scissor(x, y, width, height);
  }
  g7f(shader, string) {
    return this.v98_1.shaderSource(get_2(shader, this), string);
  }
  b7d(func, ref, mask) {
    return this.v98_1.stencilFunc(func, ref, mask);
  }
  a7d(face, func, ref, mask) {
    return this.v98_1.stencilFuncSeparate(face, func, ref, mask);
  }
  n7c(mask) {
    return this.v98_1.stencilMask(mask);
  }
  e7d(face, mask) {
    return this.v98_1.stencilMaskSeparate(face, mask);
  }
  d7d(fail, zfail, zpass) {
    return this.v98_1.stencilOp(fail, zfail, zpass);
  }
  c7d(face, sfail, dpfail, dppass) {
    return this.v98_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  r7b(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.v98_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  s7b(target, level, internalformat, format, type, data) {
    if (data instanceof HtmlNativeImage) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = !data.h3y_1 && data.g3y_1 ? 1 : 0;
      this.v98_1.pixelStorei(37441, tmp$ret$0);
      this.v98_1.texImage2D(target, level, internalformat, format, type, data.u5p_1);
      this.v98_1.pixelStorei(37441, 0);
    } else {
      return super.s7b(target, level, internalformat, format, type, data);
    }
  }
  k7b(target, pname, param) {
    return this.v98_1.texParameteri(target, pname, param);
  }
  g7b(location, count, value) {
    return this.v98_1.uniform1fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  e79(location, v0) {
    return this.v98_1.uniform1i(get_2(location, this), v0);
  }
  z7a(location, count, value) {
    return this.v98_1.uniform1iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  h7b(location, count, value) {
    return this.v98_1.uniform2fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  a7b(location, count, value) {
    return this.v98_1.uniform2iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  i7b(location, count, value) {
    return this.v98_1.uniform3fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  b7b(location, count, value) {
    return this.v98_1.uniform3iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  j7b(location, count, value) {
    return this.v98_1.uniform4fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  c7b(location, count, value) {
    return this.v98_1.uniform4iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  d7b(location, count, transpose, value) {
    return this.v98_1.uniformMatrix2fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  e7b(location, count, transpose, value) {
    return this.v98_1.uniformMatrix3fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  f7b(location, count, transpose, value) {
    return this.v98_1.uniformMatrix4fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  c7f(program) {
    return this.v98_1.useProgram(get_2(program, this));
  }
  t7d(index, size, type, normalized, stride, pointer) {
    return this.v98_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.e2());
  }
  h7e(x, y, width, height) {
    return this.v98_1.viewport(x, y, width, height);
  }
  j5u() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y98_1;
    extensions$factory();
    return this_0.n1();
  }
  g7d(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.v98_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  i7d(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.v98_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  n7d(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.v98_1.vertexAttribDivisor(index, divisor);
  }
  a6n() {
    return get_versionInt(this) >= 2;
  }
  a7e(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.v98_1.bindBufferRange(target, index, get_2(buffer, this), offset, size);
  }
  f79(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.v98_1.getUniformBlockIndex(get_2(program, this), name);
  }
  g79(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.v98_1.uniformBlockBinding(get_2(program, this), uniformBlockIndex, uniformBlockBinding);
  }
  b6n() {
    return this.b99_1.j99();
  }
  z84(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.v98_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  p7d(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.v98_1.bindVertexArray(get_2(array, this));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.c99_1 = canvas;
    this.d99_1 = name;
    this.e99_1 = coreSince;
    this.f99_1 = functions;
    this.g99_1 = suffix;
    this.h99_1 = false;
    this.i99_1 = null;
  }
  n1() {
    if (!this.h99_1) {
      this.h99_1 = true;
      this.i99_1 = this.c99_1.v98_1.getExtension(this.d99_1);
      var _iterator__ex2g4s = this.f99_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var func = _iterator__ex2g4s.c1();
        var base = removeSuffix(func, this.g99_1);
        var vfunc = this.i99_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.c99_1.v98_1[base] = vfunc.bind(this.i99_1);
        }
      }
    }
    return this.i99_1;
  }
  j99() {
    return this.c99_1.u98_1 >= this.e99_1 || this.n1() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class JsGameWindow extends GameWindow {
  static d9k() {
    return this.d8o();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  static w9e() {
    return this.d9k();
  }
}
class BrowserCanvasJsGameWindow$close$slambda {
  constructor(this$0) {
    this.e9k_1 = this$0;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.f9k_1 = $entry;
    this.g9k_1 = this$0;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  static k9c(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.d9k();
    $this.v9b_1 = canvas;
    $this.w9b_1 = AGWebgl(new AGConfig(), $this.v9b_1);
    $this.x9b_1 = new DialogInterfaceJs();
    $this.y9b_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z9b_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.a9c_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.b9c_1 = new GamepadInfo();
    $this.c9c_1 = Quality_AUTOMATIC_getInstance();
    $this.d9c_1 = 1.0;
    $this.e9c_1 = new TouchBuilder();
    $this.f9c_1 = Cursor_DEFAULT_getInstance();
    $this.g9c_1 = null;
    $this.h9c_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.v9b_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.u8o();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.u8o().q76_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($this.v9b_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.v9b_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.v9b_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.v9b_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.v9b_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.v9b_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.v9b_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.v9b_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.v9b_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.v9b_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.v9b_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.v9b_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.v9b_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.v9b_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.v9b_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.v9b_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.v9b_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.v9b_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.v9b_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.v9b_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.i9c_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.j9c_1 = null;
    return $this;
  }
  i9k() {
    return window.devicePixelRatio;
  }
  s8h() {
    return this.i9k() <= 0.0 ? 1.0 : isNaN_0(this.i9k()) ? 1.0 : isInfinite(this.i9k()) ? 1.0 : this.i9k();
  }
  u8o() {
    return this.w9b_1;
  }
  h9k() {
    if (this.y9b_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.y9b_1 = tmp_0;
    }
    return ensureNotNull(this.y9b_1);
  }
  y8p() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.l6j();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.b9c_1;
            gamepad.s6j_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.z9b_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.t6j_1;
                var tmp_1 = this.z9b_1[n].p6k();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.a9c_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_24.k6k(value, VOID, n_0 <= 3);
                gamepad.t6j_1[this.a9c_1[n_0].p6k()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.x6j(gamepad);
          }
           while (inductionVariable < last);
        this.c8q();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().c8l_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.d2x(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.e2x(level, e);
        tmp_2 = Unit_instance;
      }
    }
  }
  h8p(value) {
    if (!this.c9c_1.equals(value)) {
      this.c9c_1 = value;
      onResized(this);
    }
  }
  a8h() {
    return this.c9c_1;
  }
  b8p(value) {
    document.title = value;
  }
  k2l() {
    return this.v9b_1.clientWidth;
  }
  l2l() {
    return this.v9b_1.clientHeight;
  }
  s8o(value) {
    this.f9c_1 = value;
    var tmp = this.v9b_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.k3_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  t8o() {
    return this.f9c_1;
  }
  c8p(value) {
    this.g9c_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).k5q();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  }
  d8p(value) {
    if (!(this.j9k() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.v9b_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  j9k() {
    return !(document.fullscreenElement == null);
  }
  e8p(value) {
    this.v9b_1.style.visibility = value ? 'visible' : 'hidden';
  }
  k8p(width, height) {
  }
  k1e(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this));
    this.h9c_1 = null;
  }
  p8p(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_0.bind(VOID, this, entry), $completion);
  }
}
class DenoJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.k9k_1 = $entry;
    this.l9k_1 = this$0;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class DenoJsGameWindow extends SDLGameWindow {
  static r9h(size, config) {
    size = size === VOID ? Size2D.e2a(640, 480) : size;
    config = config === VOID ? Companion_getInstance_74().d8q_1 : config;
    return this.h98(size, config);
  }
  p8p(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_1.bind(VOID, this, entry), $completion);
  }
  k1e(exitCode) {
    super.k1e(exitCode);
    Deno.exit(exitCode);
  }
}
class DialogInterfaceJs {}
//endregion
function _get_now__e6dlkr($this) {
  return $this.w6c_1().nj_1;
}
function _queueAfter($this, time, interval, task) {
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  var this_0 = $this.t6c_1;
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.f1x();
    try {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop._queueAfter.<anonymous>' call
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.u6c_1) {
        $this.y6c_1.w2p(task_0);
      } else {
        Console_getInstance().j2w(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.t6c_1.j1x();
      break $l$block;
    }finally {
      this_0.h1x();
    }
  }
  return task_0;
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return function () {
    return new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.v6c_1));
  };
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.o6c(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function paused$factory($b0) {
  return getPropertyCallableRef('paused', 0, KMutableProperty0, function () {
    return $b0.r2u_1;
  }, function (value) {
    return $b0.s2u(value);
  });
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.s6d_1 == null)
    $this.s6d_1 = FastIdentityMap();
  var tmp0_safe_receiver = $this.s6d_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_elvis_lhs = get_0(ensureNotNull($this.s6d_1), type);
    set(tmp0_safe_receiver, type, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + delta | 0);
  }
  var tmp2_safe_receiver = $this.q6d_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp2_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp0_safe_receiver = child.s6d_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp0_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
      var i = ensureNotNull(get_0(tmp0_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Companion_instance_8;
function Companion_getInstance_14() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_15() {
  return Companion_instance_9;
}
var Companion_instance_10;
function Companion_getInstance_16() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_17() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_18() {
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_19() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_20() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_21() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_22() {
  return Companion_instance_16;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_17;
function Companion_getInstance_23() {
  Type_initEntries();
  if (Companion_instance_17 === VOID)
    new Companion_8();
  return Companion_instance_17;
}
function values() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_UP_instance = new Type('UP', 0);
  Type_DOWN_instance = new Type('DOWN', 1);
  Type_TYPE_instance = new Type('TYPE', 2);
  Companion_getInstance_23();
}
function Type_UP_getInstance() {
  Type_initEntries();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_18;
function Companion_getInstance_24() {
  Type_initEntries_0();
  if (Companion_instance_18 === VOID)
    new Companion_9();
  return Companion_instance_18;
}
function values_0() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_MOVE_instance = new Type_0('MOVE', 0);
  Type_DRAG_instance = new Type_0('DRAG', 1);
  Type_UP_instance_0 = new Type_0('UP', 2);
  Type_DOWN_instance_0 = new Type_0('DOWN', 3);
  Type_CLICK_instance = new Type_0('CLICK', 4);
  Type_ENTER_instance = new Type_0('ENTER', 5);
  Type_EXIT_instance = new Type_0('EXIT', 6);
  Type_SCROLL_instance = new Type_0('SCROLL', 7);
  Companion_getInstance_24();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_0();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_0();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_0();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_0();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_0();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_0();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_0();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_0();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_19;
function Companion_getInstance_25() {
  Type_initEntries_1();
  if (Companion_instance_19 === VOID)
    new Companion_10();
  return Companion_instance_19;
}
function values_1() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MAGNIFY_instance = new Type_1('MAGNIFY', 0);
  Type_ROTATE_instance = new Type_1('ROTATE', 1);
  Type_SWIPE_instance = new Type_1('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type_1('SMART_MAGNIFY', 3);
  Companion_getInstance_25();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries_1();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries_1();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_SMART_MAGNIFY_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_DROP_instance;
var Companion_instance_20;
function Companion_getInstance_26() {
  Type_initEntries_2();
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_DROP_instance = new Type_2('DROP', 2);
  Companion_getInstance_26();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_DROP_getInstance() {
  Type_initEntries_2();
  return Type_DROP_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_21;
function Companion_getInstance_27() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_22;
function Companion_getInstance_28() {
  Type_initEntries_3();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_MOVE_instance_0 = new Type_3('MOVE', 2);
  Type_HOVER_instance = new Type_3('HOVER', 3);
  Type_UNKNOWN_instance = new Type_3('UNKNOWN', 4);
  Companion_getInstance_28();
}
var Companion_instance_23;
function Companion_getInstance_29() {
  return Companion_instance_23;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_3();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_3();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_3();
  return Type_UNKNOWN_instance;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_24;
function Companion_getInstance_30() {
  return Companion_instance_24;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Companion_instance_25;
function Companion_getInstance_31() {
  return Companion_instance_25;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_32() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_32();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_33() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_33();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_34() {
  Key_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_34();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_29;
function Companion_getInstance_35() {
  MouseButton_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
function values_6() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_35();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var Companion_instance_30;
function Companion_getInstance_36() {
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_41().e6n_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_42().i6n_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_58().m6n_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_31.o6n() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_45().q6n_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().s6n_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_47().w6n_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().a6o_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_43().e6o_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_49().g6o_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.y6m(frameBuffer.e6m_1, frameBuffer.k6o(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function draw_0(_this__u8e3s4, batch) {
  return batch.t6o(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, batch) {
  return batch.t6o(_this__u8e3s4);
}
function upload($this, data, needClone) {
  var tmp0_safe_receiver = $this.r6p_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r13()) === data.r13()) {
    if (data.r13() < 1024 && Companion_instance_4.j13(data, 0, ensureNotNull($this.r6p_1), 0, data.r13())) {
      return $this;
    }
    Companion_instance_4.i13(data, 0, ensureNotNull($this.r6p_1), 0, data.r13());
  } else {
    $this.r6p_1 = needClone ? clone(data) : data;
  }
  $this.w6p();
  return $this;
}
var Companion_instance_31;
function Companion_getInstance_37() {
  return Companion_instance_31;
}
var Companion_instance_32;
function Companion_getInstance_38() {
  return Companion_instance_32;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.g3y_1) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.s6r_1;
    var level = Level_ERROR_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
      var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_39().w6q_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_39().c6t(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_33;
function Companion_getInstance_39() {
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function AGTextureUnitInfo__toString_impl_7im6je($this) {
  return 'AGTextureUnitInfo(wrap=' + AGWrapMode__toString_impl_8bjnw2(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + AGTextureTargetKind__toString_impl_68648p(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
}
function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
  return $this;
}
function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
  if (!(other instanceof AGTextureUnitInfo))
    return false;
  if (!($this === (other instanceof AGTextureUnitInfo ? other.i6t_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_34;
function Companion_getInstance_40() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_40().b6w_1 ? 'POINTS' : $this === Companion_getInstance_40().c6w_1 ? 'LINE_STRIP' : $this === Companion_getInstance_40().d6w_1 ? 'LINE_LOOP' : $this === Companion_getInstance_40().e6w_1 ? 'LINES' : $this === Companion_getInstance_40().f6w_1 ? 'TRIANGLES' : $this === Companion_getInstance_40().g6w_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_40().h6w_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function AGDrawType__equals_impl_rtafo6($this, other) {
  if (!(other instanceof AGDrawType))
    return false;
  if (!($this === (other instanceof AGDrawType ? other.i6w_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
var Companion_instance_35;
function Companion_getInstance_41() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_41().c6n_1 ? 'null' : $this === Companion_getInstance_41().d6n_1 ? 'UBYTE' : $this === Companion_getInstance_41().e6n_1 ? 'USHORT' : $this === Companion_getInstance_41().f6n_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).k6w.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).j6w_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).l6w.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).j6w_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).m6w.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).j6w_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_42().h6n_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_36;
function Companion_getInstance_42() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.j6w_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_43() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(data).c4(new Long(-1, 0)).d4(toLong(data2).z3(32));
  return _AGFrameBufferInfo___init__impl__dbxiro(tmp$ret$0);
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_48.r6x(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_38;
function Companion_getInstance_44() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(front).c4(new Long(-1, 0)).d4(toLong(back).z3(32));
  return _AGStencilReference___init__impl__rta8vg(tmp$ret$0);
}
var Companion_instance_39;
function Companion_getInstance_45() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).d6y.call(new AGStencilReference($this), referenceValue, referenceValueBack).c6y_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).e6y.call(new AGStencilReference($this), readMask, readMaskBack).c6y_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).f6y.call(new AGStencilReference($this), writeMask, writeMaskBack).c6y_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.c6y_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_40;
function Companion_getInstance_46() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).x6y.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).w6y_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).y6y.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).w6y_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).z6y.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).w6y_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.w6y_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
  this_0.ub('AGColorMask(');
  this_0.ub(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.ub(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.ub(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.ub(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.ub(')');
  return this_0.toString();
}
var Companion_instance_41;
function Companion_getInstance_47() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function AGColorMask__equals_impl_mrih8l($this, other) {
  if (!(other instanceof AGColorMask))
    return false;
  if (!($this === (other instanceof AGColorMask ? other.a6z_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_42;
function Companion_getInstance_48() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_43;
function Companion_getInstance_49() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_49().g6o_1 ? 'NONE' : $this === Companion_getInstance_49().j6o_1 ? 'BOTH' : $this === Companion_getInstance_49().h6o_1 ? 'FRONT' : $this === Companion_getInstance_49().i6o_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function AGCullFace__equals_impl_wgngjr($this, other) {
  if (!(other instanceof AGCullFace))
    return false;
  if (!($this === (other instanceof AGCullFace ? other.e6z_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_50().e6s_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_50().f6s_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_50().g6s_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_50().h6s_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_50().e6s_1 ? 2 : $this === Companion_getInstance_50().f6s_1 ? 3 : $this === Companion_getInstance_50().g6s_1 ? 3 : $this === Companion_getInstance_50().h6s_1 ? 3 : 0;
}
var Companion_instance_44;
function Companion_getInstance_50() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.j6s_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_45;
function Companion_getInstance_51() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_51().d6t_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_51().e6t_1 ? 'REPEAT' : $this === Companion_getInstance_51().f6t_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.a70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_46;
function Companion_getInstance_52() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_52().n6w_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_52().o6w_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_52().p6w_1 ? 'ONE' : $this === Companion_getInstance_52().q6w_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_52().r6w_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_52().s6w_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_52().t6w_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_52().u6w_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_52().v6w_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_52().w6w_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_52().n6w_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_52().o6w_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_52().p6w_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_52().q6w_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_52().r6w_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_52().s6w_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_52().t6w_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_52().u6w_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_52().v6w_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_52().w6w_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.b70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_47;
function Companion_getInstance_53() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_53().a6x_1 ? 'ADD' : $this === Companion_getInstance_53().b6x_1 ? 'SUBTRACT' : $this === Companion_getInstance_53().c6x_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_53().a6x_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_53().b6x_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_53().c6x_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.c70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_48;
function Companion_getInstance_54() {
  return Companion_instance_48;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_49;
function Companion_getInstance_55() {
  if (Companion_instance_49 === VOID)
    new Companion_40();
  return Companion_instance_49;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_55().o6y_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_55().p6y_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_55().q6y_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_55().r6y_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_55().s6y_1 ? 'INVERT' : $this === Companion_getInstance_55().t6y_1 ? 'KEEP' : $this === Companion_getInstance_55().u6y_1 ? 'SET' : $this === Companion_getInstance_55().v6y_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.e70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_56() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_56().g6y_1 ? 'ALWAYS' : $this === Companion_getInstance_56().h6y_1 ? 'EQUAL' : $this === Companion_getInstance_56().i6y_1 ? 'GREATER' : $this === Companion_getInstance_56().j6y_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_56().k6y_1 ? 'LESS' : $this === Companion_getInstance_56().l6y_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_56().m6y_1 ? 'NEVER' : $this === Companion_getInstance_56().n6y_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__inverted_impl_7xxk8m($this) {
  return $this === Companion_getInstance_56().g6y_1 ? Companion_getInstance_56().m6y_1 : $this === Companion_getInstance_56().h6y_1 ? Companion_getInstance_56().n6y_1 : $this === Companion_getInstance_56().i6y_1 ? Companion_getInstance_56().l6y_1 : $this === Companion_getInstance_56().j6y_1 ? Companion_getInstance_56().k6y_1 : $this === Companion_getInstance_56().k6y_1 ? Companion_getInstance_56().j6y_1 : $this === Companion_getInstance_56().l6y_1 ? Companion_getInstance_56().i6y_1 : $this === Companion_getInstance_56().m6y_1 ? Companion_getInstance_56().g6y_1 : $this === Companion_getInstance_56().n6y_1 ? Companion_getInstance_56().h6y_1 : Companion_getInstance_56().m6y_1;
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.f70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_57() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
function toAGScissor(_this__u8e3s4) {
  if (_this__u8e3s4 == null)
    return Companion_getInstance_43().e6o_1;
  return AGScissor.i6x(numberToInt(_this__u8e3s4.h29_1), numberToInt(_this__u8e3s4.i29_1), numberToInt(_this__u8e3s4.j29_1), numberToInt(_this__u8e3s4.k29_1));
}
function plus_5(_this__u8e3s4, scissor) {
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D.q2b(scissor.o29(), scissor.q29())), Vector2D.q2b(scissor.p29(), scissor.r29()));
}
function applyMatrixBounds(_this__u8e3s4, m) {
  var x0 = m.b2d(_this__u8e3s4.o29(), _this__u8e3s4.q29());
  var x1 = m.b2d(_this__u8e3s4.p29(), _this__u8e3s4.q29());
  var x2 = m.b2d(_this__u8e3s4.o29(), _this__u8e3s4.r29());
  var x3 = m.b2d(_this__u8e3s4.p29(), _this__u8e3s4.r29());
  var y0 = m.c2d(_this__u8e3s4.o29(), _this__u8e3s4.q29());
  var y1 = m.c2d(_this__u8e3s4.p29(), _this__u8e3s4.q29());
  var y2 = m.c2d(_this__u8e3s4.o29(), _this__u8e3s4.r29());
  var y3 = m.c2d(_this__u8e3s4.p29(), _this__u8e3s4.r29());
  return Companion_getInstance_43().f2h(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max_0(x0, x1, x2, x3)), numberToInt(max_0(y0, y1, y2, y3)));
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function u_Tex$factory() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.c74();
  }, null);
}
function u_TexEx$factory() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.e74();
  }, null);
}
function u_Tex$factory_0() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.c74();
  }, null);
}
function u_TexEx$factory_0() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.e74();
  }, null);
}
function u_ProjMat$factory() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.h71();
  }, null);
}
function u_ViewMat$factory() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.i71();
  }, null);
}
function u_ProjMat$factory_0() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.h71();
  }, null);
}
function u_ViewMat$factory_0() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.i71();
  }, null);
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var this_0 = gl$delegate;
  var property = gl$factory();
  var value = this_0.iz_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.gz_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = gl$delegate;
    var property = gl$factory_0();
    var tmp0_elvis_lhs = this_0.gz_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.hz_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.gz_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.q76_1;
  var map = $this.u76_1;
  if ($this.v76_1 == null) {
    $this.v76_1 = gl.a78(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().x6l_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.d2x(level)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$0 = 'GL_VERSION=' + gl.a78(7938);
      this_0.e2x(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().x6l_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.d2x(level_0)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.v76_1;
      this_1.e2x(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_36().x6l_1;
    var level_1 = Level_INFO_getInstance();
    var tmp_1;
    if (this_2.d2x(level_1)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      this_2.e2x(level_1, tmp$ret$4);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_36().x6l_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_2;
    if (this_3.d2x(level_2)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
      this_3.e2x(level_2, tmp$ret$6);
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_4 = Companion_getInstance_36().x6l_1;
    var level_3 = Level_INFO_getInstance();
    var tmp_3;
    if (this_4.d2x(level_3)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
      this_4.e2x(level_3, tmp$ret$8);
      tmp_3 = Unit_instance;
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.z2(program);
  var tmp_4;
  if (value == null) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_5 = new GLBaseProgram($this.t76_1, GLShaderCompiler_getInstance().d78(gl, $this.b78(), program, program.g6u_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
    this_5.h78();
    var programInfo = this_5.g78_1;
    var programId = programInfo.i78_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = program.k6u_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
      var location = programInfo.d79(gl, element.y78_1);
      gl.e79(location, element.s6q_1);
    }
    if (programInfo.m78_1.l79()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_6 = program.j6u_1;
      var n = 0;
      while (n < this_6.e1()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_6.d1(_unary__edvuaz);
        var index = gl.f79(programId, it.l3());
        gl.g79(programId, index, it.e6v_1);
      }
    }
    var answer = this_5;
    map.b3(program, answer);
    tmp_4 = answer;
  } else {
    tmp_4 = value;
  }
  var nprogram = tmp_4;
  if (!equals($this.e77_1, nprogram)) {
    $this.e77_1 = nprogram;
    nprogram.h78();
  }
}
function resetObjects($this) {
  $this.x76_1 = null;
  $this.i77_1 = Companion_getInstance_43().d6o_1;
  $this.y76_1 = Companion_getInstance_42().g6n_1;
  $this.z76_1 = Companion_getInstance_49().f6o_1;
  $this.a77_1 = Companion_getInstance_46().r6n_1;
  $this.b77_1 = Companion_getInstance_45().p6n_1;
  $this.c77_1 = Companion_getInstance_47().t6n_1;
  $this.d77_1 = Companion_getInstance_48().z6n_1;
  $this.f77_1.e3();
  $this.e77_1 = null;
  $this.t77_1 = -1;
  $this.r77_1 = 0;
  $this.s77_1 = Companion_instance_48.d70();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.o77_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].v2t();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $this.t76_1.a7a_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.f1x();
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.t76_1.b7a_1.g1()) {
          // Inline function 'kotlin.also' call
          var this_1 = toList($this.t76_1.b7a_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
          $this.t76_1.b7a_1.e3();
          tmp = this_1;
        } else {
          return Unit_instance;
        }
        tmp$ret$3 = tmp;
        break $l$block;
      }finally {
        this_0.h1x();
      }
    }
    var n = 0;
    while (n < tmp$ret$3.e1()) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$3.d1(_unary__edvuaz).e7a();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  var gl = $this.q76_1;
  if (reallocated == null)
    null;
  else {
    reallocated.l2u(false);
  }
  if (updated == null)
    null;
  else {
    updated.l2u(false);
  }
  if (buffer == null) {
    gl.f7a(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty(buffer, $this);
  if (!onlyUpdate) {
    gl.f7a(toGl_6(target), bufferInfo.i7a_1);
  }
  $this.l7a(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.q76_1;
  var location = programInfo.d79(gl, uniform.y78_1);
  var uniformType = uniform.v2c();
  var arrayCount = uniform.o7a_1;
  if (uniformType.v7a_1.k3_1 === 6) {
    switch (uniformType.k3_1) {
      case 1:
        gl.d7b(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.n77_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.e7b(location, arrayCount, false, $this.n77_1);
        break;
      case 3:
        gl.f7b(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.w7a_1) {
          case 1:
            gl.g7b(location, arrayCount, data);
            break;
          case 2:
            gl.h7b(location, arrayCount, data);
            break;
          case 3:
            gl.i7b(location, arrayCount, data);
            break;
          case 4:
            gl.j7b(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.w7a_1) {
      case 1:
        gl.z7a(location, arrayCount, data);
        break;
      case 2:
        gl.a7b(location, arrayCount, data);
        break;
      case 3:
        gl.b7b(location, arrayCount, data);
        break;
      case 4:
        gl.c7b(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.q76_1;
  var params = $this.o77_1[$this.r77_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.n79_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.k7b(glTarget, 10242, glWrap);
  gl.k7b(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.k7b(glTarget, 32882, glWrap);
  }
  params.o79_1 = minFilter;
  params.p79_1 = magFilter;
  gl.k7b(glTarget, 10241, minFilter);
  gl.k7b(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.m13(bmp.o2i());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
        arraycopy_3(bmp.m47(), 0, get_i8(this_0), 0, bmp.o2i());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.m13(imul(imul(bmp.o2i(), 4), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_2(bmp.t4a_1, 0, get_f32(this_1), 0, imul(bmp.o2i(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.m13(imul(bmp.o2i(), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          var abmp = bmp.g3y_1 ? bmp.x45().b49() : bmp.x45().c49();
          arraycopy_1(abmp.q3x_1, 0, get_i32(this_2), 0, abmp.o2i());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.r77_1;
  if (!($this.r77_1 === index)) {
    $this.r77_1 = index;
    if (index >= 0) {
      $this.q76_1.l7b(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty(_this__u8e3s4, $this) {
  return gl(_this__u8e3s4, $this.t76_1);
}
function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
  return gl_0(_this__u8e3s4, $this.t76_1);
}
function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
  return gl_1(_this__u8e3s4, $this.t76_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return function () {
    return new GlslConfig(this$0.q76_1.m7b(), this$0.q76_1);
  };
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return function (it) {
    var tmp0_elvis_lhs = $buffer.r6p_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.m13(0) : tmp0_elvis_lhs;
    $bufferInfo.n7b(mem.r13());
    var tmp;
    if ($onlyUpdate) {
      $gl.f7a(toGl_6($target), $bufferInfo.i7a_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.j7a_1 < mem.r13()) {
      $bufferInfo.j7a_1 = mem.r13();
      $gl.p7b(toGl_6($target), mem.r13(), mem, 35048);
      var tmp1_safe_receiver = $reallocated;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.l2u(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.o7b(toGl_6($target), 0, mem.r13(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp2_safe_receiver = $updated;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.l2u(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return function (it) {
    var rbmp = $tex.x6r_1;
    var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y6s_1;
    var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
    var requestMipmaps = $tex.u6r_1;
    $tex.y6r_1 = $tex.a6t(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.a1();
    var index = 0;
    while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.c1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_50().g6s_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.m7b()) && _GLVariant___get_version__impl__9nyfwa($gl.m7b()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.m7b()).ev()) {
        $gl.q7b(3313, 0);
        $gl.q7b(3312, 1);
      }
      if (bmp == null) {
        $gl.r7b(toGl_8($target), 0, type, $tex.k2l(), $tex.l2l(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.o2i() === 0)) {
            $gl.s7b(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.r7b(texTarget, 0, internalFormat, bmp.a3y_1, bmp.b3y_1, 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.a3y_1 === 0) && !(bmp.b3y_1 === 0) && !(get_size_0(buffer) === 0)) {
              $gl.r7b(texTarget, 0, internalFormat, bmp.a3y_1, bmp.b3y_1, 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.k2l(), $tex.l2l()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.m7b())) {
        var tmp_0;
        if ($tex.y6r_1) {
          var tmp4_elvis_lhs = $tex.v6r_1;
          tmp_0 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.k7b(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.y6r_1) {
          var tmp5_elvis_lhs = $tex.w6r_1;
          tmp_1 = tmp5_elvis_lhs == null ? 1000 : tmp5_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.k7b(3553, 33085, tmp_1);
      }
      if ($tex.y6r_1) {
        $gl.t7b(texTarget);
      }
    }
    $glTex.n7b(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function gl$factory() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function gl$factory_0() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function glslConfig$factory() {
  return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
    return receiver.b78();
  }, null);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.ei('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.ei('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_50().e6s_1;
      break;
    case 32879:
      tmp = Companion_getInstance_50().f6s_1;
      break;
    case 34067:
      tmp = Companion_getInstance_50().g6s_1;
      break;
    case 36197:
      tmp = Companion_getInstance_50().h6s_1;
      break;
    case 34069:
      tmp = Companion_getInstance_50().g6s_1;
      break;
    case 34070:
      tmp = Companion_getInstance_50().g6s_1;
      break;
    case 34071:
      tmp = Companion_getInstance_50().g6s_1;
      break;
    case 34072:
      tmp = Companion_getInstance_50().g6s_1;
      break;
    case 34073:
      tmp = Companion_getInstance_50().g6s_1;
      break;
    case 34074:
      tmp = Companion_getInstance_50().g6s_1;
      break;
    default:
      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.ud('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_53().a6x_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_53().b6x_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_53().c6x_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_52().n6w_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_52().o6w_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_52().p6w_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_52().q6w_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_52().r6w_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_52().s6w_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_52().t6w_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_52().u6w_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_52().v6w_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_52().w6w_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_56().g6y_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_56().h6y_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_56().i6y_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_56().j6y_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_56().k6y_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_56().l6y_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_56().m6y_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_56().n6y_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_55().o6y_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_55().p6y_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_55().q6y_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_55().r6y_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_55().s6y_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_55().t6y_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_55().u6y_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_55().v6y_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_40().b6w_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_40().c6w_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_40().d6w_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_40().e6w_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_40().g6w_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_40().h6w_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_40().f6w_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_41().c6n_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_41().d6n_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_41().e6n_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_41().f6n_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_49().j6o_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_49().h6o_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_49().i6o_1) {
    tmp = 1029;
  } else {
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.ud('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.k3_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.v7a_1.k3_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_50().e6s_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_50().f6s_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_50().g6s_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_50().h6s_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_51().d6t_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_51().e6t_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_51().f6t_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_57().b6z_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_57().d6z_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_57().c6z_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.s6p_1 == null || !(_this__u8e3s4.t6p_1 === state.t79_1.b6m_1)) {
    _this__u8e3s4.t6p_1 = state.t79_1.b6m_1;
    _this__u8e3s4.a6q();
    _this__u8e3s4.s6p_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.s6p_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return function (it) {
    return new GLBuffer($state);
  };
}
function gl$lambda_0($state, $this_gl) {
  return function (it) {
    return new GLFrameBuffer($state, $this_gl);
  };
}
function gl$lambda_1($state) {
  return function (it) {
    return new GLTexture($state);
  };
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionString$delegate;
    var property = versionString$factory();
    var tmp0_elvis_lhs = this_0.gz_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.hz_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.gz_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionInt$delegate;
    var property = versionInt$factory();
    var tmp0_elvis_lhs = this_0.gz_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.hz_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.gz_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.f7f(type);
  gl.g7f(shaderId, str);
  gl.h7f(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.i7f();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.l76(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.m7b())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.m7b()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.a78(35724);
  }
  return tmp;
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0_safe_receiver = Regex.sh('(\\d+\\.\\d+)').vh(get_versionString($this$PropertyThis));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
  return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
}
function versionString$factory() {
  return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
    return get_versionString(receiver);
  }, null);
}
function versionInt$factory() {
  return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
    return get_versionInt(receiver);
  }, null);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_52;
function Companion_getInstance_58() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp0_elvis_lhs = this$0.y70_1;
    var this_0 = TypedUniform.s7g(tmp0_elvis_lhs == null ? 'unknown' + this$0.x70_1.m71() : tmp0_elvis_lhs, this$0.z70_1, this$0.a71_1, this$0.x70_1, this$0.b71_1, this$0.c71_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
    this$0.x70_1.g6v_1.h(this_0);
    return this_0;
  };
}
var Companion_instance_53;
function Companion_getInstance_59() {
  return Companion_instance_53;
}
function _get_bufferSize__mp12kq($this) {
  return $this.p6t_1.r13() / $this.n6t_1 | 0;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.v7g_1;
  tmp.v7g_1 = Math.max(a, size);
  while (!(($this.u7g_1 % size | 0) === 0)) {
    $this.u7g_1 = $this.u7g_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return function () {
    align(this$0, this$0.v7g_1);
    return this$0.u7g_1;
  };
}
function uniform$factory() {
  return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
    return receiver.t7g();
  }, null);
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.e1();
  }, null);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_2().av_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_54;
function Companion_getInstance_60() {
  return Companion_instance_54;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.q7i_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).u7i_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.y7i_1, config)).m7j(_this__u8e3s4);
}
var Companion_instance_55;
function Companion_getInstance_61() {
  if (Companion_instance_55 === VOID)
    new Companion_46();
  return Companion_instance_55;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp = a.y78_1;
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.y78_1;
  return compareValues(tmp, tmp$ret$1);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return function ($this$Indenter) {
    var tmp;
    if (!this$0.l7j_1.k79_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.l7j_1.h79_1) ? ' es' : '';
      $this$Indenter.w37('#version ' + this$0.l7j_1.j79_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.k7j_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.w37('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.w37('#ifdef GL_ES');
    $this$Indenter.w37('precision mediump float;');
    $this$Indenter.w37('#endif');
    var _iterator__ex2g4s = $types.o7j_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var it = _iterator__ex2g4s.c1();
      var layout = this$0.l7j_1.t7l() && this$0.l7j_1.j79_1 >= 410 ? 'layout(location = ' + it.l72_1 + ') ' : '';
      $this$Indenter.w37(layout + this$0.u7l() + ' ' + this$0.v7l(it.z78_1) + this$0.w7l(it.v2c()) + ' ' + it.y78_1 + this$0.x7l(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.t7j_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var it_0 = _iterator__ex2g4s_0.c1();
      var layout_0 = this$0.l7j_1.t7l() ? '' : '';
      $this$Indenter.w37(layout_0 + this$0.y7l() + ' ' + this$0.v7l(it_0.z78_1) + this$0.w7l(it_0.v2c()) + ' ' + it_0.y78_1 + this$0.x7l(it_0) + ';');
    }
    var tmp_1;
    if (this$0.l7j_1.l79()) {
      var _iterator__ex2g4s_1 = $types.s7j_1.a1();
      while (_iterator__ex2g4s_1.b1()) {
        var block = _iterator__ex2g4s_1.c1();
        $this$Indenter.w37('layout(std140) uniform ' + block.l3() + ' {');
        var _iterator__ex2g4s_2 = block.j71().a1();
        while (_iterator__ex2g4s_2.b1()) {
          var uniform = _iterator__ex2g4s_2.c1();
          $this$Indenter.w37('  ' + this$0.v7l(uniform.z78_1) + this$0.w7l(uniform.v2c()) + ' ' + uniform.y78_1 + this$0.x7l(uniform) + ';');
        }
        $this$Indenter.w37('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.q7j_1.a1();
      while (_iterator__ex2g4s_3.b1()) {
        var it_1 = _iterator__ex2g4s_3.c1();
        $this$Indenter.w37(this$0.y7l() + ' ' + this$0.v7l(it_1.z78_1) + this$0.w7l(it_1.v2c()) + ' ' + it_1.y78_1 + this$0.x7l(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.p7j_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$0).a1();
    var index = 0;
    $l$loop: while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.c1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.l7j_1.t7l() ? this$0.z7l() : it_2.y78_1 === this$0.l7j_1.a7m() && this$0.k7j_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.z7l() : this$0.k7j_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.z7l() : this$0.u7l();
      $this$Indenter.w37(INOUT + ' ' + this$0.v7l(it_2.z78_1) + this$0.w7l(it_2.v2c()) + ' ' + it_2.y78_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.a1();
    while (_iterator__ex2g4s_4.b1()) {
      var func = _iterator__ex2g4s_4.c1();
      var gen = new GlslBodyGenerator(this$0.k7j_1, this$0.l7j_1);
      gen.m7k(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.d7m_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$2 = this$0.w7l(item.hl_1) + ' ' + item.gl_1;
        destination.h(tmp$ret$2);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.w7l(func.c7m_1) + ' ' + func.b7m_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.w37(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.x37();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var _iterator__ex2g4s_5 = gen.j7m_1.a1();
        while (_iterator__ex2g4s_5.b1()) {
          var temp = _iterator__ex2g4s_5.c1();
          $this$Indenter.w37(this$0.v7l(temp.z78_1) + this$0.w7l(temp.v2c()) + ' ' + temp.y78_1 + ';');
        }
        $this$Indenter.v37(gen.k7m_1);
      }finally {
        $this$Indenter.y37();
      }
      $this$Indenter.w37('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_56;
function Companion_getInstance_62() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return function (it) {
    return this$0.x7k(it);
  };
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return function (it) {
    return this$0.x7k(it);
  };
}
function ProgramLayout$names$lambda(it) {
  return it.y78_1;
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
var Companion_instance_57;
function Companion_getInstance_63() {
  if (Companion_instance_57 === VOID)
    new Companion_48();
  return Companion_instance_57;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return function ($this$FUNC) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.p7o_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var tmp$ret$0 = $this$FUNC.v7o('p' + index_0, item);
      destination.h(tmp$ret$0);
    }
    var args = destination;
    this$0.r7o_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1), it.d1(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return function ($this$ELSE) {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.y74($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.z74($ref, $min + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.m7r();
  return Output_instance;
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_58;
function Companion_getInstance_64() {
  return Companion_instance_58;
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
function FragmentShader(info) {
  return FragmentShader_0(info.gl_1, info.hl_1);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function VertexShader(info) {
  return VertexShader_0(info.gl_1, info.hl_1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return function () {
    $this_toDisposable.g6();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      _this__u8e3s4.c14(_unary__edvuaz, toByte(tmp$ret$0));
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    _this__u8e3s4.c14(_unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _this__u8e3s4.a14(n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_59;
function Companion_getInstance_65() {
  return Companion_instance_59;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.j5u().s2('GL_OES_texture_float') || this$0.j5u().s2('GL_ARB_texture_float');
  };
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
  _this__u8e3s4.v84(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
  _this__u8e3s4.z84(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
  _this__u8e3s4.w84(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
  _this__u8e3s4.x84(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.y84(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
  _this__u8e3s4.r84(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
  _this__u8e3s4.n84(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
  _this__u8e3s4.u84(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
  _this__u8e3s4.q84(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
  _this__u8e3s4.t84(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
  _this__u8e3s4.s84(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
  _this__u8e3s4.p84(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
  _this__u8e3s4.o84(1, it);
  getInt32(it, 0);
}
function _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return get_tempNBuffer1();
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_1().tx('KmlGlException');
    tempNBufferByte = Buffer.m13(1, true);
    tempNBuffer1 = Buffer.m13(4, true);
    tempNBuffer4 = Buffer.m13(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_60;
function Companion_getInstance_66() {
  return Companion_instance_60;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().f2c_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().h3z_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_67().l85_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().f2c_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().h3z_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_67().l85_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.h4g();
  var m2 = m.p2d(x, y).h2d(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.d87_1;
  var this_1 = this_0.m87_1;
  if (!(this_1.h87_1 === this_0)) {
    this_1.h87_1 = this_0;
    this_1.r88();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  var tmp;
  if (inductionVariable <= last) {
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.h4g();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp_0 = charSequenceGet(str, index);
      } else {
        // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
        tmp_0 = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$1 = tmp_0;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
      var glyph = _this__u8e3s4.d1(c1);
      var tex = glyph.x4f_1;
      var tmp0_tex = ctx.s88(tex);
      var tmp1_x = dx + glyph.y4f_1;
      var tmp2_y = dy + glyph.z4f_1;
      var tmp3_width = tex.z3i_1;
      var tmp4_height = tex.a3j_1;
      var tmp5_m = get_immutable(m2);
      this_0.t88(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_m, filtering, colMul, blendMode);
      var tmp6_safe_receiver = _this__u8e3s4.l4g().d1(Companion_instance_5.u4f(c1, c2));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.f4g_1;
      var kerningOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      dx = dx + (glyph.a4g_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
    tmp = Unit_instance;
  }
}
var debugBmpFontOrNull;
function *_generator_debugBmpFont__zhh4ef($completion) {
  if (debugBmpFontOrNull == null) {
    var tmp = readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    debugBmpFontOrNull = debugBmpFont_0(slice(tmp.x45()));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_debugBmpFont__zhh4ef.bind(VOID), $completion);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.ic(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable = this_0.w1_1;
  var last = this_0.x1_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
      var it = element;
      var x = it % 16 | 0;
      var y = it / 16 | 0;
      var tmp$ret$0 = new Glyph(fntHeight, it, tex.h3k(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.b3(element, tmp$ret$0);
    }
     while (!(element === last));
  var glyphs = toIntMap(result);
  var kernings = IntMap.b2s();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_61;
function Companion_getInstance_67() {
  if (Companion_instance_61 === VOID)
    new Companion_52();
  return Companion_instance_61;
}
var Companion_instance_62;
function Companion_getInstance_68() {
  return Companion_instance_62;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.b8a_1[n];
      var curr = $this.a8a_1[n];
      $this.g8a_1[n] = (prev && !curr);
      $this.f8a_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.c8a_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.c8a_1[n] = 0.0;
        $this.d8a_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.c8a_1[n]);
      if ($this.c8a_1[n] > 0) {
        var tmp0_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp0_subject ? tmp0_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp0_subject ? tmp0_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp0_subject ? tmp0_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.d8a_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.d8a_1[n] = $this.c8a_1[n];
      }
      $this.e8a_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.a8a_1, 0, $this.b8a_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.j8a();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *_generator_configureLoggerFromProperties__heiqlb(file, $completion) {
  try {
    var tmp = file.n27(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    configureLoggerFromProperties_0(tmp);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties(file, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureLoggerFromProperties__heiqlb.bind(VOID, file), $completion);
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_63.w8a(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.l1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.m1();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.n1();
    try {
      var tmp = Companion_getInstance_1().tx(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = value.toUpperCase();
      tmp.w2w(valueOf(tmp$ret$4));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_63;
function Companion_getInstance_69() {
  return Companion_instance_63;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.v2t();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.d8c_1 === bitmap && ensureNotNull($this.e8c_1).m8b_1.q8b_1 === bitmap.j3y_1)
    return ensureNotNull($this.e8c_1);
  if ($this.f8c_1 === bitmap && ensureNotNull($this.g8c_1).m8b_1.q8b_1 === bitmap.j3y_1)
    return ensureNotNull($this.g8c_1);
  $this.x8b_1.t2q(bitmap);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.c8c_1;
    var res = get_0(this_0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = $this.b8c_1.f2t();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
    var base = this_1.m8b_1;
    base.q8b_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_50().g6s_1;
    } else {
      tmp_0 = Companion_getInstance_50().e6s_1;
    }
    tmp.o8b_1 = new AGTexture(tmp_0);
    base.s8b(bitmap.a3y_1);
    base.t8b(bitmap.b3y_1);
    var out = this_1;
    set(this_0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.f8c_1 = $this.d8c_1;
  $this.g8c_1 = $this.e8c_1;
  var base_0 = textureInfo.m8b_1;
  $this.d8c_1 = bitmap;
  $this.e8c_1 = textureInfo;
  if (!(bitmap.j3y_1 === base_0.q8b_1)) {
    base_0.q8b_1 = bitmap.j3y_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.Long.minus' call
    var this_2 = $this.a8c_1;
    var other = textureInfo.l8b_1;
    tmp_1.a8c_1 = this_2.t1(toLong(other));
    try {
      base_0.m8c(bitmap, bitmap.l3y_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.l8b_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
      var tmp_2 = $this;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = $this.a8c_1;
      var other_0 = textureInfo.l8b_1;
      tmp_2.a8c_1 = this_3.r3(toLong(other_0));
    }
    bitmap.w3y();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
  return imul(_this__u8e3s4.b3y_1, imul(_this__u8e3s4.a3y_1, _this__u8e3s4.c3y_1) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.h8c_1 === slice)
    return ensureNotNull($this.i8c_1);
  if ($this.j8c_1 === slice)
    return ensureNotNull($this.k8c_1);
  var info = getTextureInfo($this, slice.z3j());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = info.n8b_1;
    var res = get_0(this_0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture_1(info.m8b_1).j3k(RectangleInt.a2i(slice.o29(), slice.q29(), slice.z3i_1, slice.a3j_1));
    } else {
      tmp = Companion_instance_7.x3k(info.m8b_1, slice);
    }
    var out = tmp;
    set(this_0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.j8c_1 = $this.h8c_1;
  $this.k8c_1 = $this.i8c_1;
  $this.h8c_1 = slice;
  $this.i8c_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.d8c_1 = null;
  $this.e8c_1 = null;
  $this.f8c_1 = null;
  $this.g8c_1 = null;
  $this.h8c_1 = null;
  $this.i8c_1 = null;
  $this.j8c_1 = null;
  $this.k8c_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.v2t();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.s73($this$IF_ELSE_BINARY_LOOKUP.v73(), $this$IF_ELSE_BINARY_LOOKUP.d74(Companion_getInstance_70().h8d_1[n], $this$IF_ELSE_BINARY_LOOKUP.b74($$this$apply.o73(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.u87_1);
  var idx_0 = idx;
  var ma = matrix.k2c_1;
  var mb = matrix.l2c_1;
  var mc = matrix.m2c_1;
  var md = matrix.n2c_1;
  var mtx = matrix.o2c_1;
  var mty = matrix.p2c_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.o2d(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_7().s2c(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.x28_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.y28_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.a88_1 + indices | 0) < $this.t87_1 && ($this.z87_1 + vertices | 0) < $this.s87_1;
}
var Companion_instance_64;
function Companion_getInstance_70() {
  if (Companion_instance_64 === VOID)
    new Companion_55();
  return Companion_instance_64;
}
function BatchBuilder2D$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (it.k3_1) {
      case 0:
        this$0.y8d();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.z8d();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_1().tx('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_3().ev() && Companion_getInstance_3().hv().pu_1 && Companion_getInstance_3().hv().uu() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = debugLineRenderContext$delegate;
    var property = debugLineRenderContext$factory();
    var tmp0_elvis_lhs = this_0.gz_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.hz_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.gz_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_65;
function Companion_getInstance_71() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function addVertex($this, x, y, color, m) {
  setFloat32($this.m8g_1, $this.p8g_1 + 0 | 0, m.y2c(x, y));
  setFloat32($this.m8g_1, $this.p8g_1 + 1 | 0, m.z2c(x, y));
  setInt32($this.m8g_1, $this.p8g_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.p8g_1 = $this.p8g_1 + (Companion_getInstance_71().b8g_1.w6v_1 / 4 | 0) | 0;
  $this.o8g_1 = $this.o8g_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return function (it) {
    this$0.rc();
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function debugLineRenderContext$factory() {
  return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
    return get_debugLineRenderContext(receiver);
  }, null);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return function () {
    return this$0.u6t(ProjViewUB_getInstance());
  };
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.r6m(VOID, it);
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function projViewMatUB$factory() {
  return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
    return receiver.b8h();
  }, null);
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_1().tx('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.b75($this$FUNC.q7p(a, b, c));
  return Unit_instance;
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.b75($this$FUNC.n7p(a, b));
  return Unit_instance;
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.b75($this$FUNC.o7p(a, b));
  return Unit_instance;
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.b75($this$FUNC.o7p(a, $this$FUNC.q75(b)));
  return Unit_instance;
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.b75($this$FUNC.r75(d, r));
  return Unit_instance;
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.b75($this$FUNC.r75($this$FUNC.i75(d), r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.w7p(d, 0.0);
  var body = $this$FUNC.j74();
  // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
  body.b75(d);
  var stmIf = new If(cond, body.l74());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.r73_1.h(stmIf);
  var tmp = stmIf;
  $this$FUNC.x74(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return function ($this$ELSE) {
    $this$ELSE.b75($this$ELSE.r75($this$ELSE.i75($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.b75($this$FUNC.s7p(1.0, $this$FUNC.m7p($this$FUNC.u7p($this$FUNC.h74(d, $this$FUNC.p7p(d)), 0.5), $this$FUNC.y73(0.0), $this$FUNC.y73(1.0))));
  return Unit_instance;
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.b75($this$FUNC.m7p($this$FUNC.u7p($this$FUNC.h74(d, $this$FUNC.p7p(d)), 0.5), $this$FUNC.y73(0.0), $this$FUNC.y73(1.0)));
  return Unit_instance;
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.k7p($this$FUNC.m7p($this$FUNC.t7p(0.5, $this$FUNC.h74($this$FUNC.v7p(0.5, $this$FUNC.r75(d2, d1)), k)), $this$FUNC.y73(0.0), $this$FUNC.y73(1.0)));
  $this$FUNC.b75($this$FUNC.r75($this$FUNC.q7p(d2, d1, h), $this$FUNC.w73($this$FUNC.w73(k, h), $this$FUNC.s7p(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.k7p($this$FUNC.m7p($this$FUNC.s7p(0.5, $this$FUNC.h74($this$FUNC.v7p(0.5, $this$FUNC.s75(d2, d1)), k)), $this$FUNC.y73(0.0), $this$FUNC.y73(1.0)));
  $this$FUNC.b75($this$FUNC.s75($this$FUNC.q7p(d2, $this$FUNC.q75(d1), h), $this$FUNC.w73($this$FUNC.w73(k, h), $this$FUNC.s7p(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.k7p($this$FUNC.m7p($this$FUNC.s7p(0.5, $this$FUNC.h74($this$FUNC.v7p(0.5, $this$FUNC.r75(d2, d1)), k)), $this$FUNC.y73(0.0), $this$FUNC.y73(1.0)));
  $this$FUNC.b75($this$FUNC.s75($this$FUNC.q7p(d2, d1, h), $this$FUNC.w73($this$FUNC.w73(k, h), $this$FUNC.s7p(1.0, h))));
  return Unit_instance;
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.b75($this$FUNC.r75($this$FUNC.r7p(p), r));
  return Unit_instance;
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  $this$FUNC.s73($this$FUNC.b74(r, 'xy'), $this$FUNC.l7p($this$FUNC.w7p($this$FUNC.m75(p), 0.0), $this$FUNC.b74(r, 'xy'), $this$FUNC.b74(r, 'zw')));
  $this$FUNC.s73($this$FUNC.m75(r), $this$FUNC.l7p($this$FUNC.w7p($this$FUNC.n75(p), 0.0), $this$FUNC.m75(r), $this$FUNC.n75(r)));
  var q = $this$FUNC.k7p($this$FUNC.s75($this$FUNC.r75($this$FUNC.i75(p), b), $this$FUNC.m75(r)));
  $this$FUNC.b75($this$FUNC.r75($this$FUNC.s75($this$FUNC.n7p($this$FUNC.o7p($this$FUNC.m75(q), $this$FUNC.n75(q)), $this$FUNC.y73(0.0)), $this$FUNC.r7p($this$FUNC.o7p(q, $this$FUNC.y73(0.0)))), $this$FUNC.m75(r)));
  return Unit_instance;
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.k7p($this$FUNC.r75($this$FUNC.i75(p), b));
  $this$FUNC.b75($this$FUNC.s75($this$FUNC.r7p($this$FUNC.o7p(d, $this$FUNC.y73(0.0))), $this$FUNC.n7p($this$FUNC.o7p($this$FUNC.m75(d), $this$FUNC.n75(d)), $this$FUNC.y73(0.0))));
  return Unit_instance;
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.b75($this$FUNC.s75(src, $this$FUNC.w73(dst, $this$FUNC.s7p(1.0, $this$FUNC.f74(src)))));
  return Unit_instance;
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.x8i();
  return SDFShaders_instance;
}
function opInterpolate$factory() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.y8i();
  }, null);
}
function opUnion$factory() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.z8i();
  }, null);
}
function opIntersect$factory() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.a8j();
  }, null);
}
function opSubtract$factory() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.b8j();
  }, null);
}
function opRound$factory() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.c8j();
  }, null);
}
function opBorder$factory() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.d8j();
  }, null);
}
function opBorderInner$factory() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.e8j();
  }, null);
}
function opAA$factory() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.f8j();
  }, null);
}
function opAARev$factory() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.g8j();
  }, null);
}
function opSmoothUnion$factory() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.h8j();
  }, null);
}
function opSmoothSubtraction$factory() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.i8j();
  }, null);
}
function opSmoothIntersection$factory() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.j8j();
  }, null);
}
function circle$factory() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.k8j();
  }, null);
}
function roundedBox$factory() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.l8j();
  }, null);
}
function box$factory() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.m8j();
  }, null);
}
function opCombinePremultipliedColors$factory() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.n8j();
  }, null);
}
function opInterpolate$factory_0() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.y8i();
  }, null);
}
function opUnion$factory_0() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.z8i();
  }, null);
}
function opIntersect$factory_0() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.a8j();
  }, null);
}
function opSubtract$factory_0() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.b8j();
  }, null);
}
function opRound$factory_0() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.c8j();
  }, null);
}
function opBorder$factory_0() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.d8j();
  }, null);
}
function opBorderInner$factory_0() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.e8j();
  }, null);
}
function opAA$factory_0() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.f8j();
  }, null);
}
function opAARev$factory_0() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.g8j();
  }, null);
}
function opSmoothUnion$factory_0() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.h8j();
  }, null);
}
function opSmoothSubtraction$factory_0() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.i8j();
  }, null);
}
function opSmoothIntersection$factory_0() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.j8j();
  }, null);
}
function circle$factory_0() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.k8j();
  }, null);
}
function roundedBox$factory_0() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.l8j();
  }, null);
}
function box$factory_0() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.m8j();
  }, null);
}
function opCombinePremultipliedColors$factory_0() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.n8j();
  }, null);
}
function Texture(frameBuffer) {
  return Texture_0(frameBuffer.j6r(), frameBuffer.l6m_1, frameBuffer.m6m_1);
}
function Texture_0(agBase, width, height) {
  return new RectSlice(TextureBase.o8j(agBase, SizeInt.q2j(width, height)), RectangleInt.a2i(0, 0, width, height));
}
function Texture_1(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.k2l() : right;
  bottom = bottom === VOID ? base.l2l() : bottom;
  return new RectSlice(base, Companion_instance_2.f2h(left, top, right, bottom));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_66;
function Companion_getInstance_72() {
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.t8j_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.u8j_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function _interpolateRatio(ratio, l, r) {
  return interpolate(ratio, l, r);
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_67;
function Companion_getInstance_73() {
  Cursor_initEntries();
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_73();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.v8k_1($this.w8k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  return $this.c8m_1.ho($this, fpsCached$factory());
}
function *_generator_waitClose__fhnm35($this, $completion) {
  while ($this.r8m_1) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay_0(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_loop__qll5p8($this, entry, $completion) {
  var tmp = $this.v8n($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.ym(CoroutineName.x1c('GameWindow.loop'));
  launchImmediately(tmp_0, GameWindow$loop$slambda_0(entry, $this));
  while ($this.r8m_1) {
    var elapsed;
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.hj();
    // Inline function 'korlibs.render.GameWindow.loop.<anonymous>' call
    elapsed = $this.w8n();
    var realElapsed = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    var available = FastDuration__minus_impl_evs237($this.x8n(), elapsed);
    if (FastDuration__compareTo_impl_4fhnj7(available, Companion_instance_3.u1w()) > 0) {
      var tmp_1 = $this.y8n(available, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  return Unit_instance;
}
function *_generator_loopDelay__vgtnit($this, time, $completion) {
  var tmp = delay(time, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return function () {
    return this$0.z8n();
  };
}
function GameWindow$loop$slambda_0($entry, this$0) {
  var i = new GameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_68;
function Companion_getInstance_74() {
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().i3z_1 : bgcolor;
  _this__u8e3s4.k8p(numberToInt(size.c2a_1), numberToInt(size.d2a_1));
  if (!(title == null)) {
    _this__u8e3s4.b8p(title);
  }
  _this__u8e3s4.c8p(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.d8p(fullscreen);
  }
  _this__u8e3s4.f8p(bgcolor);
  _this__u8e3s4.e8p(true);
}
function fpsCached$factory() {
  return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
    return _get_fpsCached__581dty(receiver);
  }, null);
}
function continuousRenderMode$factory() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.r8p();
  }, function (receiver, value) {
    return receiver.q8p(value);
  });
}
function continuousRenderMode$factory_0() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.r8p();
  }, function (receiver, value) {
    return receiver.q8p(value);
  });
}
var Companion_instance_69;
function Companion_getInstance_75() {
  if (Companion_instance_69 === VOID)
    new Companion_60();
  return Companion_instance_69;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().w6b());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.r8q_1, b.r8q_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return function (it) {
    $task.u8q_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this$0.m8o_1.a1x_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this$0.l8o_1.x2p($task);
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return function () {
    $block.n1b();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return function (it) {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return function () {
    var tmp;
    if (!($cancelled._v == null)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.uc(tmp$ret$0);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      this_1.uc(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.n1b();
    return Unit_instance;
  };
}
var Companion_instance_70;
function Companion_getInstance_76() {
  return Companion_instance_70;
}
var korgwJvmEngine;
function get_SDLPath() {
  _init_properties_SDL_kt__pqu7sn();
  // Inline function 'kotlin.getValue' call
  var this_0 = SDLPath$delegate;
  SDLPath$factory();
  return this_0.n1();
}
var SDLPath$delegate;
var Companion_instance_71;
function Companion_getInstance_77() {
  return Companion_instance_71;
}
var Companion_instance_72;
function Companion_getInstance_78() {
  return Companion_instance_72;
}
function SDLPath$delegate$lambda() {
  _init_properties_SDL_kt__pqu7sn();
  return Companion_getInstance_3().fv() ? '/Library/Frameworks/SDL2.framework/SDL2' : 'SDL2.dll';
}
function SDLPath$factory() {
  return getPropertyCallableRef('SDLPath', 0, KProperty0, function () {
    return get_SDLPath();
  }, null);
}
function SDL_Init$factory() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.m8s();
  }, null);
}
function SDL_CreateWindow$factory() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.n8s();
  }, null);
}
function SDL_SetWindowTitle$factory() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.o8s();
  }, null);
}
function SDL_SetWindowSize$factory() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.p8s();
  }, null);
}
function SDL_SetWindowPosition$factory() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.q8s();
  }, null);
}
function SDL_ShowWindow$factory() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.r8s();
  }, null);
}
function SDL_RaiseWindow$factory() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.s8s();
  }, null);
}
function SDL_PollEvent$factory() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.t8s();
  }, null);
}
function SDL_Quit$factory() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.u8s();
  }, null);
}
function SDL_GL_CreateContext$factory() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.v8s();
  }, null);
}
function SDL_GL_DeleteContext$factory() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.w8s();
  }, null);
}
function SDL_GL_MakeCurrent$factory() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.x8s();
  }, null);
}
function SDL_GL_SwapWindow$factory() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.y8s();
  }, null);
}
function SDL_Init$factory_0() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.m8s();
  }, null);
}
function SDL_CreateWindow$factory_0() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.n8s();
  }, null);
}
function SDL_SetWindowTitle$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.o8s();
  }, null);
}
function SDL_SetWindowSize$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.p8s();
  }, null);
}
function SDL_SetWindowPosition$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.q8s();
  }, null);
}
function SDL_ShowWindow$factory_0() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.r8s();
  }, null);
}
function SDL_RaiseWindow$factory_0() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.s8s();
  }, null);
}
function SDL_PollEvent$factory_0() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.t8s();
  }, null);
}
function SDL_Quit$factory_0() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.u8s();
  }, null);
}
function SDL_GL_CreateContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.v8s();
  }, null);
}
function SDL_GL_DeleteContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.w8s();
  }, null);
}
function SDL_GL_MakeCurrent$factory_0() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.x8s();
  }, null);
}
function SDL_GL_SwapWindow$factory_0() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.y8s();
  }, null);
}
function glDrawArraysInstanced$factory() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.l92();
  }, null);
}
function glDrawElementsInstanced$factory() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.m92();
  }, null);
}
function glVertexAttribDivisor$factory() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.n92();
  }, null);
}
function glTexSubImage2D$factory() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.u92();
  }, null);
}
function glTexImage2D$factory() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.u91();
  }, null);
}
function glTexParameteri$factory() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.v91();
  }, null);
}
function glTexParameterf$factory() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.v92();
  }, null);
}
function glTexParameterfv$factory() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.w92();
  }, null);
}
function glTexParameteriv$factory() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.x92();
  }, null);
}
function glStencilOp$factory() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.s91();
  }, null);
}
function glStencilMask$factory() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.q91();
  }, null);
}
function glReadPixels$factory() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.y92();
  }, null);
}
function glStencilFunc$factory() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.o91();
  }, null);
}
function glScissor$factory() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.m91();
  }, null);
}
function glPolygonOffset$factory() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.z92();
  }, null);
}
function glPixelStorei$factory() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.k91();
  }, null);
}
function glLineWidth$factory() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.a93();
  }, null);
}
function glGetTexParameterfv$factory() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.b93();
  }, null);
}
function glGetTexParameteriv$factory() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.c93();
  }, null);
}
function glGetError$factory() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.d91();
  }, null);
}
function glGetFloatv$factory() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.d93();
  }, null);
}
function glGetIntegerv$factory() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.e91();
  }, null);
}
function glGetBooleanv$factory() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.e93();
  }, null);
}
function glGenTextures$factory() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.b91();
  }, null);
}
function glDepthRange$factory() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.f93();
  }, null);
}
function glDepthRangef$factory() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.m90();
  }, null);
}
function glClearDepth$factory() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.g93();
  }, null);
}
function glClearDepthf$factory() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.x8z();
  }, null);
}
function glDrawArrays$factory() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function glDrawElements$factory() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
function glFrontFace$factory() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function glFinish$factory() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.h93();
  }, null);
}
function glFlush$factory() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function glEnable$factory() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.r90();
  }, null);
}
function glIsEnabled$factory() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.i93();
  }, null);
}
function glDisable$factory() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.n90();
  }, null);
}
function glDepthMask$factory() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.l90();
  }, null);
}
function glDepthFunc$factory() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.k90();
  }, null);
}
function glDeleteTextures$factory() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.j90();
  }, null);
}
function glCullFace$factory() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.d90();
  }, null);
}
function glCopyTexImage2D$factory() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.j93();
  }, null);
}
function glCopyTexSubImage2D$factory() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.k93();
  }, null);
}
function glColorMask$factory() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.z8z();
  }, null);
}
function glClearStencil$factory() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.y8z();
  }, null);
}
function glClearColor$factory() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.w8z();
  }, null);
}
function glClear$factory() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.v8z();
  }, null);
}
function glBindTexture$factory() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function glHint$factory() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.l93();
  }, null);
}
function glViewport$factory() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.k92();
  }, null);
}
function glGetString$factory() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.i91();
  }, null);
}
function glGetStringi$factory() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.m93();
  }, null);
}
function glVertexAttribPointer$factory() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.j92();
  }, null);
}
function glVertexAttrib4fv$factory() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.n93();
  }, null);
}
function glActiveTexture$factory() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.k8z();
  }, null);
}
function glAttachShader$factory() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.l8z();
  }, null);
}
function glBindAttribLocation$factory() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.m8z();
  }, null);
}
function glBindBuffer$factory() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.n8z();
  }, null);
}
function glBindFramebuffer$factory() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.o8z();
  }, null);
}
function glBindRenderbuffer$factory() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.p8z();
  }, null);
}
function glBlendColor$factory() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.o93();
  }, null);
}
function glBlendEquation$factory() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.p93();
  }, null);
}
function glBlendEquationSeparate$factory() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function glBlendFunc$factory() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.q93();
  }, null);
}
function glBlendFuncSeparate$factory() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.s8z();
  }, null);
}
function glBufferData$factory() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.t8z();
  }, null);
}
function glBufferSubData$factory() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.u8z();
  }, null);
}
function glCheckFramebufferStatus$factory() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.r93();
  }, null);
}
function glCompileShader$factory() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.a90();
  }, null);
}
function glCompressedTexImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.s93();
  }, null);
}
function glCompressedTexSubImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.t93();
  }, null);
}
function glCreateProgram$factory() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.b90();
  }, null);
}
function glCreateShader$factory() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.c90();
  }, null);
}
function glDeleteBuffers$factory() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.e90();
  }, null);
}
function glDeleteFramebuffers$factory() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.f90();
  }, null);
}
function glDeleteProgram$factory() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.g90();
  }, null);
}
function glDeleteRenderbuffers$factory() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.h90();
  }, null);
}
function glDeleteShader$factory() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.i90();
  }, null);
}
function glDetachShader$factory() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.u93();
  }, null);
}
function glDisableVertexAttribArray$factory() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function glEnableVertexAttribArray$factory() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function glFramebufferRenderbuffer$factory() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function glFramebufferTexture2D$factory() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function glGenBuffers$factory() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.x90();
  }, null);
}
function glGenerateMipmap$factory() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.y90();
  }, null);
}
function glGenFramebuffers$factory() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.z90();
  }, null);
}
function glGenRenderbuffers$factory() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.a91();
  }, null);
}
function glGetActiveAttrib$factory() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.v93();
  }, null);
}
function glGetActiveUniform$factory() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.w93();
  }, null);
}
function glGetAttachedShaders$factory() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.x93();
  }, null);
}
function glGetAttribLocation$factory() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.y93();
  }, null);
}
function glGetUniformLocation$factory() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.c91();
  }, null);
}
function glGetBufferParameteriv$factory() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.z93();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a94();
  }, null);
}
function glGetProgramInfoLog$factory() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.b94();
  }, null);
}
function glGetRenderbufferParameteriv$factory() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.c94();
  }, null);
}
function glGetProgramiv$factory() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.f91();
  }, null);
}
function glGetShaderiv$factory() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.g91();
  }, null);
}
function glGetShaderInfoLog$factory() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.h91();
  }, null);
}
function glGetShaderPrecisionFormat$factory() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.d94();
  }, null);
}
function glGetShaderSource$factory() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.e94();
  }, null);
}
function glGetUniformfv$factory() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.f94();
  }, null);
}
function glGetUniformiv$factory() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.g94();
  }, null);
}
function glGetVertexAttribfv$factory() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.h94();
  }, null);
}
function glGetVertexAttribiv$factory() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.i94();
  }, null);
}
function glGetVertexAttribPointerv$factory() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.j94();
  }, null);
}
function glIsBuffer$factory() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.k94();
  }, null);
}
function glIsFramebuffer$factory() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.l94();
  }, null);
}
function glIsProgram$factory() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.m94();
  }, null);
}
function glIsRenderbuffer$factory() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.n94();
  }, null);
}
function glIsTexture$factory() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.o94();
  }, null);
}
function glIsShader$factory() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.p94();
  }, null);
}
function glLinkProgram$factory() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.j91();
  }, null);
}
function glReleaseShaderCompiler$factory() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.q94();
  }, null);
}
function glRenderbufferStorage$factory() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.l91();
  }, null);
}
function glSampleCoverage$factory() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.r94();
  }, null);
}
function glShaderBinary$factory() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.s94();
  }, null);
}
function glShaderSource$factory() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.n91();
  }, null);
}
function glStencilFuncSeparate$factory() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.p91();
  }, null);
}
function glStencilMaskSeparate$factory() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.r91();
  }, null);
}
function glStencilOpSeparate$factory() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.t91();
  }, null);
}
function glUniform1f$factory() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.t94();
  }, null);
}
function glUniform2f$factory() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.u94();
  }, null);
}
function glUniform3f$factory() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.v94();
  }, null);
}
function glUniform4f$factory() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.w94();
  }, null);
}
function glUniform1i$factory() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.x91();
  }, null);
}
function glUniform2i$factory() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.x94();
  }, null);
}
function glUniform3i$factory() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.y94();
  }, null);
}
function glUniform4i$factory() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.z94();
  }, null);
}
function glUniform1fv$factory() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.w91();
  }, null);
}
function glUniform2fv$factory() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.z91();
  }, null);
}
function glUniform3fv$factory() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.b92();
  }, null);
}
function glUniform4fv$factory() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.d92();
  }, null);
}
function glUniform1iv$factory() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.y91();
  }, null);
}
function glUniform2iv$factory() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.a92();
  }, null);
}
function glUniform3iv$factory() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.c92();
  }, null);
}
function glUniform4iv$factory() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.e92();
  }, null);
}
function glUniformMatrix2fv$factory() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.f92();
  }, null);
}
function glUniformMatrix3fv$factory() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.g92();
  }, null);
}
function glUniformMatrix4fv$factory() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.h92();
  }, null);
}
function glUseProgram$factory() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.i92();
  }, null);
}
function glValidateProgram$factory() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.a95();
  }, null);
}
function glVertexAttrib1f$factory() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.b95();
  }, null);
}
function glVertexAttrib2f$factory() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.c95();
  }, null);
}
function glVertexAttrib3f$factory() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.d95();
  }, null);
}
function glVertexAttrib4f$factory() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.e95();
  }, null);
}
function glVertexAttrib1fv$factory() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.f95();
  }, null);
}
function glVertexAttrib2fv$factory() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.g95();
  }, null);
}
function glVertexAttrib3fv$factory() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.h95();
  }, null);
}
function glBindBufferRange$factory() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.o92();
  }, null);
}
function glGetUniformBlockIndex$factory() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function glUniformBlockBinding$factory() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.q92();
  }, null);
}
function glGenVertexArrays$factory() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function glDeleteVertexArrays$factory() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.i95();
  }, null);
}
function glBindVertexArray$factory() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.s92();
  }, null);
}
function glDrawArraysInstanced$factory_0() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.l92();
  }, null);
}
function glDrawElementsInstanced$factory_0() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.m92();
  }, null);
}
function glVertexAttribDivisor$factory_0() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.n92();
  }, null);
}
function glTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.u92();
  }, null);
}
function glTexImage2D$factory_0() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.u91();
  }, null);
}
function glTexParameteri$factory_0() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.v91();
  }, null);
}
function glTexParameterf$factory_0() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.v92();
  }, null);
}
function glTexParameterfv$factory_0() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.w92();
  }, null);
}
function glTexParameteriv$factory_0() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.x92();
  }, null);
}
function glStencilOp$factory_0() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.s91();
  }, null);
}
function glStencilMask$factory_0() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.q91();
  }, null);
}
function glReadPixels$factory_0() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.y92();
  }, null);
}
function glStencilFunc$factory_0() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.o91();
  }, null);
}
function glScissor$factory_0() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.m91();
  }, null);
}
function glPolygonOffset$factory_0() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.z92();
  }, null);
}
function glPixelStorei$factory_0() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.k91();
  }, null);
}
function glLineWidth$factory_0() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.a93();
  }, null);
}
function glGetTexParameterfv$factory_0() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.b93();
  }, null);
}
function glGetTexParameteriv$factory_0() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.c93();
  }, null);
}
function glGetError$factory_0() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.d91();
  }, null);
}
function glGetFloatv$factory_0() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.d93();
  }, null);
}
function glGetIntegerv$factory_0() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.e91();
  }, null);
}
function glGetBooleanv$factory_0() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.e93();
  }, null);
}
function glGenTextures$factory_0() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.b91();
  }, null);
}
function glDepthRange$factory_0() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.f93();
  }, null);
}
function glDepthRangef$factory_0() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.m90();
  }, null);
}
function glClearDepth$factory_0() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.g93();
  }, null);
}
function glClearDepthf$factory_0() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.x8z();
  }, null);
}
function glDrawArrays$factory_0() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function glDrawElements$factory_0() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
function glFrontFace$factory_0() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function glFinish$factory_0() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.h93();
  }, null);
}
function glFlush$factory_0() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function glEnable$factory_0() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.r90();
  }, null);
}
function glIsEnabled$factory_0() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.i93();
  }, null);
}
function glDisable$factory_0() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.n90();
  }, null);
}
function glDepthMask$factory_0() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.l90();
  }, null);
}
function glDepthFunc$factory_0() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.k90();
  }, null);
}
function glDeleteTextures$factory_0() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.j90();
  }, null);
}
function glCullFace$factory_0() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.d90();
  }, null);
}
function glCopyTexImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.j93();
  }, null);
}
function glCopyTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.k93();
  }, null);
}
function glColorMask$factory_0() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.z8z();
  }, null);
}
function glClearStencil$factory_0() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.y8z();
  }, null);
}
function glClearColor$factory_0() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.w8z();
  }, null);
}
function glClear$factory_0() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.v8z();
  }, null);
}
function glBindTexture$factory_0() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.q8z();
  }, null);
}
function glHint$factory_0() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.l93();
  }, null);
}
function glViewport$factory_0() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.k92();
  }, null);
}
function glGetString$factory_0() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.i91();
  }, null);
}
function glGetStringi$factory_0() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.m93();
  }, null);
}
function glVertexAttribPointer$factory_0() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.j92();
  }, null);
}
function glVertexAttrib4fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.n93();
  }, null);
}
function glActiveTexture$factory_0() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.k8z();
  }, null);
}
function glAttachShader$factory_0() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.l8z();
  }, null);
}
function glBindAttribLocation$factory_0() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.m8z();
  }, null);
}
function glBindBuffer$factory_0() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.n8z();
  }, null);
}
function glBindFramebuffer$factory_0() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.o8z();
  }, null);
}
function glBindRenderbuffer$factory_0() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.p8z();
  }, null);
}
function glBlendColor$factory_0() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.o93();
  }, null);
}
function glBlendEquation$factory_0() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.p93();
  }, null);
}
function glBlendEquationSeparate$factory_0() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.r8z();
  }, null);
}
function glBlendFunc$factory_0() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.q93();
  }, null);
}
function glBlendFuncSeparate$factory_0() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.s8z();
  }, null);
}
function glBufferData$factory_0() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.t8z();
  }, null);
}
function glBufferSubData$factory_0() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.u8z();
  }, null);
}
function glCheckFramebufferStatus$factory_0() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.r93();
  }, null);
}
function glCompileShader$factory_0() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.a90();
  }, null);
}
function glCompressedTexImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.s93();
  }, null);
}
function glCompressedTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.t93();
  }, null);
}
function glCreateProgram$factory_0() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.b90();
  }, null);
}
function glCreateShader$factory_0() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.c90();
  }, null);
}
function glDeleteBuffers$factory_0() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.e90();
  }, null);
}
function glDeleteFramebuffers$factory_0() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.f90();
  }, null);
}
function glDeleteProgram$factory_0() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.g90();
  }, null);
}
function glDeleteRenderbuffers$factory_0() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.h90();
  }, null);
}
function glDeleteShader$factory_0() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.i90();
  }, null);
}
function glDetachShader$factory_0() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.u93();
  }, null);
}
function glDisableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function glEnableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function glFramebufferRenderbuffer$factory_0() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function glFramebufferTexture2D$factory_0() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function glGenBuffers$factory_0() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.x90();
  }, null);
}
function glGenerateMipmap$factory_0() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.y90();
  }, null);
}
function glGenFramebuffers$factory_0() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.z90();
  }, null);
}
function glGenRenderbuffers$factory_0() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.a91();
  }, null);
}
function glGetActiveAttrib$factory_0() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.v93();
  }, null);
}
function glGetActiveUniform$factory_0() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.w93();
  }, null);
}
function glGetAttachedShaders$factory_0() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.x93();
  }, null);
}
function glGetAttribLocation$factory_0() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.y93();
  }, null);
}
function glGetUniformLocation$factory_0() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.c91();
  }, null);
}
function glGetBufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.z93();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory_0() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a94();
  }, null);
}
function glGetProgramInfoLog$factory_0() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.b94();
  }, null);
}
function glGetRenderbufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.c94();
  }, null);
}
function glGetProgramiv$factory_0() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.f91();
  }, null);
}
function glGetShaderiv$factory_0() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.g91();
  }, null);
}
function glGetShaderInfoLog$factory_0() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.h91();
  }, null);
}
function glGetShaderPrecisionFormat$factory_0() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.d94();
  }, null);
}
function glGetShaderSource$factory_0() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.e94();
  }, null);
}
function glGetUniformfv$factory_0() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.f94();
  }, null);
}
function glGetUniformiv$factory_0() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.g94();
  }, null);
}
function glGetVertexAttribfv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.h94();
  }, null);
}
function glGetVertexAttribiv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.i94();
  }, null);
}
function glGetVertexAttribPointerv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.j94();
  }, null);
}
function glIsBuffer$factory_0() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.k94();
  }, null);
}
function glIsFramebuffer$factory_0() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.l94();
  }, null);
}
function glIsProgram$factory_0() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.m94();
  }, null);
}
function glIsRenderbuffer$factory_0() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.n94();
  }, null);
}
function glIsTexture$factory_0() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.o94();
  }, null);
}
function glIsShader$factory_0() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.p94();
  }, null);
}
function glLinkProgram$factory_0() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.j91();
  }, null);
}
function glReleaseShaderCompiler$factory_0() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.q94();
  }, null);
}
function glRenderbufferStorage$factory_0() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.l91();
  }, null);
}
function glSampleCoverage$factory_0() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.r94();
  }, null);
}
function glShaderBinary$factory_0() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.s94();
  }, null);
}
function glShaderSource$factory_0() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.n91();
  }, null);
}
function glStencilFuncSeparate$factory_0() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.p91();
  }, null);
}
function glStencilMaskSeparate$factory_0() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.r91();
  }, null);
}
function glStencilOpSeparate$factory_0() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.t91();
  }, null);
}
function glUniform1f$factory_0() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.t94();
  }, null);
}
function glUniform2f$factory_0() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.u94();
  }, null);
}
function glUniform3f$factory_0() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.v94();
  }, null);
}
function glUniform4f$factory_0() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.w94();
  }, null);
}
function glUniform1i$factory_0() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.x91();
  }, null);
}
function glUniform2i$factory_0() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.x94();
  }, null);
}
function glUniform3i$factory_0() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.y94();
  }, null);
}
function glUniform4i$factory_0() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.z94();
  }, null);
}
function glUniform1fv$factory_0() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.w91();
  }, null);
}
function glUniform2fv$factory_0() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.z91();
  }, null);
}
function glUniform3fv$factory_0() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.b92();
  }, null);
}
function glUniform4fv$factory_0() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.d92();
  }, null);
}
function glUniform1iv$factory_0() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.y91();
  }, null);
}
function glUniform2iv$factory_0() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.a92();
  }, null);
}
function glUniform3iv$factory_0() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.c92();
  }, null);
}
function glUniform4iv$factory_0() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.e92();
  }, null);
}
function glUniformMatrix2fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.f92();
  }, null);
}
function glUniformMatrix3fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.g92();
  }, null);
}
function glUniformMatrix4fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.h92();
  }, null);
}
function glUseProgram$factory_0() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.i92();
  }, null);
}
function glValidateProgram$factory_0() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.a95();
  }, null);
}
function glVertexAttrib1f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.b95();
  }, null);
}
function glVertexAttrib2f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.c95();
  }, null);
}
function glVertexAttrib3f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.d95();
  }, null);
}
function glVertexAttrib4f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.e95();
  }, null);
}
function glVertexAttrib1fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.f95();
  }, null);
}
function glVertexAttrib2fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.g95();
  }, null);
}
function glVertexAttrib3fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.h95();
  }, null);
}
function glBindBufferRange$factory_0() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.o92();
  }, null);
}
function glGetUniformBlockIndex$factory_0() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.p92();
  }, null);
}
function glUniformBlockBinding$factory_0() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.q92();
  }, null);
}
function glGenVertexArrays$factory_0() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.r92();
  }, null);
}
function glDeleteVertexArrays$factory_0() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.i95();
  }, null);
}
function glBindVertexArray$factory_0() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.s92();
  }, null);
}
var properties_initialized_SDL_kt_s4ko39;
function _init_properties_SDL_kt__pqu7sn() {
  if (!properties_initialized_SDL_kt_s4ko39) {
    properties_initialized_SDL_kt_s4ko39 = true;
    SDLPath$delegate = lazy(SDLPath$delegate$lambda);
  }
}
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.getValue' call
  var this_0 = korgwCanvasQuery$delegate;
  korgwCanvasQuery$factory();
  return this_0.n1();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.il();
    var v = _destruct__k2r9zo.jl();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
    var tmp_0 = document.querySelector(tmp0_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = AGOpengl.a7c(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.g70_1)])));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return window.korgwCanvasQuery;
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return function (e) {
    $ag.t6m();
    return Unit_instance;
  };
}
function korgwCanvasQuery$factory() {
  return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
    return get_korgwCanvasQuery();
  }, null);
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc(_this__u8e3s4, $this) {
  if (_this__u8e3s4 === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.id === undefined) {
    if ($this.x98_1.g1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.a5(toString(message));
    }
    var index = $this.x98_1.i3($this.x98_1.e1() - 1 | 0);
    $this.w98_1[index] = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.id = index;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.id;
}
function get_2(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.w98_1[_this__u8e3s4];
  } else {
    tmp = null;
  }
  return tmp;
}
function free(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.w98_1[_this__u8e3s4];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.x98_1.h(_this__u8e3s4);
    $this.w98_1[_this__u8e3s4] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.v98_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.v98_1.getExtension('OES_texture_float_linear') != null || this$0.v98_1.getExtension('OES_texture_float') != null || this$0.u98_1 >= 2;
  };
}
function extensions$factory() {
  return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
    return receiver.j5u();
  }, null);
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_3().qv() ? DenoJsGameWindow.r9h(VOID, config) : Companion_getInstance_3().pv() ? NodeJsGameWindow.w9e() : BrowserCanvasJsGameWindow.k9c();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_safe_receiver = $this.e9k_1.h9c_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = cancelAndJoin(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  window.close();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.f9k_1($this.g9k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onResized($this) {
  $this.y9b_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.a8h().u8n(window.innerWidth, window.innerHeight, $this.s8h());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.v9b_1.width = canvasWidth;
    $this.v9b_1.height = canvasHeight;
    $this.v9b_1.style.position = 'absolute';
    $this.v9b_1.style.left = '0';
    $this.v9b_1.style.right = '0';
    $this.v9b_1.style.width = '' + window.innerWidth + 'px';
    $this.v9b_1.style.height = '' + window.innerHeight + 'px';
    $this.d9c_1 = scale;
  } else {
    $this.d9c_1 = $this.v9b_1.width / $this.v9b_1.clientWidth;
  }
  $this.v8p(0, 0, $this.v9b_1.width, $this.v9b_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_34().m6l();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_34().n6l();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_34().i6l();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_34().j6l();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_34().g6l();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_34().h6l();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_34().k6l();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_34().l6l();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = CoroutineKey_getInstance().c8l_1;
            var level = Level_INFO_getInstance();
            var tmp_1;
            if (this_0.d2x(level)) {
              // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
              var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              this_0.e2x(level, tmp$ret$1);
              tmp_1 = Unit_instance;
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.g6e(invoke_0($this.y8l_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.q6l()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.v9b_1.getBoundingClientRect();
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  var this_0 = $this.e9c_1;
  this_0.b6j_1 = Mode_JS_getInstance();
  this_0.c6j(type, false);
  try {
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.d9c_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.d9c_1;
        var tmp_1 = Vector2D.o2d(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_elvis_lhs = touch.force;
        this_0.f6j(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    this_0.d6j();
  }
  var this_1 = this_0.a6j_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
  $this.g6e(this_1);
}
function mouseEvent($this, e, type, pressingType) {
  var canvasBounds = $this.v9b_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.d9c_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.d9c_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.z8l_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.h9k() || type.equals(Type_SCROLL_getInstance())) {
    $this.g6e($this.z8l_1);
  }
}
function mouseEvent$default($this, e, type, pressingType, $super) {
  pressingType = pressingType === VOID ? type : pressingType;
  return mouseEvent($this, e, type, pressingType);
}
function *_generator_loop__qll5p8_0($this, entry, $completion) {
  var tmp = $this;
  var tmp_0 = $this.v8n($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.h9c_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda_0(entry, $this));
  _get_jsFrame__gugpar($this)(0.0);
  return Unit_instance;
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.i9c_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return function ($this$keyEvent) {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.a5(toString(message));
    }
    tmp.l6f_1 = tmp_0;
    $this$keyEvent.m6f_1 = 0;
    $this$keyEvent.o6f_1 = $me.keyCode;
    $this$keyEvent.n6f_1 = $key;
    $this$keyEvent.q6f_1 = $me.shiftKey;
    $this$keyEvent.r6f_1 = $me.ctrlKey;
    $this$keyEvent.s6f_1 = $me.altKey;
    $this$keyEvent.t6f_1 = $me.metaKey;
    $this$keyEvent.p6f_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return function ($this$mouseEvent) {
    $this$mouseEvent.c6g_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.p6g_1 = false;
    $this$mouseEvent.d6g_1 = 0;
    $this$mouseEvent.e6g_1 = $tx;
    $this$mouseEvent.f6g_1 = $ty;
    $this$mouseEvent.g6g_1 = Companion_getInstance_35().d1($e.button);
    $this$mouseEvent.h6g_1 = $e.buttons;
    $this$mouseEvent.l6g_1 = $e.shiftKey;
    $this$mouseEvent.m6g_1 = $e.ctrlKey;
    $this$mouseEvent.n6g_1 = $e.altKey;
    $this$mouseEvent.o6g_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp0_subject = we.deltaMode;
      var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.v6g(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda_0(this$0) {
  var i = new BrowserCanvasJsGameWindow$close$slambda(this$0);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return function (it) {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return function (it) {
    return this$0.a8q(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return function (it) {
    return this$0.a8q(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return function (it) {
    return this$0.a8q(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return function (it) {
    return this$0.a8q(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return function (it) {
    return this$0.a8q(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return function (it) {
    it.preventDefault();
    this$0.a8q(Type_END_getInstance(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = until(0, items.length);
    var destination = ArrayList.i1();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = this_0.w1_1;
    var last = this_0.x1_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var files = destination;
    return this$0.a8q(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return function (step) {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.w8n();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.k9k_1($this.l9k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_loop__qll5p8_1($this, entry, $completion) {
  var tmp = $this.v8n($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  launchImmediately(tmp, DenoJsGameWindow$loop$slambda_0(entry, $this));
  var tmp_0 = get_jsGlobalThis();
  tmp_0.setInterval(DenoJsGameWindow$loop$lambda($this), 16);
  return Unit_instance;
}
function DenoJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new DenoJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function DenoJsGameWindow$loop$lambda(this$0) {
  return function () {
    this$0.j98();
    this$0.w8n();
    this$0.k98();
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).ft = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).f6e = dispatch$default;
protoOf(BaseEventListener).h6e = onEvents;
protoOf(BaseEventListener).i6e = dispatchDown;
protoOf(BaseEventListener).j6e = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.t6d, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForCompanion(Companion);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Type, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Type_2, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.m6h);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Type_3, 'Type');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_20);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForCompanion(Companion_21);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).z6m = get_parentFeatures;
protoOf(AG).a6n = get_isUniformBuffersSupported;
protoOf(AG).b6n = get_isVertexArraysSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForCompanion(Companion_22);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.d6q);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.r6m, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AGObject, AutoCloseable]);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_24);
initMetadataForClass(AGTextureUnitInfo, 'AGTextureUnitInfo');
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData);
initMetadataForCompanion(Companion_25);
initMetadataForClass(AGDrawType, 'AGDrawType');
initMetadataForCompanion(Companion_26);
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_29);
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_30);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_32);
initMetadataForClass(AGColorMask, 'AGColorMask');
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(AGCullFace, 'AGCullFace');
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_35);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_36);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_37);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_39);
initMetadataForCompanion(Companion_40);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).e75 = get_Float1;
protoOf(Builder).v7q = get_Float2;
protoOf(Builder).w7q = get_Float4;
protoOf(Builder).v73 = get_out;
protoOf(Builder).f75 = atan;
protoOf(Builder).d74 = texture2D;
protoOf(Builder).l7p = TERNARY;
protoOf(Builder).g75 = pow;
protoOf(Builder).h75 = sqrt;
protoOf(Builder).i75 = abs;
protoOf(Builder).j75 = fract;
protoOf(Builder).m7p = clamp;
protoOf(Builder).n7p = min_0;
protoOf(Builder).o7p = max_1;
protoOf(Builder).p7p = fwidth;
protoOf(Builder).q7p = mix;
protoOf(Builder).k75 = smoothstep;
protoOf(Builder).r7p = length;
protoOf(Builder).y73 = get_lit;
protoOf(Builder).l75 = vec2;
protoOf(Builder).z73 = vec4;
protoOf(Builder).b74 = get_1;
protoOf(Builder).m75 = get_x;
protoOf(Builder).n75 = get_y;
protoOf(Builder).o75 = get_z;
protoOf(Builder).p75 = get_w;
protoOf(Builder).f74 = get_a;
protoOf(Builder).q75 = unaryMinus;
protoOf(Builder).r75 = minus_0;
protoOf(Builder).s7p = minus_1;
protoOf(Builder).s75 = plus_2;
protoOf(Builder).t7p = plus_3;
protoOf(Builder).u7p = plus_4;
protoOf(Builder).w73 = times;
protoOf(Builder).v7p = times_0;
protoOf(Builder).h74 = div;
protoOf(Builder).t75 = eq;
protoOf(Builder).u75 = lt;
protoOf(Builder).v75 = le;
protoOf(Builder).w75 = gt;
protoOf(Builder).w7p = gt_0;
initMetadataForClass(Builder, 'Builder', Builder.i74, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).c74 = get_u_Tex;
protoOf(ProgramBuilderDefault).h71 = get_u_ProjMat;
protoOf(ProgramBuilderDefault).i71 = get_u_ViewMat;
protoOf(ProgramBuilderDefault).x73 = get_a_Pos;
protoOf(ProgramBuilderDefault).p73 = get_a_Tex;
protoOf(ProgramBuilderDefault).u73 = get_a_Col;
protoOf(ProgramBuilderDefault).o73 = get_v_Tex;
protoOf(ProgramBuilderDefault).t73 = get_v_Col;
protoOf(ProgramBuilderDefault).g74 = get_t_Temp0;
protoOf(ProgramBuilderDefault).x75 = get_t_Temp1;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.n73, VOID, [Builder, IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy.w7f);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog.q7g);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint.g7g);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_43);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(Gen, 'Gen');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForCompanion(Companion_45);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
initMetadataForCompanion(Companion_46);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).v7l = precToString;
protoOf(GlslGenerator).w7l = typeToString;
protoOf(GlslGenerator).x7l = get_arrayDecl;
protoOf(GlslGenerator).u7l = get_IN;
protoOf(GlslGenerator).z7l = get_OUT;
protoOf(GlslGenerator).y7l = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_47);
initMetadataForClass(GlslConfig, 'GlslConfig');
protoOf(GlslBodyGenerator).w7l = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [Visitor, BaseGlslGenerator]);
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).g75 = pow;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).y73 = get_lit;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).b74 = get_1;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).r75 = minus_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).s75 = plus_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).w73 = times;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).w75 = gt;
initMetadataForClass(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, VOID, VOID, [ExpressionBuilder]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForCompanion(Companion_49);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_50);
protoOf(KmlGl).z6m = get_parentFeatures;
protoOf(KmlGl).a6n = get_isUniformBuffersSupported;
protoOf(KmlGl).b6n = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KmlGlContext, 'KmlGlContext', VOID, VOID, [AutoCloseable]);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_51);
initMetadataForCompanion(Companion_52);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_53);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_54);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(AgCachedBuffer, 'AgCachedBuffer');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_55);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).y8f = get_windowToGlobalScaleAvg;
protoOf(Base).z8f = get_globalToWindowScaleAvg;
protoOf(Base).a8g = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_56);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
protoOf(DEFAULT).s8h = get_devicePixelRatio;
protoOf(DEFAULT).t8h = get_pixelsPerInch;
protoOf(DEFAULT).u8h = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).d8h = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForCompanion(Companion_58);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForLambda(GameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv);
protoOf(GameWindow).s8h = get_devicePixelRatio;
protoOf(GameWindow).t8h = get_pixelsPerInch;
protoOf(GameWindow).u8h = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).d8h = get_computedPixelRatio;
protoOf(GameWindow).fd = get;
protoOf(GameWindow).xm = fold;
protoOf(GameWindow).wm = minusKey;
protoOf(GameWindow).ym = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.d8o, VOID, [BaseEventListener, DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_59);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_60);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.r8o, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.g8o, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_61);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForCompanion(Companion_62);
initMetadataForClass(SDL, 'SDL', SDL.l8s);
initMetadataForClass(KmlGlOpenGL, 'KmlGlOpenGL', KmlGlOpenGL);
initMetadataForCompanion(Companion_63);
initMetadataForClass(OpenGL, 'OpenGL', OpenGL.c8z);
initMetadataForClass(SDLGameWindow$ag$1);
initMetadataForClass(SDLGameWindow, 'SDLGameWindow', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(Size3D, 'Size3D');
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.d9k, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.w9e, VOID, VOID, [0, 1]);
initMetadataForLambda(BrowserCanvasJsGameWindow$close$slambda, VOID, VOID, [0]);
initMetadataForLambda(BrowserCanvasJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.k9c, VOID, VOID, [1, 0]);
initMetadataForLambda(DenoJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(DenoJsGameWindow, 'DenoJsGameWindow', DenoJsGameWindow.r9h, VOID, VOID, [1, 0]);
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
//endregion
//region block: init
Companion_instance_8 = new Companion();
Companion_instance_9 = new Companion_0();
Companion_instance_10 = new Companion_1();
Companion_instance_11 = new Companion_2();
Companion_instance_14 = new Companion_5();
Companion_instance_15 = new Companion_6();
Companion_instance_16 = new Companion_7();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_31 = new Companion_22();
Companion_instance_32 = new Companion_23();
AGFinish_instance = new AGFinish();
Companion_instance_48 = new Companion_39();
Companion_instance_53 = new Companion_44();
Companion_instance_54 = new Companion_45();
Companion_instance_58 = new Companion_49();
Companion_instance_59 = new Companion_50();
Companion_instance_60 = new Companion_51();
debugBmpFontOrNull = null;
Companion_instance_62 = new Companion_53();
Companion_instance_63 = new Companion_54();
DEFAULT_instance = new DEFAULT();
GLOBAL_CHECK_GL = false;
Companion_instance_70 = new Companion_61();
korgwJvmEngine = null;
Companion_instance_71 = new Companion_62();
Companion_instance_72 = new Companion_63();
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Size3D as Size3D,
};
export {
  Key_F12_getInstance as Key_F12_getInstance20smmrbslhgku,
  Key_F7_getInstance as Key_F7_getInstance1fxfgbmldwoq6,
  Key_RIGHT_getInstance as Key_RIGHT_getInstance3209gaexis4i6,
  Key_SPACE_getInstance as Key_SPACE_getInstance3ccpin6uc1wp0,
  Key_UP_getInstance as Key_UP_getInstance3m44cx75e2bd1,
  Type_DOWN_getInstance as Type_DOWN_getInstance3w3upujzs6x5,
  Type_TYPE_getInstance as Type_TYPE_getInstance3kl3gtiytkq1p,
  Type_UP_getInstance as Type_UP_getInstance2onpl7vaj0n6f,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2pxjdxrpl68c5,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance1zas01g4tazis,
  Type_DRAG_getInstance as Type_DRAG_getInstance1oyczma3u1sfi,
  Type_UP_getInstance_0 as Type_UP_getInstance1azeslmnft6l5,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance104tc4m897tyy,
  Status_ADD_getInstance as Status_ADD_getInstance22apyg5ct4px7,
  Status_KEEP_getInstance as Status_KEEP_getInstance3tj4183qdgyi5,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance19drpw6lfvon8,
  Type_END_getInstance_0 as Type_END_getInstance3ekhp9k4xqwsb,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstanceavavmobr5nzz,
  Type_START_getInstance_0 as Type_START_getInstance27oonvh9zpi1o,
  Precision_MEDIUM_getInstance as Precision_MEDIUM_getInstancewn61okav7bh4,
  VarType_Float1_getInstance as VarType_Float1_getInstance1fp6gxp2vmo7y,
  VarType_Float2_getInstance as VarType_Float2_getInstance321ftm11bbyai,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstancemdqrzfwu4c9e,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstance2edcjnp9auwx5,
  debugBmpFont as debugBmpFont2i7i2ml66o1iy,
  configureLoggerFromProperties as configureLoggerFromProperties2zy8apzr93pqp,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv as AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3,
  AGStencilReference__withReadMask$default_impl_7mdffx as AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb,
  AGStencilReference__withReferenceValue$default_impl_2trj0v as AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t,
  AGStencilReference__withWriteMask$default_impl_b7j7b4 as AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42,
  _AGColorMask___init__impl__j38ai8_0 as _AGColorMask___init__impl__j38ai828hvpfxybxjk7,
  _AGColorMask___init__impl__j38ai8_1 as _AGColorMask___init__impl__j38ai819ejt5rq8iy6o,
  AGColorMask__hashCode_impl_g9082f as AGColorMask__hashCode_impl_g9082fge542b8j3bn5,
  AGColorMask__toString_impl_5i5oqg as AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a,
  AGCompareMode__inverted_impl_7xxk8m as AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy,
  AGCullFace__hashCode_impl_t4e5ur as AGCullFace__hashCode_impl_t4e5urey2md6modztx,
  AGCullFace__toString_impl_7d891w as AGCullFace__toString_impl_7d891w3d9dwll45l9u7,
  AGDrawType__hashCode_impl_ylaury as AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2,
  AGDrawType__toString_impl_eonaeb as AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw,
  AGStencilOpFunc__hashCode_impl_nopebb as AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s,
  AGStencilOpFunc__toString_impl_pl8quy as AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0,
  AGStencilOpFunc__withEnabled_impl_mpcwmr as AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4,
  AGStencilReference__hashCode_impl_52zufx as AGStencilReference__hashCode_impl_52zufx32vlakxm4newn,
  AGStencilReference__toString_impl_qu5r8s as AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx,
  Companion_instance_11 as Companion_instance99w5lpdgjzr4,
  Companion_getInstance_26 as Companion_getInstance18y91gyxi2z7,
  Companion_getInstance_32 as Companion_getInstanceok0yphc67vv6,
  Companion_instance_25 as Companion_instancekcgdgz2aik3h,
  Companion_getInstance_25 as Companion_getInstance2ckr5i14ndxro,
  Companion_getInstance_23 as Companion_getInstance1wltq3fgn1avz,
  Companion_getInstance_24 as Companion_getInstancekjblelnta22u,
  Companion_instance_8 as Companion_instance2ovjg7lp6gfg7,
  Companion_instance_16 as Companion_instance12t49ingjwxzt,
  Companion_instance_9 as Companion_instance3i2v9jzzqvdkl,
  Companion_instance_10 as Companion_instancef7estul0zruo,
  Companion_getInstance_28 as Companion_getInstance6ryfwvwg9trm,
  Companion_getInstance_63 as Companion_getInstance31h96uhdj5cc,
  Companion_instance_53 as Companion_instance31en7fj48z7ti,
  Companion_getInstance_47 as Companion_getInstance29a9zmyrrw3c9,
  Companion_getInstance_56 as Companion_getInstancei2plsq4vst79,
  Companion_getInstance_49 as Companion_getInstance14dcva8uz4sb6,
  Companion_getInstance_40 as Companion_getInstanceae40js4gnuwg,
  Companion_getInstance_43 as Companion_getInstance23l94gq35u9ye,
  Companion_getInstance_55 as Companion_getInstance203qp9xyfv543,
  Companion_getInstance_46 as Companion_getInstance2cx7brx0y6bm1,
  Companion_getInstance_45 as Companion_getInstance3dym1csqm206y,
  ProjViewUB_getInstance as ProjViewUB_getInstance2c14wyrj73xek,
  DefaultShaders_getInstance as DefaultShaders_getInstance2nkm3g7twu3qg,
  Companion_getInstance_67 as Companion_getInstance1ifu77pbb1si2,
  DefaultViewport_getInstance as DefaultViewport_getInstance3ta8638tkh0q1,
  Companion_getInstance_70 as Companion_getInstance1dp345vz250gb,
  SDFShaders_getInstance as SDFShaders_getInstance2aqc6fv2u457r,
  Companion_getInstance_72 as Companion_getInstance2vwksse73neff,
  KorgeReload_getInstance as KorgeReload_getInstance1jsrcs9uzp4z9,
  Companion_instance_60 as Companion_instance7uo85wjiqj61,
  Companion_instance_70 as Companion_instanceyamrbth4pjfq,
  CoroutineKey_getInstance as CoroutineKey_getInstance2jikmq30sknr8,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  AGPrint as AGPrint2do8iynklt71b,
  Attribute as Attribute3obvnbxr5w4xd,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  If as If1av5krmfyt44s,
  ProgramLayout as ProgramLayout373hh4xkth3qt,
  Program as Program1hnygp9hph4ry,
  UniformBlockBuffer as UniformBlockBuffer2p2oao2ic417b,
  UniformBlock as UniformBlock2qoqszhm3r9i2,
  Varying as Varying105nnu9x9j75f,
  VertexShader as VertexShader26kcg39ndf3s1,
  AGBatch as AGBatch2bse24318tbhc,
  AGColorMask as AGColorMaskwqd86t1dhpnk,
  AGCullFace as AGCullFaceff7di2v9k2ne,
  AGDrawType as AGDrawType11vxw4gf0yugk,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AGStencilOpFunc as AGStencilOpFunc1juigl5mvjr07,
  AGStencilReference as AGStencilReference8at184sv64zi,
  AGTextureUnits as AGTextureUnits3k80ikbk5qbv9,
  AGVertexArrayObject as AGVertexArrayObjectp6l6cor3jhq8,
  AGVertexData as AGVertexDatawn78bdwnwjab,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  applyMatrixBounds as applyMatrixBounds3j13fpymjibm6,
  draw_1 as draw3n7i8s75fp58g,
  plus_5 as plus3tmekjwnqrsa6,
  toAGScissor as toAGScissor50oxbqy8vpfx,
  drawText as drawText2ld6eqw3mc9xd,
  Input as Input3ljaq07eyi73v,
  AgCachedBuffer as AgCachedBuffer8k1i505isl6b,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TextureBase as TextureBase31xvoisoo1pp7,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture as Texture2obedkmljq67n,
  Texture_1 as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  Stats as Statslnkcsgem8jjl,
  V2 as V22su20mpwty0v0,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  configure as configure1a7py4k2lj4vi,
};
//endregion
